(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 95382:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isDesktop = exports.getCommonEventProperties = void 0;
exports.waitForAnalyticsLoad = waitForAnalyticsLoad;
exports.initAckoAnalytics = initAckoAnalytics;
exports.pageEvent = pageEvent;
exports.trackEvent = trackEvent;
exports.identifyEvent = identifyEvent;
const js_cookie_1 = __importDefault(__webpack_require__(10646));
const utils_1 = __webpack_require__(82684);
let write_key = '';
let anonymousId = '';
let requestURL = '/external/api/v2/send';
let dataLayerEventsList = [];
const getCommonEventProperties = (pageType = '') => {
    var _a, _b;
    let props = { page_type: pageType };
    if (typeof window != 'undefined') {
        const queryParams = new URLSearchParams(`?${(_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) === null || _b === void 0 ? void 0 : _b.split('?')[1]}`);
        props['page'] = window.location.href;
        props['path'] = window.location.pathname;
        props['source'] = document.referrer || '';
        props['referrer'] = document.referrer || '';
        props['platform'] = (0, exports.isDesktop)()
            ? 'web'
            : js_cookie_1.default.get('webview')
                ? 'app'
                : 'mweb';
        props['utm_source'] = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.get('utm_source')) || '';
        props['utm_campaign'] = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.get('utm_campaign')) || '';
        props['utm_content'] = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.get('utm_content')) || '';
        props['utm_medium'] = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.get('utm_medium')) || '';
        props['url'] = window.location.href;
        props['title'] = document.title;
        props['search'] = window.location.search;
    }
    return props;
};
exports.getCommonEventProperties = getCommonEventProperties;
const isDesktop = () => {
    var _a;
    const res = typeof window !== 'undefined'
        ? (_a = window.matchMedia('(min-width: 1024px)')) === null || _a === void 0 ? void 0 : _a.matches
        : false;
    return res;
};
exports.isDesktop = isDesktop;
function waitForAnalyticsLoad() {
    return new Promise((resolve) => {
        resolve(void 0);
    });
}
function initAckoAnalytics(id, apiKey, cdpApiEndPoint = '/external/api/v2/send') {
    write_key = apiKey;
    anonymousId = id;
    requestURL = cdpApiEndPoint;
    return `window.acko_analytics={
    write_key:"${write_key}",
    anonymousId:"${anonymousId}"
  }`;
}
function pageEvent(eventName, properties, custom_write_key = null) {
    var _a, _b;
    const commonProps = (0, exports.getCommonEventProperties)();
    if (dataLayerEventsList.length === 0) {
        fetch('https://acko-cms.ackoassets.com/data_layer_events_list_seo_a0629b56ba.json')
            .then(response => response.json())
            .then(data => {
            dataLayerEventsList = data === null || data === void 0 ? void 0 : data.dataLayerEvents;
            (0, utils_1.pushEventsToDataLayer)(dataLayerEventsList, eventName, commonProps, properties);
        })
            .catch(error => {
            console.error('Error fetching dataLayer events list:', error);
        });
    }
    else {
        (0, utils_1.pushEventsToDataLayer)(dataLayerEventsList, eventName, commonProps, properties);
    }
    return fetch(requestURL, {
        headers: {
            //@ts-ignore
            'x-write-key': custom_write_key
                ? custom_write_key
                : write_key || ((_a = window === null || window === void 0 ? void 0 : window.acko_analytics) === null || _a === void 0 ? void 0 : _a.write_key),
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
            event_type: 'page',
            event_name: eventName,
            event_properties: Object.assign(Object.assign({}, commonProps), properties),
            //@ts-ignore
            anonymous_id: anonymousId || ((_b = window === null || window === void 0 ? void 0 : window.acko_analytics) === null || _b === void 0 ? void 0 : _b.anonymousId),
        }),
        credentials: 'include',
    })
        .then((res) => {
        return res.json();
    })
        .then((data) => {
        console.log(data);
    })
        .catch((err) => {
        console.error('There was a problem with the CDP API fetch operation:', err);
    });
}
function trackEvent(eventName, properties, custom_write_key = null) {
    var _a, _b;
    const commonProps = (0, exports.getCommonEventProperties)();
    if (dataLayerEventsList.length === 0) {
        fetch('https://acko-cms.ackoassets.com/data_layer_events_list_seo_a0629b56ba.json')
            .then(response => response.json())
            .then(data => {
            dataLayerEventsList = data === null || data === void 0 ? void 0 : data.dataLayerEvents;
            (0, utils_1.pushEventsToDataLayer)(dataLayerEventsList, eventName, commonProps, properties);
        })
            .catch(error => {
            console.error('Error fetching dataLayer events list:', error);
        });
    }
    else {
        (0, utils_1.pushEventsToDataLayer)(dataLayerEventsList, eventName, commonProps, properties);
    }
    return fetch(requestURL, {
        headers: {
            //@ts-ignore
            'x-write-key': custom_write_key
                ? custom_write_key
                : write_key || ((_a = window === null || window === void 0 ? void 0 : window.acko_analytics) === null || _a === void 0 ? void 0 : _a.write_key),
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
            event_type: 'track',
            event_name: eventName,
            event_properties: Object.assign(Object.assign({}, commonProps), properties),
            //@ts-ignore
            anonymous_id: anonymousId || ((_b = window === null || window === void 0 ? void 0 : window.acko_analytics) === null || _b === void 0 ? void 0 : _b.anonymousId),
        }),
        credentials: 'include',
    })
        .then((res) => {
        return res.json();
    })
        .then((data) => {
        console.log(data);
    })
        .catch((err) => {
        console.error('There was a problem with the CDP API fetch operation:', err);
    });
}
function identifyEvent(properties, custom_write_key = null) {
    var _a, _b;
    return fetch(requestURL, {
        headers: {
            //@ts-ignore
            'x-write-key': custom_write_key
                ? custom_write_key
                : write_key || ((_a = window === null || window === void 0 ? void 0 : window.acko_analytics) === null || _a === void 0 ? void 0 : _a.write_key),
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
            event_type: 'identify',
            event_properties: properties,
            //@ts-ignore
            anonymous_id: anonymousId || ((_b = window === null || window === void 0 ? void 0 : window.acko_analytics) === null || _b === void 0 ? void 0 : _b.anonymousId),
        }),
        credentials: 'include',
    })
        .then((res) => {
        return res.json();
    })
        .then((data) => {
        console.log(data);
    })
        .catch((err) => {
        console.error('There was a problem with the CDP API fetch operation:', err);
    });
}
//# sourceMappingURL=acko-analytics.js.map

/***/ }),

/***/ 94262:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(95382), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 82684:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pushEventsToDataLayer = void 0;
const pushEventsToDataLayer = (dataLayerEventsList, eventName, commonProps, properties) => {
    dataLayerEventsList =
        dataLayerEventsList.length === 0
            ? [
                'tap_btn_newbike_get_quote',
                'tap_btn_newcar_get_quote',
                'tap_btn_get_quote',
                'view_seo_page',
                'tap_btn_CTA_widget',
                'phone_number_entered',
                'otp_entered',
                'tap_btn_acko_app',
                'view_page',
            ]
            : dataLayerEventsList;
    if (dataLayerEventsList.includes(eventName)) {
        // @ts-ignore
        if (window && (window === null || window === void 0 ? void 0 : window.dataLayer) !== undefined) {
            // @ts-ignore
            window === null || window === void 0 ? void 0 : window.dataLayer = (window === null || window === void 0 ? void 0 : window.dataLayer) || [];
            // @ts-ignore
            window === null || window === void 0 ? void 0 : window.dataLayer.push(Object.assign(Object.assign({ event: eventName }, commonProps), properties));
        }
    }
};
exports.pushEventsToDataLayer = pushEventsToDataLayer;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 79749:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styled = void 0;
__exportStar(__webpack_require__(4694), exports);
__exportStar(__webpack_require__(99325), exports);
__exportStar(__webpack_require__(53711), exports);
var styled_components_1 = __webpack_require__(4694);
Object.defineProperty(exports, "styled", ({ enumerable: true, get: function () { return __importDefault(styled_components_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4694:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ServerStyleSheet = exports.styledComponents = exports.ThemeProvider = exports.keyframes = exports.createGlobalStyle = exports.css = void 0;
//@ts-nocheck
const styledComponents = __importStar(__webpack_require__(10063));
exports.styledComponents = styledComponents;
const { default: styled, css, createGlobalStyle, keyframes, ThemeProvider, ServerStyleSheet, } = styledComponents;
exports.css = css;
exports.createGlobalStyle = createGlobalStyle;
exports.keyframes = keyframes;
exports.ThemeProvider = ThemeProvider;
exports.ServerStyleSheet = ServerStyleSheet;
const Styled = styled;
exports["default"] = Styled;
//# sourceMappingURL=styled-components.js.map

/***/ }),

/***/ 99325:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/**
<<<<<<< HEAD
* ======================
* Break Points
* ======================
*/
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.$fontWeightBolder = exports.$fontWeightBold = exports.$fontWeightNormal = exports.$fontWeightLight = exports.$primaryColorsGreen = exports.$fontSize = exports.$space = exports.$blackShades = exports.$greyShades = exports.$greenShades = exports.$backgroundColor = exports.$white = exports.$grayLighter = exports.$grayLight = exports.$hyperlink = exports.$error = exports.$info = exports.$warning = exports.$neutralColors = exports.$accentColors = exports.$primaryColors = exports.$containerXsL = exports.$screenL = exports.$screenXsL = exports.$screenXs = exports.$containerXs = exports.$gutter = void 0;
exports.$gutter = 16;
exports.$containerXs = '28.125em';
exports.$screenXs = '30em';
exports.$screenXsL = '40em';
exports.$screenL = '48em';
exports.$containerXsL = '38.125em';
/**
 * ==========
 * Colors
 * ==========
 */
exports.$primaryColors = {
    lightest: '#DDD4F8',
    light: '#9174E7',
    normal: '#582CDB',
    dark: '#421EAE',
};
exports.$accentColors = {
    lightest: '#D4F7E6',
    light: '#7EE7B4',
    normal: '#44CB86',
    dark: '#1FAD69',
};
exports.$neutralColors = {
    lightest: '#DCDCE0',
    light: '#8D8E99',
    normal: '#5C5D66',
    dark: '#151619',
};
exports.$warning = '#FF9100';
exports.$info = '#697890';
exports.$error = '#FD4B44';
exports.$hyperlink = '#3C8CEA';
exports.$grayLight = '#F3F3F7';
exports.$grayLighter = '#F3F7FF';
exports.$white = '#FFFFFF';
exports.$backgroundColor = exports.$grayLight;
exports.$greenShades = {
    normal: '#37C87E',
    dark: '#00A871',
};
exports.$greyShades = {
    normal: '#C8D0DB',
};
exports.$blackShades = {
    normal: '#434F5A',
    dark: '#282E33',
};
/**
 * ==========
 * Spacing
 * ==========
 */
exports.$space = {
    xs: '0.5em',
    s: '1em',
    sm: '1.5em',
    m: '2em',
    l: '3em',
    xl: '4em',
    xxl: '6em',
};
/**
 * ==========
 * font
 * ==========
 */
exports.$fontSize = {
    xxxs: '0.625rem', // 10px
    xxs: '0.75rem', // 12px
    xs: '0.875rem', // 14px
    normal: '1rem', // 16px
    small: '1.125rem', // 18px
    medium: '1.25rem', // 20px
    large: '1.5rem', // 24px
    xl: '1.875rem', // 30px
    xxl: '2.375rem', // 38px
    xxxl: '2.875rem', // 46px
};
exports.$primaryColorsGreen = {
    disabled: '#E5E5E5',
    lightest: '#f2faf7',
    light: '#0FA457',
    normal: '#0FA457',
    dark: '#149452',
};
/**
 * ==========
 * Font weights
 * ==========
 */
exports.$fontWeightLight = 400;
exports.$fontWeightNormal = 500;
exports.$fontWeightBold = 600;
exports.$fontWeightBolder = 700;
exports["default"] = {};
//# sourceMappingURL=theme.js.map

/***/ }),

/***/ 53711:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Flex = exports.Box = void 0;
const styled_components_1 = __importDefault(__webpack_require__(10063));
exports.Box = styled_components_1.default.div `
  width: ${props => (props.width ? props.width : "100%")};
  ${props => props.justifyContent ? `justify-content: ${props.justifyContent}` : ""};
  ${props => (props.alignItems ? `align-items: ${props.alignItems}` : "")};
  ${props => (props.textAlign ? `text-align: ${props.textAlign}` : "")};
  ${props => (props.margin ? `margin: ${props.margin}` : "")};
  ${props => (props.padding ? `padding: ${props.padding}` : "")};
  ${props => (props.mt ? `margin-top: ${props.mt}` : "")};
  ${props => (props.mr ? `margin-right: ${props.mr}` : "")};
  ${props => (props.mb ? `margin-bottom: ${props.mb}` : "")};
  ${props => (props.ml ? `margin-left: ${props.ml}` : "")};
  ${props => (props.pt ? `padding-top: ${props.pt}` : "")};
  ${props => (props.pb ? `padding-bottom: ${props.pb}` : "")};
  ${props => (props.pl ? `padding-left: ${props.pl}` : "")};
  ${props => (props.pr ? `padding-right: ${props.pr}` : "")};
  ${props => (props.overflow ? `overflow: ${props.overflow}` : "")};
  ${props => props.styles};
`;
exports.Flex = (0, styled_components_1.default)(exports.Box) `
  display: flex;
  ${props => props.flexDirection ? `flex-direction: ${props.flexDirection}` : ""};
  ${props => props.styles};
`;
exports["default"] = {};
//# sourceMappingURL=util.js.map

/***/ }),

/***/ 66010:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTheme = exports.useColor = exports.ThemeConsumer = exports.ThemeContext = void 0;
exports["default"] = ThemeProvider;
const react_1 = __importStar(__webpack_require__(11720));
const styled_components_1 = __webpack_require__(10063);
const Acko_1 = __webpack_require__(27113);
exports.ThemeContext = react_1.default.createContext({ currentMode: 'light' });
exports.ThemeConsumer = exports.ThemeContext.Consumer;
const useColor = () => {
    const { currentMode, theme } = (0, react_1.useContext)(exports.ThemeContext);
    let localTheme = theme;
    if (!localTheme) {
        localTheme = Acko_1.AckoMainTheme;
    }
    return localTheme.colors[currentMode];
};
exports.useColor = useColor;
const useTheme = () => {
    return (0, react_1.useContext)(exports.ThemeContext);
};
exports.useTheme = useTheme;
function ThemeProvider({ theme: propsTheme, mode, children }) {
    const parentThemeContext = (0, react_1.useContext)(exports.ThemeContext);
    // Todo: Replace with deepmerge
    const theme = (0, react_1.useMemo)(() => {
        if (parentThemeContext)
            return Object.assign(parentThemeContext, propsTheme);
        return propsTheme;
    }, [propsTheme, parentThemeContext]);
    if (!children) {
        return null;
    }
    const GlobalFonts = (0, styled_components_1.createGlobalStyle) `
      ${theme.typography.fonts.family.face};
  `;
    return (react_1.default.createElement(exports.ThemeContext.Provider, { value: { theme, currentMode: mode || theme.defaultMode } },
        react_1.default.createElement(GlobalFonts, null),
        children));
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 549:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThemeProvider = exports.useTheme = exports.ThemeConsumer = exports.ThemeContext = exports.useColor = exports.AckoMainTheme = void 0;
var Acko_1 = __webpack_require__(27113);
Object.defineProperty(exports, "AckoMainTheme", ({ enumerable: true, get: function () { return Acko_1.AckoMainTheme; } }));
var ThemeProviders_1 = __webpack_require__(66010);
Object.defineProperty(exports, "useColor", ({ enumerable: true, get: function () { return ThemeProviders_1.useColor; } }));
Object.defineProperty(exports, "ThemeContext", ({ enumerable: true, get: function () { return ThemeProviders_1.ThemeContext; } }));
Object.defineProperty(exports, "ThemeConsumer", ({ enumerable: true, get: function () { return ThemeProviders_1.ThemeConsumer; } }));
Object.defineProperty(exports, "useTheme", ({ enumerable: true, get: function () { return ThemeProviders_1.useTheme; } }));
var ThemeProviders_2 = __webpack_require__(66010);
Object.defineProperty(exports, "ThemeProvider", ({ enumerable: true, get: function () { return __importDefault(ThemeProviders_2).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 33288:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const border = {
    radius: {
        none: '0px',
        small: '2px',
        medium: '4px',
        large: '8px',
        xLarge: '12px',
        xxLarge: '16px',
        xxxLarge: '20px',
        max: '24px',
        xMax: '999px',
        round: '50%',
    },
    width: {
        none: '0px',
        thin: '1px',
    },
};
exports["default"] = border;
//# sourceMappingURL=border.js.map

/***/ }),

/***/ 27516:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const breakpoints = {
    xs: 320,
    s: 480,
    m: 768,
    l: 1024,
    xl: 1200,
    max: 1201,
};
exports["default"] = breakpoints;
//# sourceMappingURL=breakpoints.js.map

/***/ }),

/***/ 9670:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const colors = {
    light: {
        green: {
            g50: '#EBFBEE',
            g100: '#C1F5C8',
            g200: '#8CE99A',
            g300: '#0FA457',
            g400: '#0B753E',
            g500: '#064625',
        },
        neutral: {
            n50: '#F8F7FC',
            n100: '#F0F0F6',
            n200: '#E7E7F0',
            n300: '#E0E0E8',
            n400: '#5B5675',
            n500: '#36354C',
        },
        red: {
            r50: '#FBEAEA',
            r100: '#F3C0BE',
            r200: '#F07975',
            r300: '#E05752',
            r400: '#D83D37',
            r500: '#95221D',
        },
        yellow: {
            y50: '#FFF7E5',
            y100: '#FFE380',
            y200: '#FFC400',
            y300: '#FFAB00',
            y400: '#F58700',
            y500: '#D16900',
        },
        blue: {
            b50: '#E2F5FF',
            b100: '#A9DDFE',
            b200: '#4EA3F9',
            b300: '#1B73E8',
            b400: '#104EA3',
            b500: '#0B3874',
        },
        purple: {
            p50: '#EFE9FB',
            p100: '#D0BDF4',
            p200: '#B191ED',
            p300: '#7C47E1',
            p400: '#5920C5',
            p500: '#451999',
        },
        maroon: {
            m50: '#FBE9F6',
            m100: '#FCC2D7',
            m200: '#F783AC',
            m300: '#E64980',
            m400: '#C2255C',
            m500: '#76003D',
        },
        cyan: {
            c50: '#E3FAFC',
            c100: '#B9F4F9',
            c200: '#66D9E8',
            c300: '#1DB6CD',
            c400: '#0895AA',
            c500: '#086A7D',
        },
        primary: {
            g300: '#0FA457',
            n600: '#040222',
            n0: '#FFFFFF',
        },
        secondary: {
            p300: '#7C47E1',
            cg_red: '#D83D37',
            y300: '#FFAB00',
            b300: '#1B73E8',
            m400: '#C2255C',
            c300: '#1DB6CD',
        },
    },
};
exports["default"] = colors;
//# sourceMappingURL=colors.js.map

/***/ }),

/***/ 9878:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fontWeights = exports.lineHeights = exports.fontSizes = exports.fontFamily = void 0;
exports.fontFamily = {
    family: "'Euclid Circular B', 'Inter', sans-serif",
    face: `@font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        src: url(https://fonts.gstatic.com/s/inter/v11/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZ9hjp-Ek-_EeA.woff) format('woff');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }`,
};
exports.fontSizes = {
    C1: '12px',
    P2: '14px',
    P2_L: '14px',
    P1: '16px',
    T4_SB: '14px',
    T4_M: '14px',
    T3: '16px',
    T2: '18px',
    T1: '22px',
    H4: '18px',
    H3: '22px',
    H2: '26px',
    H1: '34px',
};
exports.lineHeights = {
    C1: '16px',
    P2: '20px',
    P2_L: '20px',
    P1: '22px',
    T4_SB: '20px',
    T4_M: '20px',
    T3: '22px',
    T2: '24px',
    T1: '32px',
    H4: '24px',
    H3: '32px',
    H2: '36px',
    H1: '44px',
};
exports.fontWeights = {
    P2_L: '300',
    C1: '400',
    P2: '400',
    P1: '400',
    T4_M: '500',
    T4_SB: '600',
    T3: '600',
    T2: '600',
    T1: '600',
    H4: '700',
    H3: '700',
    H2: '700',
    H1: '700',
};
//# sourceMappingURL=font.js.map

/***/ }),

/***/ 27113:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AckoMainTheme = void 0;
const border_1 = __importDefault(__webpack_require__(33288));
const typography_1 = __importDefault(__webpack_require__(64193));
const breakpoints_1 = __importDefault(__webpack_require__(27516));
const spacing_1 = __importDefault(__webpack_require__(29331));
const colors_1 = __importDefault(__webpack_require__(9670));
exports.AckoMainTheme = {
    defaultMode: 'light',
    border: border_1.default,
    breakpoints: breakpoints_1.default,
    colors: colors_1.default,
    spacing: spacing_1.default,
    typography: typography_1.default
};
exports["default"] = exports.AckoMainTheme;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29331:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const spacing = {
    0: '0px',
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    7: '32px',
    8: '40px',
    9: '48px',
    10: '56px',
};
exports["default"] = spacing;
//# sourceMappingURL=spacing.js.map

/***/ }),

/***/ 64193:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const font_1 = __webpack_require__(9878);
const typography = {
    fonts: {
        family: font_1.fontFamily,
        size: font_1.fontSizes,
        weight: font_1.fontWeights
    },
    lineHeights: font_1.lineHeights
};
exports["default"] = typography;
//# sourceMappingURL=typography.js.map

/***/ }),

/***/ 81361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gr": function() { return /* reexport */ GrowthBook_GrowthBook; },
  "Ny": function() { return /* binding */ GrowthBookProvider; },
  "aS": function() { return /* binding */ useFeatureValue; }
});

// UNUSED EXPORTS: FeatureString, FeaturesReady, GrowthBookContext, IfFeatureEnabled, clearCache, configureCache, getGrowthBookSSRData, setPolyfills, useExperiment, useFeature, useFeatureIsOn, useGrowthBook, useGrowthBookSSR, withRunExperiment

;// CONCATENATED MODULE: ./node_modules/dom-mutator/dist/dom-mutator.esm.js
var validAttributeName = /^[a-zA-Z:_][a-zA-Z0-9:_.-]*$/;
var nullController = {
  revert: function revert() {}
};
var dom_mutator_esm_elements = /*#__PURE__*/new Map();
var mutations = /*#__PURE__*/new Set();

function getObserverInit(attr) {
  return attr === 'html' ? {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true
  } : {
    childList: false,
    subtree: false,
    attributes: true,
    attributeFilter: [attr]
  };
}

function getElementRecord(element) {
  var record = dom_mutator_esm_elements.get(element);

  if (!record) {
    record = {
      element: element,
      attributes: {}
    };
    dom_mutator_esm_elements.set(element, record);
  }

  return record;
}

function createElementPropertyRecord(el, attr, getCurrentValue, setValue, mutationRunner) {
  var currentValue = getCurrentValue(el);
  var record = {
    isDirty: false,
    originalValue: currentValue,
    virtualValue: currentValue,
    mutations: [],
    el: el,
    observer: new MutationObserver(function () {
      var currentValue = getCurrentValue(el);
      if (currentValue === record.virtualValue) return;
      record.originalValue = currentValue;
      mutationRunner(record);
    }),
    mutationRunner: mutationRunner,
    setValue: setValue,
    getCurrentValue: getCurrentValue
  };
  record.observer.observe(el, getObserverInit(attr));
  return record;
}

function queueIfNeeded(val, record) {
  var currentVal = record.getCurrentValue(record.el);
  record.virtualValue = val;

  if (val && typeof val !== 'string') {
    if (!currentVal || val.parentNode !== currentVal.parentNode || val.insertBeforeNode !== currentVal.insertBeforeNode) {
      record.isDirty = true;
      queueDOMUpdates();
    }
  } else if (val !== currentVal) {
    record.isDirty = true;
    queueDOMUpdates();
  }
}

function htmlMutationRunner(record) {
  var val = record.originalValue;
  record.mutations.forEach(function (m) {
    return val = m.mutate(val);
  });
  queueIfNeeded(getTransformedHTML(val), record);
}

function classMutationRunner(record) {
  var val = new Set(record.originalValue.split(/\s+/).filter(Boolean));
  record.mutations.forEach(function (m) {
    return m.mutate(val);
  });
  queueIfNeeded(Array.from(val).filter(Boolean).join(' '), record);
}

function attrMutationRunner(record) {
  var val = record.originalValue;
  record.mutations.forEach(function (m) {
    return val = m.mutate(val);
  });
  queueIfNeeded(val, record);
}

function _loadDOMNodes(_ref) {
  var parentSelector = _ref.parentSelector,
      insertBeforeSelector = _ref.insertBeforeSelector;
  var parentNode = document.querySelector(parentSelector);
  if (!parentNode) return null;
  var insertBeforeNode = insertBeforeSelector ? document.querySelector(insertBeforeSelector) : null;
  if (insertBeforeSelector && !insertBeforeNode) return null;
  return {
    parentNode: parentNode,
    insertBeforeNode: insertBeforeNode
  };
}

function positionMutationRunner(record) {
  var val = record.originalValue;
  record.mutations.forEach(function (m) {
    var selectors = m.mutate();

    var newNodes = _loadDOMNodes(selectors);

    val = newNodes || val;
  });
  queueIfNeeded(val, record);
}

var getHTMLValue = function getHTMLValue(el) {
  return el.innerHTML;
};

var setHTMLValue = function setHTMLValue(el, value) {
  return el.innerHTML = value;
};

function getElementHTMLRecord(element) {
  var elementRecord = getElementRecord(element);

  if (!elementRecord.html) {
    elementRecord.html = createElementPropertyRecord(element, 'html', getHTMLValue, setHTMLValue, htmlMutationRunner);
  }

  return elementRecord.html;
}

var getElementPosition = function getElementPosition(el) {
  return {
    parentNode: el.parentElement,
    insertBeforeNode: el.nextElementSibling
  };
};

var setElementPosition = function setElementPosition(el, value) {
  value.parentNode.insertBefore(el, value.insertBeforeNode);
};

function getElementPositionRecord(element) {
  var elementRecord = getElementRecord(element);

  if (!elementRecord.position) {
    elementRecord.position = createElementPropertyRecord(element, 'position', getElementPosition, setElementPosition, positionMutationRunner);
  }

  return elementRecord.position;
}

var setClassValue = function setClassValue(el, val) {
  return val ? el.className = val : el.removeAttribute('class');
};

var getClassValue = function getClassValue(el) {
  return el.className;
};

function getElementClassRecord(el) {
  var elementRecord = getElementRecord(el);

  if (!elementRecord.classes) {
    elementRecord.classes = createElementPropertyRecord(el, 'class', getClassValue, setClassValue, classMutationRunner);
  }

  return elementRecord.classes;
}

var getAttrValue = function getAttrValue(attrName) {
  return function (el) {
    var _el$getAttribute;

    return (_el$getAttribute = el.getAttribute(attrName)) != null ? _el$getAttribute : null;
  };
};

var setAttrValue = function setAttrValue(attrName) {
  return function (el, val) {
    return val !== null ? el.setAttribute(attrName, val) : el.removeAttribute(attrName);
  };
};

function getElementAttributeRecord(el, attr) {
  var elementRecord = getElementRecord(el);

  if (!elementRecord.attributes[attr]) {
    elementRecord.attributes[attr] = createElementPropertyRecord(el, attr, getAttrValue(attr), setAttrValue(attr), attrMutationRunner);
  }

  return elementRecord.attributes[attr];
}

function deleteElementPropertyRecord(el, attr) {
  var element = dom_mutator_esm_elements.get(el);
  if (!element) return;

  if (attr === 'html') {
    var _element$html, _element$html$observe;

    (_element$html = element.html) == null ? void 0 : (_element$html$observe = _element$html.observer) == null ? void 0 : _element$html$observe.disconnect();
    delete element.html;
  } else if (attr === 'class') {
    var _element$classes, _element$classes$obse;

    (_element$classes = element.classes) == null ? void 0 : (_element$classes$obse = _element$classes.observer) == null ? void 0 : _element$classes$obse.disconnect();
    delete element.classes;
  } else if (attr === 'position') {
    var _element$position, _element$position$obs;

    (_element$position = element.position) == null ? void 0 : (_element$position$obs = _element$position.observer) == null ? void 0 : _element$position$obs.disconnect();
    delete element.position;
  } else {
    var _element$attributes, _element$attributes$a, _element$attributes$a2;

    (_element$attributes = element.attributes) == null ? void 0 : (_element$attributes$a = _element$attributes[attr]) == null ? void 0 : (_element$attributes$a2 = _element$attributes$a.observer) == null ? void 0 : _element$attributes$a2.disconnect();
    delete element.attributes[attr];
  }
}

var transformContainer;

function getTransformedHTML(html) {
  if (!transformContainer) {
    transformContainer = document.createElement('div');
  }

  transformContainer.innerHTML = html;
  return transformContainer.innerHTML;
}

function setPropertyValue(el, attr, m) {
  if (!m.isDirty) return;
  m.isDirty = false;
  var val = m.virtualValue;

  if (!m.mutations.length) {
    deleteElementPropertyRecord(el, attr);
  }

  m.setValue(el, val);
}

var raf = false;

function setValue(m, el) {
  m.html && setPropertyValue(el, 'html', m.html);
  m.classes && setPropertyValue(el, 'class', m.classes);
  m.position && setPropertyValue(el, 'position', m.position);
  Object.keys(m.attributes).forEach(function (attr) {
    setPropertyValue(el, attr, m.attributes[attr]);
  });
}

function setValues() {
  raf = false;
  dom_mutator_esm_elements.forEach(setValue);
}

function queueDOMUpdates() {
  if (!raf) {
    raf = true;
    requestAnimationFrame(setValues);
  }
} // find or create ElementPropertyRecord, add mutation to it, then run


function startMutating(mutation, element) {
  var record = null;

  if (mutation.kind === 'html') {
    record = getElementHTMLRecord(element);
  } else if (mutation.kind === 'class') {
    record = getElementClassRecord(element);
  } else if (mutation.kind === 'attribute') {
    record = getElementAttributeRecord(element, mutation.attribute);
  } else if (mutation.kind === 'position') {
    record = getElementPositionRecord(element);
  }

  if (!record) return;
  record.mutations.push(mutation);
  record.mutationRunner(record);
} // get (existing) ElementPropertyRecord, remove mutation from it, then run


function stopMutating(mutation, el) {
  var record = null;

  if (mutation.kind === 'html') {
    record = getElementHTMLRecord(el);
  } else if (mutation.kind === 'class') {
    record = getElementClassRecord(el);
  } else if (mutation.kind === 'attribute') {
    record = getElementAttributeRecord(el, mutation.attribute);
  } else if (mutation.kind === 'position') {
    record = getElementPositionRecord(el);
  }

  if (!record) return;
  var index = record.mutations.indexOf(mutation);
  if (index !== -1) record.mutations.splice(index, 1);
  record.mutationRunner(record);
} // maintain list of elements associated with mutation


function refreshElementsSet(mutation) {
  var existingElements = new Set(mutation.elements);
  var newElements = new Set();
  var matchingElements = document.querySelectorAll(mutation.selector);
  matchingElements.forEach(function (el) {
    newElements.add(el);

    if (!existingElements.has(el)) {
      mutation.elements.add(el);
      startMutating(mutation, el);
    }
  });
  existingElements.forEach(function (el) {
    if (!newElements.has(el)) {
      mutation.elements["delete"](el);
      stopMutating(mutation, el);
    }
  });
}

function revertMutation(mutation) {
  mutation.elements.forEach(function (el) {
    return stopMutating(mutation, el);
  });
  mutation.elements.clear();
  mutations["delete"](mutation);
}

function refreshAllElementSets() {
  mutations.forEach(refreshElementsSet);
} // Observer for elements that don't exist in the DOM yet


var observer;
function disconnectGlobalObserver() {
  observer && observer.disconnect();
}
function connectGlobalObserver() {
  if (typeof document === 'undefined') return;

  if (!observer) {
    observer = new MutationObserver(function () {
      refreshAllElementSets();
    });
  }

  refreshAllElementSets();
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
  });
} // run on init

connectGlobalObserver();

function newMutation(m) {
  // Not in a browser
  if (typeof document === 'undefined') return nullController; // add to global index of mutations

  mutations.add(m); // run refresh on init to establish list of elements associated w/ mutation

  refreshElementsSet(m);
  return {
    revert: function revert() {
      revertMutation(m);
    }
  };
}

function html(selector, mutate) {
  return newMutation({
    kind: 'html',
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function position(selector, mutate) {
  return newMutation({
    kind: 'position',
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function classes(selector, mutate) {
  return newMutation({
    kind: 'class',
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function attribute(selector, attribute, mutate) {
  if (!validAttributeName.test(attribute)) return nullController;

  if (attribute === 'class' || attribute === 'className') {
    return classes(selector, function (classnames) {
      var mutatedClassnames = mutate(Array.from(classnames).join(' '));
      classnames.clear();
      if (!mutatedClassnames) return;
      mutatedClassnames.split(/\s+/g).filter(Boolean).forEach(function (c) {
        return classnames.add(c);
      });
    });
  }

  return newMutation({
    kind: 'attribute',
    attribute: attribute,
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function declarative(_ref2) {
  var selector = _ref2.selector,
      action = _ref2.action,
      value = _ref2.value,
      attr = _ref2.attribute,
      parentSelector = _ref2.parentSelector,
      insertBeforeSelector = _ref2.insertBeforeSelector;

  if (attr === 'html') {
    if (action === 'append') {
      return html(selector, function (val) {
        return val + (value != null ? value : '');
      });
    } else if (action === 'set') {
      return html(selector, function () {
        return value != null ? value : '';
      });
    }
  } else if (attr === 'class') {
    if (action === 'append') {
      return classes(selector, function (val) {
        if (value) val.add(value);
      });
    } else if (action === 'remove') {
      return classes(selector, function (val) {
        if (value) val["delete"](value);
      });
    } else if (action === 'set') {
      return classes(selector, function (val) {
        val.clear();
        if (value) val.add(value);
      });
    }
  } else if (attr === 'position') {
    if (action === 'set' && parentSelector) {
      return position(selector, function () {
        return {
          insertBeforeSelector: insertBeforeSelector,
          parentSelector: parentSelector
        };
      });
    }
  } else {
    if (action === 'append') {
      return attribute(selector, attr, function (val) {
        return val !== null ? val + (value != null ? value : '') : value != null ? value : '';
      });
    } else if (action === 'set') {
      return attribute(selector, attr, function () {
        return value != null ? value : '';
      });
    } else if (action === 'remove') {
      return attribute(selector, attr, function () {
        return null;
      });
    }
  }

  return nullController;
}

var index = {
  html: html,
  classes: classes,
  attribute: attribute,
  position: position,
  declarative: declarative
};

/* harmony default export */ var dom_mutator_esm = (index);

//# sourceMappingURL=dom-mutator.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook/dist/esm/util.js
function hashFnv32a(str) {
  let hval = 0x811c9dc5;
  const l = str.length;
  for (let i = 0; i < l; i++) {
    hval ^= str.charCodeAt(i);
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
  }
  return hval >>> 0;
}
function hash(seed, value, version) {
  // New unbiased hashing algorithm
  if (version === 2) {
    return hashFnv32a(hashFnv32a(seed + value) + "") % 10000 / 10000;
  }
  // Original biased hashing algorithm (keep for backwards compatibility)
  if (version === 1) {
    return hashFnv32a(value + seed) % 1000 / 1000;
  }

  // Unknown hash version
  return null;
}
function getEqualWeights(n) {
  if (n <= 0) return [];
  return new Array(n).fill(1 / n);
}
function inRange(n, range) {
  return n >= range[0] && n < range[1];
}
function inNamespace(hashValue, namespace) {
  const n = hash("__" + namespace[0], hashValue, 1);
  if (n === null) return false;
  return n >= namespace[1] && n < namespace[2];
}
function chooseVariation(n, ranges) {
  for (let i = 0; i < ranges.length; i++) {
    if (inRange(n, ranges[i])) {
      return i;
    }
  }
  return -1;
}
function getUrlRegExp(regexString) {
  try {
    const escaped = regexString.replace(/([^\\])\//g, "$1\\/");
    return new RegExp(escaped);
  } catch (e) {
    console.error(e);
    return undefined;
  }
}
function isURLTargeted(url, targets) {
  if (!targets.length) return false;
  let hasIncludeRules = false;
  let isIncluded = false;
  for (let i = 0; i < targets.length; i++) {
    const match = _evalURLTarget(url, targets[i].type, targets[i].pattern);
    if (targets[i].include === false) {
      if (match) return false;
    } else {
      hasIncludeRules = true;
      if (match) isIncluded = true;
    }
  }
  return isIncluded || !hasIncludeRules;
}
function _evalSimpleUrlPart(actual, pattern, isPath) {
  try {
    // Escape special regex characters and change wildcard `_____` to `.*`
    let escaped = pattern.replace(/[*.+?^${}()|[\]\\]/g, "\\$&").replace(/_____/g, ".*");
    if (isPath) {
      // When matching pathname, make leading/trailing slashes optional
      escaped = "\\/?" + escaped.replace(/(^\/|\/$)/g, "") + "\\/?";
    }
    const regex = new RegExp("^" + escaped + "$", "i");
    return regex.test(actual);
  } catch (e) {
    return false;
  }
}
function _evalSimpleUrlTarget(actual, pattern) {
  try {
    // If a protocol is missing, but a host is specified, add `https://` to the front
    // Use "_____" as the wildcard since `*` is not a valid hostname in some browsers
    const expected = new URL(pattern.replace(/^([^:/?]*)\./i, "https://$1.").replace(/\*/g, "_____"), "https://_____");

    // Compare each part of the URL separately
    const comps = [[actual.host, expected.host, false], [actual.pathname, expected.pathname, true]];
    // We only want to compare hashes if it's explicitly being targeted
    if (expected.hash) {
      comps.push([actual.hash, expected.hash, false]);
    }
    expected.searchParams.forEach((v, k) => {
      comps.push([actual.searchParams.get(k) || "", v, false]);
    });

    // If any comparisons fail, the whole thing fails
    return !comps.some(data => !_evalSimpleUrlPart(data[0], data[1], data[2]));
  } catch (e) {
    return false;
  }
}
function _evalURLTarget(url, type, pattern) {
  try {
    const parsed = new URL(url, "https://_");
    if (type === "regex") {
      const regex = getUrlRegExp(pattern);
      if (!regex) return false;
      return regex.test(parsed.href) || regex.test(parsed.href.substring(parsed.origin.length));
    } else if (type === "simple") {
      return _evalSimpleUrlTarget(parsed, pattern);
    }
    return false;
  } catch (e) {
    return false;
  }
}
function getBucketRanges(numVariations, coverage, weights) {
  coverage = coverage === undefined ? 1 : coverage;

  // Make sure coverage is within bounds
  if (coverage < 0) {
    if (false) {}
    coverage = 0;
  } else if (coverage > 1) {
    if (false) {}
    coverage = 1;
  }

  // Default to equal weights if missing or invalid
  const equal = getEqualWeights(numVariations);
  weights = weights || equal;
  if (weights.length !== numVariations) {
    if (false) {}
    weights = equal;
  }

  // If weights don't add up to 1 (or close to it), default to equal weights
  const totalWeight = weights.reduce((w, sum) => sum + w, 0);
  if (totalWeight < 0.99 || totalWeight > 1.01) {
    if (false) {}
    weights = equal;
  }

  // Covert weights to ranges
  let cumulative = 0;
  return weights.map(w => {
    const start = cumulative;
    cumulative += w;
    return [start, start + coverage * w];
  });
}
function getQueryStringOverride(id, url, numVariations) {
  if (!url) {
    return null;
  }
  const search = url.split("?")[1];
  if (!search) {
    return null;
  }
  const match = search.replace(/#.*/, "") // Get rid of anchor
  .split("&") // Split into key/value pairs
  .map(kv => kv.split("=", 2)).filter(_ref => {
    let [k] = _ref;
    return k === id;
  }) // Look for key that matches the experiment id
  .map(_ref2 => {
    let [, v] = _ref2;
    return parseInt(v);
  }); // Parse the value into an integer

  if (match.length > 0 && match[0] >= 0 && match[0] < numVariations) return match[0];
  return null;
}
function isIncluded(include) {
  try {
    return include();
  } catch (e) {
    console.error(e);
    return false;
  }
}
const base64ToBuf = b => Uint8Array.from(atob(b), c => c.charCodeAt(0));
async function decrypt(encryptedString, decryptionKey, subtle) {
  decryptionKey = decryptionKey || "";
  subtle = subtle || globalThis.crypto && globalThis.crypto.subtle;
  if (!subtle) {
    throw new Error("No SubtleCrypto implementation found");
  }
  try {
    const key = await subtle.importKey("raw", base64ToBuf(decryptionKey), {
      name: "AES-CBC",
      length: 128
    }, true, ["encrypt", "decrypt"]);
    const [iv, cipherText] = encryptedString.split(".");
    const plainTextBuffer = await subtle.decrypt({
      name: "AES-CBC",
      iv: base64ToBuf(iv)
    }, key, base64ToBuf(cipherText));
    return new TextDecoder().decode(plainTextBuffer);
  } catch (e) {
    throw new Error("Failed to decrypt");
  }
}
function paddedVersionString(input) {
  // Remove build info and leading `v` if any
  // Split version into parts (both core version numbers and pre-release tags)
  // "v1.2.3-rc.1+build123" -> ["1","2","3","rc","1"]
  const parts = input.replace(/(^v|\+.*$)/g, "").split(/[-.]/);

  // If it's SemVer without a pre-release, add `~` to the end
  // ["1","0","0"] -> ["1","0","0","~"]
  // "~" is the largest ASCII character, so this will make "1.0.0" greater than "1.0.0-beta" for example
  if (parts.length === 3) {
    parts.push("~");
  }

  // Left pad each numeric part with spaces so string comparisons will work ("9">"10", but " 9"<"10")
  // Then, join back together into a single string
  return parts.map(v => v.match(/^[0-9]+$/) ? v.padStart(5, " ") : v).join("-");
}
//# sourceMappingURL=util.js.map
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook/dist/esm/mongrule.js
/* eslint-disable @typescript-eslint/no-explicit-any */


const _regexCache = {};

// The top-level condition evaluation function
function evalCondition(obj, condition) {
  // Recursive condition
  if ("$or" in condition) {
    return evalOr(obj, condition["$or"]);
  }
  if ("$nor" in condition) {
    return !evalOr(obj, condition["$nor"]);
  }
  if ("$and" in condition) {
    return evalAnd(obj, condition["$and"]);
  }
  if ("$not" in condition) {
    return !evalCondition(obj, condition["$not"]);
  }

  // Condition is an object, keys are object paths, values are the condition for that path
  for (const [k, v] of Object.entries(condition)) {
    if (!evalConditionValue(v, getPath(obj, k))) return false;
  }
  return true;
}

// Return value at dot-separated path of an object
function getPath(obj, path) {
  const parts = path.split(".");
  let current = obj;
  for (let i = 0; i < parts.length; i++) {
    if (current && typeof current === "object" && parts[i] in current) {
      current = current[parts[i]];
    } else {
      return null;
    }
  }
  return current;
}

// Transform a regex string into a real RegExp object
function getRegex(regex) {
  if (!_regexCache[regex]) {
    _regexCache[regex] = new RegExp(regex.replace(/([^\\])\//g, "$1\\/"));
  }
  return _regexCache[regex];
}

// Evaluate a single value against a condition
function evalConditionValue(condition, value) {
  // Simple equality comparisons
  if (typeof condition === "string") {
    return value + "" === condition;
  }
  if (typeof condition === "number") {
    return value * 1 === condition;
  }
  if (typeof condition === "boolean") {
    return !!value === condition;
  }
  if (condition === null) {
    return value === null;
  }
  if (Array.isArray(condition) || !isOperatorObject(condition)) {
    return JSON.stringify(value) === JSON.stringify(condition);
  }

  // This is a special operator condition and we should evaluate each one separately
  for (const op in condition) {
    if (!evalOperatorCondition(op, value, condition[op])) {
      return false;
    }
  }
  return true;
}

// If the object has only keys that start with '$'
function isOperatorObject(obj) {
  const keys = Object.keys(obj);
  return keys.length > 0 && keys.filter(k => k[0] === "$").length === keys.length;
}

// Return the data type of a value
function getType(v) {
  if (v === null) return "null";
  if (Array.isArray(v)) return "array";
  const t = typeof v;
  if (["string", "number", "boolean", "object", "undefined"].includes(t)) {
    return t;
  }
  return "unknown";
}

// At least one element of actual must match the expected condition/value
function elemMatch(actual, expected) {
  if (!Array.isArray(actual)) return false;
  const check = isOperatorObject(expected) ? v => evalConditionValue(expected, v) : v => evalCondition(v, expected);
  for (let i = 0; i < actual.length; i++) {
    if (actual[i] && check(actual[i])) {
      return true;
    }
  }
  return false;
}
function isIn(actual, expected) {
  // Do an intersection is attribute is an array
  if (Array.isArray(actual)) {
    return actual.some(el => expected.includes(el));
  }
  return expected.includes(actual);
}

// Evaluate a single operator condition
function evalOperatorCondition(operator, actual, expected) {
  switch (operator) {
    case "$veq":
      return paddedVersionString(actual) === paddedVersionString(expected);
    case "$vne":
      return paddedVersionString(actual) !== paddedVersionString(expected);
    case "$vgt":
      return paddedVersionString(actual) > paddedVersionString(expected);
    case "$vgte":
      return paddedVersionString(actual) >= paddedVersionString(expected);
    case "$vlt":
      return paddedVersionString(actual) < paddedVersionString(expected);
    case "$vlte":
      return paddedVersionString(actual) <= paddedVersionString(expected);
    case "$eq":
      return actual === expected;
    case "$ne":
      return actual !== expected;
    case "$lt":
      return actual < expected;
    case "$lte":
      return actual <= expected;
    case "$gt":
      return actual > expected;
    case "$gte":
      return actual >= expected;
    case "$exists":
      return expected ? actual !== null : actual === null;
    case "$in":
      if (!Array.isArray(expected)) return false;
      return isIn(actual, expected);
    case "$nin":
      if (!Array.isArray(expected)) return false;
      return !isIn(actual, expected);
    case "$not":
      return !evalConditionValue(expected, actual);
    case "$size":
      if (!Array.isArray(actual)) return false;
      return evalConditionValue(expected, actual.length);
    case "$elemMatch":
      return elemMatch(actual, expected);
    case "$all":
      if (!Array.isArray(actual)) return false;
      for (let i = 0; i < expected.length; i++) {
        let passed = false;
        for (let j = 0; j < actual.length; j++) {
          if (evalConditionValue(expected[i], actual[j])) {
            passed = true;
            break;
          }
        }
        if (!passed) return false;
      }
      return true;
    case "$regex":
      try {
        return getRegex(expected).test(actual);
      } catch (e) {
        return false;
      }
    case "$type":
      return getType(actual) === expected;
    default:
      console.error("Unknown operator: " + operator);
      return false;
  }
}

// Recursive $or rule
function evalOr(obj, conditions) {
  if (!conditions.length) return true;
  for (let i = 0; i < conditions.length; i++) {
    if (evalCondition(obj, conditions[i])) {
      return true;
    }
  }
  return false;
}

// Recursive $and rule
function evalAnd(obj, conditions) {
  for (let i = 0; i < conditions.length; i++) {
    if (!evalCondition(obj, conditions[i])) {
      return false;
    }
  }
  return true;
}
//# sourceMappingURL=mongrule.js.map
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook/dist/esm/feature-repository.js
// Config settings
const cacheSettings = {
  // Consider a fetch stale after 1 minute
  staleTTL: 1000 * 60,
  cacheKey: "gbFeaturesCache",
  backgroundSync: true
};
const polyfills = {
  fetch: globalThis.fetch ? globalThis.fetch.bind(globalThis) : undefined,
  SubtleCrypto: globalThis.crypto ? globalThis.crypto.subtle : undefined,
  EventSource: globalThis.EventSource
};
try {
  if (globalThis.localStorage) {
    polyfills.localStorage = globalThis.localStorage;
  }
} catch (e) {
  // Ignore localStorage errors
}

// Global state
const subscribedInstances = new Map();
let cacheInitialized = false;
const cache = new Map();
const activeFetches = new Map();
const streams = new Map();
const supportsSSE = new Set();

// Public functions
function setPolyfills(overrides) {
  Object.assign(polyfills, overrides);
}
function configureCache(overrides) {
  Object.assign(cacheSettings, overrides);
  if (!cacheSettings.backgroundSync) {
    clearAutoRefresh();
  }
}
async function clearCache() {
  cache.clear();
  activeFetches.clear();
  clearAutoRefresh();
  cacheInitialized = false;
  await updatePersistentCache();
}
async function refreshFeatures(instance, timeout, skipCache, allowStale, updateInstance) {
  const data = await fetchFeaturesWithCache(instance, allowStale, timeout, skipCache);
  updateInstance && data && (await refreshInstance(instance, data));
}

// Subscribe a GrowthBook instance to feature changes
function subscribe(instance) {
  const [key] = getKey(instance);
  const subs = subscribedInstances.get(key) || new Set();
  subs.add(instance);
  subscribedInstances.set(key, subs);
}
function unsubscribe(instance) {
  subscribedInstances.forEach(s => s.delete(instance));
}

// Private functions
async function updatePersistentCache() {
  try {
    if (!polyfills.localStorage) return;
    await polyfills.localStorage.setItem(cacheSettings.cacheKey, JSON.stringify(Array.from(cache.entries())));
  } catch (e) {
    // Ignore localStorage errors
  }
}
async function fetchFeaturesWithCache(instance, allowStale, timeout, skipCache) {
  const [key] = getKey(instance);
  const now = new Date();
  await initializeCache();
  const existing = cache.get(key);
  if (existing && !skipCache && (allowStale || existing.staleAt > now)) {
    // Reload features in the backgroud if stale
    if (existing.staleAt < now) {
      fetchFeatures(instance);
    }
    // Otherwise, if we don't need to refresh now, start a background sync
    else {
      startAutoRefresh(instance);
    }
    return existing.data;
  } else {
    const data = await promiseTimeout(fetchFeatures(instance), timeout);
    return data;
  }
}
function getKey(instance) {
  const [apiHost, clientKey] = instance.getApiInfo();
  return ["".concat(apiHost, "||").concat(clientKey), apiHost, clientKey];
}

// Guarantee the promise always resolves within {timeout} ms
// Resolved value will be `null` when there's an error or it takes too long
// Note: The promise will continue running in the background, even if the timeout is hit
function promiseTimeout(promise, timeout) {
  return new Promise(resolve => {
    let resolved = false;
    let timer;
    const finish = data => {
      if (resolved) return;
      resolved = true;
      timer && clearTimeout(timer);
      resolve(data || null);
    };
    if (timeout) {
      timer = setTimeout(() => finish(), timeout);
    }
    promise.then(data => finish(data)).catch(() => finish());
  });
}

// Populate cache from localStorage (if available)
async function initializeCache() {
  if (cacheInitialized) return;
  cacheInitialized = true;
  try {
    if (polyfills.localStorage) {
      const value = await polyfills.localStorage.getItem(cacheSettings.cacheKey);
      if (value) {
        const parsed = JSON.parse(value);
        if (parsed && Array.isArray(parsed)) {
          parsed.forEach(_ref => {
            let [key, data] = _ref;
            cache.set(key, {
              ...data,
              staleAt: new Date(data.staleAt)
            });
          });
        }
      }
    }
  } catch (e) {
    // Ignore localStorage errors
  }
}

// Called whenever new features are fetched from the API
function onNewFeatureData(key, data) {
  // If contents haven't changed, ignore the update, extend the stale TTL
  const version = data.dateUpdated || "";
  const staleAt = new Date(Date.now() + cacheSettings.staleTTL);
  const existing = cache.get(key);
  if (existing && version && existing.version === version) {
    existing.staleAt = staleAt;
    updatePersistentCache();
    return;
  }

  // Update in-memory cache
  cache.set(key, {
    data,
    version,
    staleAt
  });
  // Update local storage (don't await this, just update asynchronously)
  updatePersistentCache();

  // Update features for all subscribed GrowthBook instances
  const instances = subscribedInstances.get(key);
  instances && instances.forEach(instance => refreshInstance(instance, data));
}
async function refreshInstance(instance, data) {
  await (data.encryptedExperiments ? instance.setEncryptedExperiments(data.encryptedExperiments, undefined, polyfills.SubtleCrypto) : instance.setExperiments(data.experiments || instance.getExperiments()));
  await (data.encryptedFeatures ? instance.setEncryptedFeatures(data.encryptedFeatures, undefined, polyfills.SubtleCrypto) : instance.setFeatures(data.features || instance.getFeatures()));
}
async function fetchFeatures(instance) {
  const [key, apiHost, clientKey] = getKey(instance);
  const endpoint = apiHost + "/api/features/" + clientKey;
  let promise = activeFetches.get(key);
  if (!promise) {
    promise = polyfills.fetch(endpoint)
    // TODO: auto-retry if status code indicates a temporary error
    .then(res => {
      if (res.headers.get("x-sse-support") === "enabled") {
        supportsSSE.add(key);
      }
      return res.json();
    }).then(data => {
      onNewFeatureData(key, data);
      startAutoRefresh(instance);
      activeFetches.delete(key);
      return data;
    }).catch(e => {
       false && 0;
      activeFetches.delete(key);
      return Promise.resolve({});
    });
    activeFetches.set(key, promise);
  }
  return await promise;
}

// Watch a feature endpoint for changes
// Will prefer SSE if enabled, otherwise fall back to cron
function startAutoRefresh(instance) {
  const [key, apiHost, clientKey] = getKey(instance);
  if (cacheSettings.backgroundSync && supportsSSE.has(key) && polyfills.EventSource) {
    if (streams.has(key)) return;
    const channel = {
      src: null,
      cb: event => {
        try {
          const json = JSON.parse(event.data);
          onNewFeatureData(key, json);
          // Reset error count on success
          channel.errors = 0;
        } catch (e) {
           false && 0;
          onSSEError(channel, apiHost, clientKey);
        }
      },
      errors: 0
    };
    streams.set(key, channel);
    enableChannel(channel, apiHost, clientKey);
  }
}
function onSSEError(channel, apiHost, clientKey) {
  channel.errors++;
  if (channel.errors > 3 || channel.src && channel.src.readyState === 2) {
    // exponential backoff after 4 errors, with jitter
    const delay = Math.pow(3, channel.errors - 3) * (1000 + Math.random() * 1000);
    disableChannel(channel);
    setTimeout(() => {
      enableChannel(channel, apiHost, clientKey);
    }, Math.min(delay, 300000)); // 5 minutes max
  }
}

function disableChannel(channel) {
  if (!channel.src) return;
  channel.src.onopen = null;
  channel.src.onerror = null;
  channel.src.close();
  channel.src = null;
}
function enableChannel(channel, apiHost, clientKey) {
  channel.src = new polyfills.EventSource("".concat(apiHost, "/sub/").concat(clientKey));
  channel.src.addEventListener("features", channel.cb);
  channel.src.onerror = () => {
    onSSEError(channel, apiHost, clientKey);
  };
  channel.src.onopen = () => {
    channel.errors = 0;
  };
}
function destroyChannel(channel, key) {
  disableChannel(channel);
  streams.delete(key);
}
function clearAutoRefresh() {
  // Clear list of which keys are auto-updated
  supportsSSE.clear();

  // Stop listening for any SSE events
  streams.forEach(destroyChannel);

  // Remove all references to GrowthBook instances
  subscribedInstances.clear();
}
//# sourceMappingURL=feature-repository.js.map
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook/dist/esm/GrowthBook.js




const isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
class GrowthBook_GrowthBook {
  // context is technically private, but some tools depend on it so we can't mangle the name
  // _ctx below is a clone of this property that we use internally

  // Properties and methods that start with "_" are mangled by Terser (saves ~150 bytes)

  // eslint-disable-next-line

  constructor(context) {
    context = context || {};
    // These properties are all initialized in the constructor instead of above
    // This saves ~80 bytes in the final output
    this._ctx = this.context = context;
    this._renderer = null;
    this._trackedExperiments = new Set();
    this._trackedFeatures = {};
    this.debug = false;
    this._subscriptions = new Set();
    this._rtQueue = [];
    this._rtTimer = 0;
    this.ready = false;
    this._assigned = new Map();
    this._forcedFeatureValues = new Map();
    this._attributeOverrides = {};
    this._activeAutoExperiments = new Map();
    if (context.features) {
      this.ready = true;
    }
    if (isBrowser && context.enableDevMode) {
      window._growthbook = this;
      document.dispatchEvent(new Event("gbloaded"));
    }
    if (context.experiments) {
      this.ready = true;
      this._updateAllAutoExperiments();
    }
    if (context.clientKey) {
      this._refresh({}, true, false);
    }
  }
  async loadFeatures(options) {
    await this._refresh(options, true, true);
    if (options && options.autoRefresh) {
      subscribe(this);
    }
  }
  async refreshFeatures(options) {
    await this._refresh(options, false, true);
  }
  getApiInfo() {
    return [(this._ctx.apiHost || "https://cdn.growthbook.io").replace(/\/*$/, ""), this._ctx.clientKey || ""];
  }
  async _refresh(options, allowStale, updateInstance) {
    options = options || {};
    if (!this._ctx.clientKey) {
      throw new Error("Missing clientKey");
    }
    await refreshFeatures(this, options.timeout, options.skipCache || this._ctx.enableDevMode, allowStale, updateInstance);
  }
  _render() {
    if (this._renderer) {
      this._renderer();
    }
  }
  setFeatures(features) {
    this._ctx.features = features;
    this.ready = true;
    this._render();
  }
  async setEncryptedFeatures(encryptedString, decryptionKey, subtle) {
    const featuresJSON = await decrypt(encryptedString, decryptionKey || this._ctx.decryptionKey, subtle);
    this.setFeatures(JSON.parse(featuresJSON));
  }
  setExperiments(experiments) {
    this._ctx.experiments = experiments;
    this.ready = true;
    this._updateAllAutoExperiments();
  }
  async setEncryptedExperiments(encryptedString, decryptionKey, subtle) {
    const experimentsJSON = await decrypt(encryptedString, decryptionKey || this._ctx.decryptionKey, subtle);
    this.setExperiments(JSON.parse(experimentsJSON));
  }
  setAttributes(attributes) {
    this._ctx.attributes = attributes;
    this._render();
    this._updateAllAutoExperiments();
  }
  setAttributeOverrides(overrides) {
    this._attributeOverrides = overrides;
    this._render();
    this._updateAllAutoExperiments();
  }
  setForcedVariations(vars) {
    this._ctx.forcedVariations = vars || {};
    this._render();
    this._updateAllAutoExperiments();
  }
  // eslint-disable-next-line
  setForcedFeatures(map) {
    this._forcedFeatureValues = map;
    this._render();
  }
  setURL(url) {
    this._ctx.url = url;
    this._updateAllAutoExperiments(true);
  }
  getAttributes() {
    return {
      ...this._ctx.attributes,
      ...this._attributeOverrides
    };
  }
  getFeatures() {
    return this._ctx.features || {};
  }
  getExperiments() {
    return this._ctx.experiments || [];
  }
  subscribe(cb) {
    this._subscriptions.add(cb);
    return () => {
      this._subscriptions.delete(cb);
    };
  }
  getAllResults() {
    return new Map(this._assigned);
  }
  destroy() {
    // Release references to save memory
    this._subscriptions.clear();
    this._assigned.clear();
    this._trackedExperiments.clear();
    this._trackedFeatures = {};
    this._rtQueue = [];
    if (this._rtTimer) {
      clearTimeout(this._rtTimer);
    }
    unsubscribe(this);
    if (isBrowser && window._growthbook === this) {
      delete window._growthbook;
    }

    // Undo any active auto experiments
    this._activeAutoExperiments.forEach(exp => {
      exp.undo();
    });
    this._activeAutoExperiments.clear();
  }
  setRenderer(renderer) {
    this._renderer = renderer;
  }
  forceVariation(key, variation) {
    this._ctx.forcedVariations = this._ctx.forcedVariations || {};
    this._ctx.forcedVariations[key] = variation;
    this._render();
  }
  run(experiment) {
    const result = this._run(experiment, null);
    this._fireSubscriptions(experiment, result);
    return result;
  }
  triggerExperiment(key) {
    if (!this._ctx.experiments) return null;
    const exp = this._ctx.experiments.find(exp => exp.key === key);
    if (!exp || !exp.manual) return null;
    return this._runAutoExperiment(exp, true);
  }
  _runAutoExperiment(experiment, forceManual, forceRerun) {
    const key = experiment.key;
    const existing = this._activeAutoExperiments.get(key);

    // If this is a manual experiment and it's not already running, skip
    if (experiment.manual && !forceManual && !existing) return null;

    // Run the experiment
    const result = this.run(experiment);

    // A hash to quickly tell if the assigned value changed
    const valueHash = JSON.stringify(result.value);

    // If the changes are already active, no need to re-apply them
    if (!forceRerun && result.inExperiment && existing && existing.valueHash === valueHash) {
      return result;
    }

    // Undo any existing changes
    if (existing) this._undoActiveAutoExperiment(key);

    // Apply new changes
    if (result.inExperiment) {
      const undo = this._applyDOMChanges(result.value);
      if (undo) {
        this._activeAutoExperiments.set(experiment.key, {
          undo,
          valueHash
        });
      }
    }
    return result;
  }
  _undoActiveAutoExperiment(key) {
    const exp = this._activeAutoExperiments.get(key);
    if (exp) {
      exp.undo();
      this._activeAutoExperiments.delete(key);
    }
  }
  _updateAllAutoExperiments(forceRerun) {
    const experiments = this._ctx.experiments || [];

    // Stop any experiments that are no longer defined
    const keys = new Set(experiments.map(e => e.key));
    this._activeAutoExperiments.forEach((v, k) => {
      if (!keys.has(k)) {
        v.undo();
        this._activeAutoExperiments.delete(k);
      }
    });

    // Re-run all new/updated experiments
    experiments.forEach(exp => {
      this._runAutoExperiment(exp, false, forceRerun);
    });
  }
  _fireSubscriptions(experiment, result) {
    const key = experiment.key;

    // If assigned variation has changed, fire subscriptions
    const prev = this._assigned.get(key);
    // TODO: what if the experiment definition has changed?
    if (!prev || prev.result.inExperiment !== result.inExperiment || prev.result.variationId !== result.variationId) {
      this._assigned.set(key, {
        experiment,
        result
      });
      this._subscriptions.forEach(cb => {
        try {
          cb(experiment, result);
        } catch (e) {
          console.error(e);
        }
      });
    }
  }
  _trackFeatureUsage(key, res) {
    // Don't track feature usage that was forced via an override
    if (res.source === "override") return;

    // Only track a feature once, unless the assigned value changed
    const stringifiedValue = JSON.stringify(res.value);
    if (this._trackedFeatures[key] === stringifiedValue) return;
    this._trackedFeatures[key] = stringifiedValue;

    // Fire user-supplied callback
    if (this._ctx.onFeatureUsage) {
      try {
        this._ctx.onFeatureUsage(key, res);
      } catch (e) {
        // Ignore feature usage callback errors
      }
    }

    // In browser environments, queue up feature usage to be tracked in batches
    if (!isBrowser || !window.fetch) return;
    this._rtQueue.push({
      key,
      on: res.on
    });
    if (!this._rtTimer) {
      this._rtTimer = window.setTimeout(() => {
        // Reset the queue
        this._rtTimer = 0;
        const q = [...this._rtQueue];
        this._rtQueue = [];

        // Skip logging if a real-time usage key is not configured
        if (!this._ctx.realtimeKey) return;
        window.fetch("https://rt.growthbook.io/?key=".concat(this._ctx.realtimeKey, "&events=").concat(encodeURIComponent(JSON.stringify(q))), {
          cache: "no-cache",
          mode: "no-cors"
        }).catch(() => {
          // TODO: retry in case of network errors?
        });
      }, this._ctx.realtimeInterval || 2000);
    }
  }
  _getFeatureResult(key, value, source, ruleId, experiment, result) {
    const ret = {
      value,
      on: !!value,
      off: !value,
      source,
      ruleId: ruleId || ""
    };
    if (experiment) ret.experiment = experiment;
    if (result) ret.experimentResult = result;

    // Track the usage of this feature in real-time
    this._trackFeatureUsage(key, ret);
    return ret;
  }
  isOn(key) {
    return this.evalFeature(key).on;
  }
  isOff(key) {
    return this.evalFeature(key).off;
  }
  getFeatureValue(key, defaultValue) {
    const value = this.evalFeature(key).value;
    return value === null ? defaultValue : value;
  }

  /**
   * @deprecated Use {@link evalFeature}
   * @param id
   */
  // eslint-disable-next-line
  feature(id) {
    return this.evalFeature(id);
  }
  evalFeature(id) {
    // Global override
    if (this._forcedFeatureValues.has(id)) {
       false && 0;
      return this._getFeatureResult(id, this._forcedFeatureValues.get(id), "override");
    }

    // Unknown feature id
    if (!this._ctx.features || !this._ctx.features[id]) {
       false && 0;
      return this._getFeatureResult(id, null, "unknownFeature");
    }

    // Get the feature
    const feature = this._ctx.features[id];

    // Loop through the rules
    if (feature.rules) {
      for (const rule of feature.rules) {
        // If it's a conditional rule, skip if the condition doesn't pass
        if (rule.condition && !this._conditionPasses(rule.condition)) {
           false && 0;
          continue;
        }
        // If there are filters for who is included (e.g. namespaces)
        if (rule.filters && this._isFilteredOut(rule.filters)) {
           false && 0;
          continue;
        }

        // Feature value is being forced
        if ("force" in rule) {
          // If this is a percentage rollout, skip if not included
          if (!this._isIncludedInRollout(rule.seed || id, rule.hashAttribute, rule.range, rule.coverage, rule.hashVersion)) {
             false && 0;
            continue;
          }
           false && 0;

          // If this was a remotely evaluated experiment, fire the tracking callbacks
          if (rule.tracks) {
            rule.tracks.forEach(t => {
              this._track(t.experiment, t.result);
            });
          }
          return this._getFeatureResult(id, rule.force, "force", rule.id);
        }
        if (!rule.variations) {
           false && 0;
          continue;
        }
        // For experiment rules, run an experiment
        const exp = {
          variations: rule.variations,
          key: rule.key || id
        };
        if ("coverage" in rule) exp.coverage = rule.coverage;
        if (rule.weights) exp.weights = rule.weights;
        if (rule.hashAttribute) exp.hashAttribute = rule.hashAttribute;
        if (rule.namespace) exp.namespace = rule.namespace;
        if (rule.meta) exp.meta = rule.meta;
        if (rule.ranges) exp.ranges = rule.ranges;
        if (rule.name) exp.name = rule.name;
        if (rule.phase) exp.phase = rule.phase;
        if (rule.seed) exp.seed = rule.seed;
        if (rule.hashVersion) exp.hashVersion = rule.hashVersion;
        if (rule.filters) exp.filters = rule.filters;

        // Only return a value if the user is part of the experiment
        const res = this._run(exp, id);
        this._fireSubscriptions(exp, res);
        if (res.inExperiment && !res.passthrough) {
          return this._getFeatureResult(id, res.value, "experiment", rule.id, exp, res);
        }
      }
    }
     false && 0;

    // Fall back to using the default value
    return this._getFeatureResult(id, feature.defaultValue === undefined ? null : feature.defaultValue, "defaultValue");
  }
  _isIncludedInRollout(seed, hashAttribute, range, coverage, hashVersion) {
    if (!range && coverage === undefined) return true;
    const {
      hashValue
    } = this._getHashAttribute(hashAttribute);
    if (!hashValue) {
      return false;
    }
    const n = hash(seed, hashValue, hashVersion || 1);
    if (n === null) return false;
    return range ? inRange(n, range) : coverage !== undefined ? n <= coverage : true;
  }
  _conditionPasses(condition) {
    return evalCondition(this.getAttributes(), condition);
  }
  _isFilteredOut(filters) {
    return filters.some(filter => {
      const {
        hashValue
      } = this._getHashAttribute(filter.attribute);
      if (!hashValue) return true;
      const n = hash(filter.seed, hashValue, filter.hashVersion || 2);
      if (n === null) return true;
      return !filter.ranges.some(r => inRange(n, r));
    });
  }
  _run(experiment, featureId) {
    const key = experiment.key;
    const numVariations = experiment.variations.length;

    // 1. If experiment has less than 2 variations, return immediately
    if (numVariations < 2) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 2. If the context is disabled, return immediately
    if (this._ctx.enabled === false) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 2.5. Merge in experiment overrides from the context
    experiment = this._mergeOverrides(experiment);

    // 3. If a variation is forced from a querystring, return the forced variation
    const qsOverride = getQueryStringOverride(key, this._getContextUrl(), numVariations);
    if (qsOverride !== null) {
       false && 0;
      return this._getResult(experiment, qsOverride, false, featureId);
    }

    // 4. If a variation is forced in the context, return the forced variation
    if (this._ctx.forcedVariations && key in this._ctx.forcedVariations) {
      const variation = this._ctx.forcedVariations[key];
       false && 0;
      return this._getResult(experiment, variation, false, featureId);
    }

    // 5. Exclude if a draft experiment or not active
    if (experiment.status === "draft" || experiment.active === false) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 6. Get the hash attribute and return if empty
    const {
      hashValue
    } = this._getHashAttribute(experiment.hashAttribute);
    if (!hashValue) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 7. Exclude if user is filtered out (used to be called "namespace")
    if (experiment.filters) {
      if (this._isFilteredOut(experiment.filters)) {
         false && 0;
        return this._getResult(experiment, -1, false, featureId);
      }
    } else if (experiment.namespace && !inNamespace(hashValue, experiment.namespace)) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 7.5. Exclude if experiment.include returns false or throws
    if (experiment.include && !isIncluded(experiment.include)) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 8. Exclude if condition is false
    if (experiment.condition && !this._conditionPasses(experiment.condition)) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 8.1. Exclude if user is not in a required group
    if (experiment.groups && !this._hasGroupOverlap(experiment.groups)) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 8.2. Old style URL targeting
    if (experiment.url && !this._urlIsValid(experiment.url)) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 8.3. New, more powerful URL targeting
    if (experiment.urlPatterns && !isURLTargeted(this._getContextUrl(), experiment.urlPatterns)) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 9. Get bucket ranges and choose variation
    const n = hash(experiment.seed || key, hashValue, experiment.hashVersion || 1);
    if (n === null) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }
    const ranges = experiment.ranges || getBucketRanges(numVariations, experiment.coverage === undefined ? 1 : experiment.coverage, experiment.weights);
    const assigned = chooseVariation(n, ranges);

    // 10. Return if not in experiment
    if (assigned < 0) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 11. Experiment has a forced variation
    if ("force" in experiment) {
       false && 0;
      return this._getResult(experiment, experiment.force === undefined ? -1 : experiment.force, false, featureId);
    }

    // 12. Exclude if in QA mode
    if (this._ctx.qaMode) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 12.5. Exclude if experiment is stopped
    if (experiment.status === "stopped") {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 13. Build the result object
    const result = this._getResult(experiment, assigned, true, featureId, n);

    // 14. Fire the tracking callback
    this._track(experiment, result);

    // 15. Return the result
     false && 0;
    return result;
  }
  log(msg, ctx) {
    if (!this.debug) return;
    if (this._ctx.log) this._ctx.log(msg, ctx);else console.log(msg, ctx);
  }
  _track(experiment, result) {
    if (!this._ctx.trackingCallback) return;
    const key = experiment.key;

    // Make sure a tracking callback is only fired once per unique experiment
    const k = result.hashAttribute + result.hashValue + key + result.variationId;
    if (this._trackedExperiments.has(k)) return;
    this._trackedExperiments.add(k);
    try {
      this._ctx.trackingCallback(experiment, result);
    } catch (e) {
      console.error(e);
    }
  }
  _mergeOverrides(experiment) {
    const key = experiment.key;
    const o = this._ctx.overrides;
    if (o && o[key]) {
      experiment = Object.assign({}, experiment, o[key]);
      if (typeof experiment.url === "string") {
        experiment.url = getUrlRegExp(
        // eslint-disable-next-line
        experiment.url);
      }
    }
    return experiment;
  }
  _getHashAttribute(attr) {
    const hashAttribute = attr || "id";
    let hashValue = "";
    if (this._attributeOverrides[hashAttribute]) {
      hashValue = this._attributeOverrides[hashAttribute];
    } else if (this._ctx.attributes) {
      hashValue = this._ctx.attributes[hashAttribute] || "";
    } else if (this._ctx.user) {
      hashValue = this._ctx.user[hashAttribute] || "";
    }
    return {
      hashAttribute,
      hashValue
    };
  }
  _getResult(experiment, variationIndex, hashUsed, featureId, bucket) {
    let inExperiment = true;
    // If assigned variation is not valid, use the baseline and mark the user as not in the experiment
    if (variationIndex < 0 || variationIndex >= experiment.variations.length) {
      variationIndex = 0;
      inExperiment = false;
    }
    const {
      hashAttribute,
      hashValue
    } = this._getHashAttribute(experiment.hashAttribute);
    const meta = experiment.meta ? experiment.meta[variationIndex] : {};
    const res = {
      key: meta.key || "" + variationIndex,
      featureId,
      inExperiment,
      hashUsed,
      variationId: variationIndex,
      value: experiment.variations[variationIndex],
      hashAttribute,
      hashValue
    };
    if (meta.name) res.name = meta.name;
    if (bucket !== undefined) res.bucket = bucket;
    if (meta.passthrough) res.passthrough = meta.passthrough;
    return res;
  }
  _getContextUrl() {
    return this._ctx.url || (isBrowser ? window.location.href : "");
  }
  _urlIsValid(urlRegex) {
    const url = this._getContextUrl();
    if (!url) return false;
    const pathOnly = url.replace(/^https?:\/\//, "").replace(/^[^/]*\//, "/");
    if (urlRegex.test(url)) return true;
    if (urlRegex.test(pathOnly)) return true;
    return false;
  }
  _hasGroupOverlap(expGroups) {
    const groups = this._ctx.groups || {};
    for (let i = 0; i < expGroups.length; i++) {
      if (groups[expGroups[i]]) return true;
    }
    return false;
  }
  _applyDOMChanges(changes) {
    if (!isBrowser) return;
    const undo = [];
    if (changes.css) {
      const s = document.createElement("style");
      s.innerHTML = changes.css;
      document.head.appendChild(s);
      undo.push(() => s.remove());
    }
    if (changes.js) {
      const script = document.createElement("script");
      script.innerHTML = changes.js;
      document.body.appendChild(script);
      undo.push(() => script.remove());
    }
    if (changes.domMutations) {
      changes.domMutations.forEach(mutation => {
        undo.push(dom_mutator_esm.declarative(mutation).revert);
      });
    }
    return () => {
      undo.forEach(fn => fn());
    };
  }
}
//# sourceMappingURL=GrowthBook.js.map
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook-react/dist/esm/index.js




function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

const GrowthBookContext = /*#__PURE__*/compat_module.createContext({});
function run(exp, growthbook) {
  if (!growthbook) {
    return {
      featureId: null,
      value: exp.variations[0],
      variationId: 0,
      inExperiment: false,
      hashUsed: false,
      hashAttribute: exp.hashAttribute || "id",
      hashValue: "",
      key: ""
    };
  }
  return growthbook.run(exp);
}
function feature(id, growthbook) {
  if (!growthbook) {
    return {
      value: null,
      on: false,
      off: true,
      source: "unknownFeature",
      ruleId: ""
    };
  }
  return growthbook.evalFeature(id);
}

// Get features from API and targeting attributes during SSR
async function getGrowthBookSSRData(context) {
  // Server-side GrowthBook instance
  const gb = new GrowthBook({
    ...context
  });

  // Load feature flags from network if needed
  if (context.clientKey) {
    await gb.loadFeatures();
  }
  const data = {
    attributes: gb.getAttributes(),
    features: gb.getFeatures()
  };
  gb.destroy();
  return data;
}

// Populate the GrowthBook instance in context from the SSR props
function useGrowthBookSSR(data) {
  const gb = useGrowthBook();

  // Only do this once to avoid infinite loops
  const isFirst = React.useRef(true);
  if (gb && isFirst.current) {
    gb.setFeatures(data.features);
    gb.setAttributes(data.attributes);
    isFirst.current = false;
  }
}
function useExperiment(exp) {
  const {
    growthbook
  } = React.useContext(GrowthBookContext);
  return run(exp, growthbook);
}
function useFeature(id) {
  const growthbook = useGrowthBook();
  return feature(id, growthbook);
}
function useFeatureIsOn(id) {
  const growthbook = useGrowthBook();
  return growthbook ? growthbook.isOn(id) : false;
}
function useFeatureValue(id, fallback) {
  const growthbook = useGrowthBook();
  return growthbook ? growthbook.getFeatureValue(id, fallback) : fallback;
}
function useGrowthBook() {
  const {
    growthbook
  } = compat_module.useContext(GrowthBookContext);
  return growthbook;
}
function FeaturesReady({
  children,
  timeout,
  fallback
}) {
  const gb = useGrowthBook();
  const [hitTimeout, setHitTimeout] = React.useState(false);
  const ready = gb ? gb.ready : false;
  React.useEffect(() => {
    if (timeout && !ready) {
      const timer = setTimeout(() => {
        gb && gb.log("FeaturesReady timed out waiting for features to load", {
          timeout
        });
        setHitTimeout(true);
      }, timeout);
      return () => clearTimeout(timer);
    }
  }, [timeout, ready, gb]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, ready || hitTimeout ? children : fallback || null);
}
function IfFeatureEnabled({
  children,
  feature
}) {
  return useFeature(feature).on ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
}
function FeatureString(props) {
  const value = useFeature(props.feature).value;
  if (value !== null) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, value);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.default);
}
const withRunExperiment = Component => {
  // eslint-disable-next-line
  const withRunExperimentWrapper = props => /*#__PURE__*/compat_module.createElement(GrowthBookContext.Consumer, null, ({
    growthbook
  }) => {
    return /*#__PURE__*/compat_module.createElement(Component, _extends({}, props, {
      runExperiment: exp => run(exp, growthbook)
    }));
  });
  return withRunExperimentWrapper;
};
withRunExperiment.displayName = "WithRunExperiment";
const GrowthBookProvider = ({
  children,
  growthbook
}) => {
  // Tell growthbook how to re-render our app (for dev mode integration)
  // eslint-disable-next-line
  const [_, setRenderCount] = compat_module.useState(0);
  compat_module.useEffect(() => {
    if (!growthbook || !growthbook.setRenderer) return;
    growthbook.setRenderer(() => {
      setRenderCount(v => v + 1);
    });
    return () => {
      growthbook.setRenderer(() => {
        // do nothing
      });
    };
  }, [growthbook]);
  return /*#__PURE__*/compat_module.createElement(GrowthBookContext.Provider, {
    value: {
      growthbook
    }
  }, children);
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var createError = __webpack_require__(85061);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45655);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(65263);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 65263:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(65263);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 85061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(80481);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45655);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 80481:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(85061);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45655);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var enhanceError = __webpack_require__(80481);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__(88593);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 53630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isMobile; }
/* harmony export */ });
var appleIphone = /iPhone/i;
var appleIpod = /iPod/i;
var appleTablet = /iPad/i;
var appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
var androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var androidTablet = /Android/i;
var amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
var amazonTablet = /Silk/i;
var windowsPhone = /Windows Phone/i;
var windowsTablet = /\bWindows(?:.+)ARM\b/i;
var otherBlackBerry = /BlackBerry/i;
var otherBlackBerry10 = /BB10/i;
var otherOpera = /Opera Mini/i;
var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var otherFirefox = /Mobile(?:.+)Firefox\b/i;
var isAppleTabletOnIos13 = function (navigator) {
    return (typeof navigator !== 'undefined' &&
        navigator.platform === 'MacIntel' &&
        typeof navigator.maxTouchPoints === 'number' &&
        navigator.maxTouchPoints > 1 &&
        typeof MSStream === 'undefined');
};
function createMatch(userAgent) {
    return function (regex) { return regex.test(userAgent); };
}
function isMobile(param) {
    var nav = {
        userAgent: '',
        platform: '',
        maxTouchPoints: 0
    };
    if (!param && typeof navigator !== 'undefined') {
        nav = {
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            maxTouchPoints: navigator.maxTouchPoints || 0
        };
    }
    else if (typeof param === 'string') {
        nav.userAgent = param;
    }
    else if (param && param.userAgent) {
        nav = {
            userAgent: param.userAgent,
            platform: param.platform,
            maxTouchPoints: param.maxTouchPoints || 0
        };
    }
    var userAgent = nav.userAgent;
    var tmp = userAgent.split('[FBAN');
    if (typeof tmp[1] !== 'undefined') {
        userAgent = tmp[0];
    }
    tmp = userAgent.split('Twitter');
    if (typeof tmp[1] !== 'undefined') {
        userAgent = tmp[0];
    }
    var match = createMatch(userAgent);
    var result = {
        apple: {
            phone: match(appleIphone) && !match(windowsPhone),
            ipod: match(appleIpod),
            tablet: !match(appleIphone) &&
                (match(appleTablet) || isAppleTabletOnIos13(nav)) &&
                !match(windowsPhone),
            universal: match(appleUniversal),
            device: (match(appleIphone) ||
                match(appleIpod) ||
                match(appleTablet) ||
                match(appleUniversal) ||
                isAppleTabletOnIos13(nav)) &&
                !match(windowsPhone)
        },
        amazon: {
            phone: match(amazonPhone),
            tablet: !match(amazonPhone) && match(amazonTablet),
            device: match(amazonPhone) || match(amazonTablet)
        },
        android: {
            phone: (!match(windowsPhone) && match(amazonPhone)) ||
                (!match(windowsPhone) && match(androidPhone)),
            tablet: !match(windowsPhone) &&
                !match(amazonPhone) &&
                !match(androidPhone) &&
                (match(amazonTablet) || match(androidTablet)),
            device: (!match(windowsPhone) &&
                (match(amazonPhone) ||
                    match(amazonTablet) ||
                    match(androidPhone) ||
                    match(androidTablet))) ||
                match(/\bokhttp\b/i)
        },
        windows: {
            phone: match(windowsPhone),
            tablet: match(windowsTablet),
            device: match(windowsPhone) || match(windowsTablet)
        },
        other: {
            blackberry: match(otherBlackBerry),
            blackberry10: match(otherBlackBerry10),
            opera: match(otherOpera),
            firefox: match(otherFirefox),
            chrome: match(otherChrome),
            device: match(otherBlackBerry) ||
                match(otherBlackBerry10) ||
                match(otherOpera) ||
                match(otherFirefox) ||
                match(otherChrome)
        },
        any: false,
        phone: false,
        tablet: false
    };
    result.any =
        result.apple.device ||
            result.android.device ||
            result.windows.device ||
            result.other.device;
    result.phone =
        result.apple.phone || result.android.phone || result.windows.phone;
    result.tablet =
        result.apple.tablet || result.android.tablet || result.windows.tablet;
    return result;
}
//# sourceMappingURL=isMobile.js.map

/***/ }),

/***/ 10646:
/***/ (function(module) {

/*! js-cookie v3.0.5 | MIT */
;
(function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (name, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      name = encodeURIComponent(name)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        name + '=' + converter.write(value, name) + stringifiedAttributes)
    }

    function get (name) {
      if (typeof document === 'undefined' || (arguments.length && !name)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var found = decodeURIComponent(parts[0]);
          jar[found] = converter.read(value, found);

          if (name === found) {
            break
          }
        } catch (e) {}
      }

      return name ? jar[name] : jar
    }

    return Object.create(
      {
        set,
        get,
        remove: function (name, attributes) {
          set(
            name,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

}));


/***/ }),

/***/ 7544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(46029)


/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(88769);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/next/app.js
var app = __webpack_require__(7544);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/ismobilejs/esm/isMobile.js
var isMobile = __webpack_require__(53630);
// EXTERNAL MODULE: ./src/common/utils/responsive/index.tsx
var responsive = __webpack_require__(7010);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/common/utils/globals/polyfills.ts
/* eslint-disable func-names */ /* eslint-disable no-extend-native */ function init() {
    Promise.prototype.finally = Promise.prototype.finally || function(callback) {
        var _this = this;
        return this.then(function(value) {
            return _this.constructor.resolve(callback === null || callback === void 0 ? void 0 : callback()).then(function() {
                return value;
            });
        }, function(reason) {
            return _this.constructor.resolve(callback === null || callback === void 0 ? void 0 : callback()).then(function() {
                throw reason;
            });
        });
    };
}

;// CONCATENATED MODULE: ./src/common/utils/globals/index.ts
/* provided dependency */ var process = __webpack_require__(83454);
/* eslint-disable consistent-return */ /* eslint-disable @typescript-eslint/ban-ts-comment */ 



function initGlobals() {
    if (true) {
        init();
        window["r2d2"] = r2d2;
        window["track"] = track;
        window["cookie"] = cookie;
    }
}
function r2d2(in_) {
    var url = cookie("corp_session") ? "".concat(process.env.NEXT_PUBLIC_CORP_PLATFORM_AUTH_URL || "", "/authorization/api/r2d2/") : "/api/r2d2/";
    return axios_default().post(url, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        app: "NS_Container",
        ua: window === null || window === void 0 ? void 0 : window.navigator.userAgent,
        user: in_.user || cookie("user_id"),
        tracker: in_.tracker || cookie("trackerid")
    }, in_), {
        edata: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, in_.edata || {}), {
            anonymousID: webengageAnonymousID(),
            ga_client_id: getGAClientID(),
            is_js: true,
            platform: (window === null || window === void 0 ? void 0 : window.innerWidth) < 480 ? "mweb" : "web",
            web_engage: true
        }),
        odata: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, in_.odata || {}), {
            url: window === null || window === void 0 ? void 0 : window.location.href
        })
    }), {
        withCredentials: true
    });
}
function track(in_) {
    // @ts-ignore
    typeof dataLayer !== "undefined" && dataLayer.push(in_);
}
function getGAClientID() {
    try {
        return window["ga"].getAll()[0].get("clientId");
    } catch (e) {
        return "";
    }
}
function webengageAnonymousID() {
    var aid = cookie("we_aid");
    if (aid !== undefined) return aid;
    try {
        var w = window;
        aid = w.webengage.user.getAnonymousId();
        cookie("we_aid", aid);
    } catch (e) {
        aid = "";
    }
    return aid;
}
function cookie(key, value) {
    if (typeof document === "undefined") return;
    if (typeof key === "string" && typeof value === "string") {
        document.cookie = "".concat(key, "=").concat(value, ";path=/");
        return value;
    }
    if (document.cookie.indexOf("".concat(key, "=")) === -1) return;
    return document.cookie.split("".concat(key, "="))[1].split(";")[0];
}
var r2d2CustomEvent = '\nfunction getCookie(name) {\n  // Split all the cookies into an array\n  const cookies = document.cookie.split(";");\n  // Loop through the cookies array\n  for (let i = 0; i < cookies.length; i++) {\n    // Split the cookie into its name and value\n    const cookie = cookies[i].trim().split("=");\n\n    // Check if the cookie name matches the provided name\n    if (cookie[0] === name) {\n      // Return the cookie value\n      return decodeURIComponent(cookie[1]);\n    }\n  }\n  // If the cookie is not found, return null\n  return null;\n}\n\nfunction isMobile() {\n  try {\n    const mediaQuery = window.matchMedia("(max-width: 767px)");\n\n    // Check if the media query matches\n    if (mediaQuery.matches) {\n      return "mweb"\n    } else {\n      return "web"\n    }\n  } catch(e) {\n    return "indeterministic"\n  }\n\n}\n\nconst platform = isMobile();\nconst tracker = getCookie("trackerid");\nvar data = JSON.stringify({\n  "app": "NS_Container",\n  "ua": navigator.userAgent,\n  tracker,\n  "ekind": "travel_custom_event_page_loaded",\n  "okind": "travel",\n  "oid": tracker,\n  "edata": {},\n  "odata": {\n    "url": window.location.href\n  }\n})\n\nvar xhr = new XMLHttpRequest();\nxhr.withCredentials = true;\n\nxhr.open("POST", "https://www.acko.com/api/r2d2/");\nxhr.setRequestHeader("x-platform", platform);\n\nxhr.send(data);\n';

// EXTERNAL MODULE: ./src/common/utils/context/index.ts
var context = __webpack_require__(78234);
// EXTERNAL MODULE: ./src/international-insurance/context/index.tsx
var international_insurance_context = __webpack_require__(3262);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.theme/dist/index.js
var dist = __webpack_require__(549);
// EXTERNAL MODULE: ./src/common/styles/index.ts
var styles = __webpack_require__(31065);
// EXTERNAL MODULE: ./styles/globals.css
var globals = __webpack_require__(40906);
// EXTERNAL MODULE: ./node_modules/@growthbook/growthbook-react/dist/esm/index.js + 5 modules
var esm = __webpack_require__(81361);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-gtm-module/dist/index.js
var react_gtm_module_dist = __webpack_require__(1785);
var react_gtm_module_dist_default = /*#__PURE__*/__webpack_require__.n(react_gtm_module_dist);
// EXTERNAL MODULE: ./src/common/utils/config/index.ts
var config = __webpack_require__(79354);
// EXTERNAL MODULE: ./src/common/context-providers/user-provider.tsx
var user_provider = __webpack_require__(86089);
// EXTERNAL MODULE: ./src/common/utils/globals/initialiseAckoAnalytics.tsx + 1 modules
var initialiseAckoAnalytics = __webpack_require__(4789);
// EXTERNAL MODULE: ./src/common/utils/config/script.ts
var script = __webpack_require__(15806);
// EXTERNAL MODULE: ./src/common/utils/api/constants.ts
var constants = __webpack_require__(66725);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./src/common/styles/sass/common/common.module.scss
var common_module = __webpack_require__(60262);
var common_module_default = /*#__PURE__*/__webpack_require__.n(common_module);
;// CONCATENATED MODULE: ./pages/_app.tsx
/* eslint-disable import/no-extraneous-dependencies */ /* eslint-disable react/jsx-no-constructed-context-values */ 

























var growthbook = new esm/* GrowthBook */.Gr({
    apiHost: constants/* PRODUCTION_ENVIRONMENT */.H ? config/* GROWTHBOOK_PROD.HOST */.tW.HOST : config/* GROWTHBOOK_UAT.HOST */.XY.HOST,
    clientKey: constants/* PRODUCTION_ENVIRONMENT */.H ? config/* GROWTHBOOK_PROD.KEY */.tW.KEY : config/* GROWTHBOOK_UAT.KEY */.XY.KEY,
    enableDevMode: !constants/* PRODUCTION_ENVIRONMENT */.H,
    trackingCallback: function(experiment, result) {
        console.log("Viewed Experiment", {
            experimentId: experiment.key,
            variationId: result.key
        });
    }
});
function TravelApp(props) {
    var ref;
    var Component = props.Component, pageProps = props.pageProps, isMobileDevice = props.isMobileDevice, query = props.query, host = props.host, cookie = props.cookie;
    var router = (0,next_router.useRouter)();
    var isHT = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.utm_source) === (script.HT === null || script.HT === void 0 ? void 0 : script.HT.NAME);
    var ref1 = (0,compat_module.useState)(false), growthbookError = ref1[0], setGrowthbookError = ref1[1];
    (0,compat_module.useEffect)(function() {
        initGlobals();
        if (constants/* PRODUCTION_ENVIRONMENT */.H) react_gtm_module_dist_default().initialize({
            gtmId: config/* ACKO_GTM_ID */.Uv === null || config/* ACKO_GTM_ID */.Uv === void 0 ? void 0 : config/* ACKO_GTM_ID.PROD */.Uv.PROD
        });
        if (true) {
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem("userDetails");
        }
    }, []);
    (0,compat_module.useEffect)(function() {
        try {
            growthbook.loadFeatures();
            growthbook.setAttributes({
                id: (js_cookie/* default */.Z === null || js_cookie/* default */.Z === void 0 ? void 0 : js_cookie/* default.get */.Z.get("user_id")) || ""
            });
        } catch (e) {
            setGrowthbookError(true);
        }
        (0,initialiseAckoAnalytics/* initialiseAckoAnalytics */.x)();
    }, [
        router === null || router === void 0 ? void 0 : router.pathname
    ]);
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("title", {
                        children: "Acko | Travel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("meta", {
                        name: "description",
                        content: "Acko | Travel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                    }),
                    isHT && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("script", {
                        id: "ht-script",
                        type: "text/javascript",
                        children: script.HT.SCRIPT
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(user_provider/* UserProvider */.d, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(context/* TravelAppContext.Provider */.gg.Provider, {
                    value: {
                        cookie: cookie,
                        growthbookError: growthbookError
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(esm/* GrowthBookProvider */.Ny, {
                        growthbook: growthbook,
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(responsive/* ViewportProvider */.j, {
                            isMobileDevice: isMobileDevice,
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.ThemeProvider, {
                                theme: dist.AckoMainTheme,
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* GlobalStyle */.wr, {}),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(international_insurance_context/* TripInfoContextProvider */.Dn, {
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(international_insurance_context/* PersuassionContextProvider */.kO, {
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(international_insurance_context/* PreviousPageContextProvider */.Bw, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(international_insurance_context/* CouponsContextProvider */.x_, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(international_insurance_context/* PostPaymentDetailsProvider */.w_, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("main", {
                                                                className: (common_module_default()) === null || (common_module_default()) === void 0 ? void 0 : (common_module_default()).fontStyles,
                                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                                                                    query: query,
                                                                    host: host,
                                                                    cookie: cookie
                                                                }))
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}
TravelApp.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, appProps, userAgent, isMobileDevice;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        app["default"].getInitialProps(context)
                    ];
                case 1:
                    appProps = _state.sent();
                    userAgent =  false ? 0 : window === null || window === void 0 ? void 0 : (ref2 = window.navigator) === null || ref2 === void 0 ? void 0 : ref2.userAgent;
                    isMobileDevice = (0,isMobile/* default */.Z)(userAgent).any;
                    return [
                        2,
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, appProps), {
                            isMobileDevice: isMobileDevice,
                            query: context === null || context === void 0 ? void 0 : (ref3 = context.ctx) === null || ref3 === void 0 ? void 0 : ref3.query,
                            host: context === null || context === void 0 ? void 0 : (ref4 = context.ctx) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.req) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.headers) === null || ref6 === void 0 ? void 0 : ref6.host,
                            cookie: (context === null || context === void 0 ? void 0 : (ref7 = context.ctx) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.req) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.headers) === null || ref9 === void 0 ? void 0 : ref9.cookie) || ""
                        })
                    ];
            }
        });
    });
    return function(context) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _app = (TravelApp);


/***/ }),

/***/ 86089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useUser; },
/* harmony export */   "d": function() { return /* binding */ UserProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var src_common_custom_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49452);





var UserContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isUserLoggedIn: false
});
var UserProvider = function(param) {
    var children = param.children;
    var user = (0,src_common_custom_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useUserDetails */ .vU)();
    var value = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var isUserLoggedIn = Boolean(user === null || user === void 0 ? void 0 : user.phone);
        if (!user) {
            return {
                isUserLoggedIn: isUserLoggedIn
            };
        }
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, user), {
            isUserLoggedIn: isUserLoggedIn
        });
    }, [
        user
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(UserContext.Provider, {
        value: value,
        children: children
    });
};
var useUser = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(UserContext);
};


/***/ }),

/***/ 49452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ useTravelPassEvents; },
/* harmony export */   "E3": function() { return /* binding */ useRouterPush; },
/* harmony export */   "LD": function() { return /* binding */ useVasEvents; },
/* harmony export */   "Vr": function() { return /* binding */ useSegmentEvent; },
/* harmony export */   "W7": function() { return /* binding */ useElementOnScreen; },
/* harmony export */   "We": function() { return /* binding */ getUtmParams; },
/* harmony export */   "_Z": function() { return /* binding */ useAtlCoupon; },
/* harmony export */   "i0": function() { return /* binding */ useCurrentState; },
/* harmony export */   "rg": function() { return /* binding */ useTravelPdpRoute; },
/* harmony export */   "vU": function() { return /* binding */ useUserDetails; }
/* harmony export */ });
/* unused harmony exports useWidth, useHeight */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11720);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_common_utils_serverConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44718);
/* harmony import */ var src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92310);
/* harmony import */ var src_common_utils_api_request__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55978);
/* harmony import */ var ismobilejs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53630);
/* harmony import */ var src_common_utils_segment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22701);
/* harmony import */ var src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19659);
/* harmony import */ var src_common_context_providers_user_provider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86089);












var useWidth = function() {
    var ref = useState(0), width = ref[0], setWidth = ref[1];
    useEffect(function() {
        // eslint-disable-next-line no-restricted-globals
        setWidth((window === null || window === void 0 ? void 0 : window.outerWidth) > 0 ? window === null || window === void 0 ? void 0 : window.outerWidth : screen === null || screen === void 0 ? void 0 : screen.width);
    }, []);
    return width;
};
var useHeight = function() {
    var ref = useState(0), height = ref[0], setHeight = ref[1];
    useEffect(function() {
        // eslint-disable-next-line no-restricted-globals
        setHeight((window === null || window === void 0 ? void 0 : window.outerHeight) > 0 ? window === null || window === void 0 ? void 0 : window.outerHeight : screen === null || screen === void 0 ? void 0 : screen.height);
    }, []);
    return height;
};
var useCurrentState = function() {
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var routes = router === null || router === void 0 ? void 0 : (ref = router.route) === null || ref === void 0 ? void 0 : ref.split("/");
    var length = routes === null || routes === void 0 ? void 0 : routes.length;
    var currentState = length > 0 ? routes[length - 1] : "";
    return currentState;
};
var useUserDetails = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), userData = ref[0], setUserData = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (true) {
            getUserDetails();
        }
    }, []);
    var getUserDetails = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var res, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,src_common_utils_api_request__WEBPACK_IMPORTED_MODULE_4__/* .getRequest */ .A_)("".concat((0,src_common_utils_serverConfig__WEBPACK_IMPORTED_MODULE_2__/* .getDomainOrigin */ .IY)()).concat(src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_3__/* .getUserDetailsAPI */ .zQ))
                        ];
                    case 1:
                        res = _state.sent();
                        if (res) setUserData(res === null || res === void 0 ? void 0 : res.data);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.log({
                            error: error
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getUserDetails() {
            return _ref.apply(this, arguments);
        };
    }();
    return userData;
};
var getUtmParams = function() {
    if (true) {
        var ref, ref1;
        var urlParams = new URLSearchParams(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.search);
        var isMobileDevice = (0,ismobilejs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
        var isApp = (ref1 = urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("platform")) === null || ref1 === void 0 ? void 0 : ref1.includes("app");
        var utm_medium = urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("utm_medium");
        var utm_source = urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("utm_source");
        var utm_campaign = urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("utm_campaign");
        return {
            utm_medium: utm_medium || (isApp ? "app" : (isMobileDevice === null || isMobileDevice === void 0 ? void 0 : isMobileDevice.phone) ? "mweb" : "web"),
            utm_source: utm_source || "direct",
            utm_campaign: utm_campaign || undefined
        };
    }
    return {};
};
var useSegmentEvent = function() {
    var userDetails = (0,src_common_context_providers_user_provider__WEBPACK_IMPORTED_MODULE_7__/* .useUser */ .a)();
    var sendEvent = function(type, eventName, payload) {
        var packageType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
        (0,src_common_utils_segment__WEBPACK_IMPORTED_MODULE_5__/* .sendSegmentEvent */ .M2)(type, eventName, payload, userDetails, packageType);
    };
    return sendEvent;
};
var useVasEvents = function() {
    var userDetails = (0,src_common_context_providers_user_provider__WEBPACK_IMPORTED_MODULE_7__/* .useUser */ .a)();
    var sendEvent = function(eN) {
        var eT = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_6__/* .EventType.VIEW */ .tw.VIEW, payload = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        (0,src_common_utils_segment__WEBPACK_IMPORTED_MODULE_5__/* .sendVasEvents */ .J6)(eN, eT, payload, userDetails);
    };
    return sendEvent;
};
var useTravelPassEvents = function() {
    var userDetails = (0,src_common_context_providers_user_provider__WEBPACK_IMPORTED_MODULE_7__/* .useUser */ .a)();
    var sendEvent = function(eN) {
        var payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, eT = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_6__/* .EventType.VIEW */ .tw.VIEW;
        (0,src_common_utils_segment__WEBPACK_IMPORTED_MODULE_5__/* .sendTravelPassEvents */ .cu)(eN, payload, eT, userDetails);
    };
    return sendEvent;
};
// Router push hook for navigation
var useRouterPush = function() {
    var subRoot = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_3__/* .TravelFeBaseUrl */ .X7;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var urlRoot = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.urlRoot) ? "/".concat(router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.urlRoot) : "";
    var baseUrl = "".concat(urlRoot).concat(subRoot);
    if (subRoot === src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_3__/* .VasFeBaseUrl */ .L1 || subRoot === src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_3__/* .TravelPassBaseUrl */ .qh) baseUrl = "".concat(subRoot);
    var pushRoute = function() {
        var route = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        router.push("".concat(baseUrl).concat(route));
    };
    return pushRoute;
};
// Returns Pdp URL
var useTravelPdpRoute = function() {
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var urlRoot = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.urlRoot) ? "/".concat(router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.urlRoot) : "";
    var baseUrl = "".concat(urlRoot).concat(src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_3__/* .TravelFePdpUrl */ .fR);
    return "".concat(baseUrl);
};
var useStorage = function() {
    var storageType = function(type) {
        return "".concat(type !== null && type !== void 0 ? type : "session", "Storage");
    };
    var isBrowser = function() {
        return "object" !== "undefined";
    }();
    var getItem = function(key, type) {
        return isBrowser ? window[storageType(type)][key] : "";
    };
    var setItem = function(key, value, type) {
        if (isBrowser) {
            window[storageType(type)].setItem(key, value);
            return true;
        }
        return false;
    };
    var removeItem = function(key, type) {
        window[storageType(type)].removeItem(key);
    };
    return {
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = (useStorage);
var useElementOnScreen = function(options) {
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var callBackFunction = function(enteries) {
        var _enteries = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(enteries, 1), entry = _enteries[0];
        setIsVisible(entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var observer = new IntersectionObserver(callBackFunction, options);
        var element = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
        if (element) observer.observe(element);
        return function() {
            if (element) observer.unobserve(element);
        };
    }, [
        containerRef,
        options
    ]);
    return [
        containerRef,
        isVisible
    ];
};
var useAtlCoupon = function() {
    var getItem = useStorage().getItem;
    var sessionObj = getItem("ATL_COUPON", "session");
    var ATL_COUPON = sessionObj ? JSON.parse(sessionObj) : null;
    return ATL_COUPON;
};


/***/ }),

/***/ 31065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A7": function() { return /* binding */ MediumText; },
/* harmony export */   "Ej": function() { return /* binding */ FlexContainer; },
/* harmony export */   "KT": function() { return /* binding */ PostScript; },
/* harmony export */   "Mv": function() { return /* binding */ PhoneInputContainer; },
/* harmony export */   "Qd": function() { return /* binding */ AccordionItem; },
/* harmony export */   "Ts": function() { return /* binding */ ButtonLoaderImage; },
/* harmony export */   "Uk": function() { return /* binding */ AccordionDropdown; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "X2": function() { return /* binding */ Row; },
/* harmony export */   "oD": function() { return /* binding */ ButtonText; },
/* harmony export */   "qO": function() { return /* binding */ ButtonContainer; },
/* harmony export */   "vF": function() { return /* binding */ AccordionContent; },
/* harmony export */   "wr": function() { return /* binding */ GlobalStyle; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony exports CheckboxWrapper, CheckboxText, PageLoader, ErrorMessage, Container, SectionTitle, StickyCTA, ImageContainer, Circle, StickyText, Accordion, TextArea */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79749);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79354);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    body {\n        color: #040222;\n    }\n    scroll-behavior: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-top: 10px;\n  align-items: center;\n  margin-top: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 500;\n  font-size: 0.8rem;\n  color: #434f5a;\n  margin-left: 10px;\n  margin-top: 2px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  transform: -webkit-translate(-50%, -50%);\n  transform: -moz-translate(-50%, -50%);\n  transform: -ms-translate(-50%, -50%);\n  color: darkred;\n  width: 100px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  color: #5b5675;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: ",
        ";\n  margin: ",
        ";\n  padding: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  display: flex;\n  flex-direction: ",
        ";\n  align-items: ",
        ";\n  justify-content: ",
        ";\n  position: ",
        ";\n  height: ",
        ";\n  gap: ",
        ";\n  padding: ",
        ";\n  background: white;\n  max-width: inherit;\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  padding-left: ",
        ";\n  text-align: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  position: absolute;\n  bottom: 0px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: ",
        ";\n  margin-top: ",
        ";\n  width: ",
        ";\n  position: ",
        ";\n  cursor: pointer;\n  bottom: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  width: 65px;\n  position: absolute;\n  left: 50%;\n  margin-top: ",
        ";\n  transform: translateX(-50%);\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  visibility: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  margin-top: 60px;\n  width: 100%;\n  padding: 20px;\n  padding-bottom: 120px;\n  color: #040222;\n  max-width: inherit;\n  max-width: ",
        ";\n\n  @media screen and (min-width: 768px) {\n    background: url(",
        ");\n    background-repeat: no-repeat;\n    background-size: 100%;\n    background-color: #f8fdff;\n    max-width: unset;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  min-width: ",
        ";\n  max-width: ",
        ";\n  margin: ",
        ";\n  ",
        ";\n  position: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        ";\n  width: ",
        ";\n  border-radius: 50%;\n  border: ",
        ";\n  position: absolute;\n  top: -18px;\n  left: -2px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: #5b5675;\n  text-align: center;\n  margin: 5px 0 20px 0;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: ",
        ";\n  justify-content: ",
        ";\n  padding-bottom: ",
        ";\n  margin: ",
        ";\n  gap: ",
        ";\n  position: relative;\n  border-bottom: ",
        ";\n  padding-right: ",
        ";\n  flex-wrap: wrap;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid #e7e7f0;\n  padding: ",
        ";\n  margin: ",
        ";\n\n  &:last-child {\n    border: unset;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  right: 0;\n  font-weight: 700;\n  font-size: 1rem;\n  line-height: 1.375rem;\n  transition: all 0.3s ease-in;\n  transform: ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: #5b5675;\n  margin: ",
        ";\n  height: ",
        ";\n  opacity: ",
        ";\n  padding: ",
        ";\n  overflow: ",
        ";\n  transition: all 0.25s ease-in;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.25rem;\n  color: ",
        ";\n  max-width: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 120px;\n  overflow: auto;\n  padding: 12px 16px;\n  border: 1px solid #e0e0e8;\n  border-radius: 8px;\n  font-family: inherit;\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  margin-top: 18px;\n  resize: none;\n\n  &:focus {\n    outline: none;\n    border: 1px solid #5b5675;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  ",
        ";\n}"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  margin-bottom: 24px;\n  width: 100%;\n  ",
        ";\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 12px;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  ",
        ";\n}"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}


var GlobalStyle = (0,_acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.createGlobalStyle)(_templateObject());
var CheckboxWrapper = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject1());
var CheckboxText = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject2());
var PageLoader = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.img(_templateObject3());
var ErrorMessage = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject4());
var Container = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject5(), function(props) {
    return props.maxWidth;
}, function(props) {
    return props.margin || "auto";
}, function(props) {
    return props.padding || "0";
}, function(props) {
    return !props.noShadow ? "0px 10px 20px rgb(0,0,0,0.2)" : "";
});
var FlexContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject6(), function(props) {
    return props.width || "100%";
}, function(props) {
    return props.direction || "column";
}, function(props) {
    return props.align || "center";
}, function(props) {
    return props.justify || "flex-start";
}, function(props) {
    return props.position || "relative";
}, function(props) {
    return props.height || "initial";
}, function(props) {
    return props.gap || "10px";
}, function(props) {
    return props.padding || "initial";
}, function(props) {
    return props && props.styles;
});
var SectionTitle = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject7(), function(props) {
    return props.weight || "600";
}, function(props) {
    return props.size || "1.4rem";
}, function(props) {
    return props.lineHeight || "2rem";
}, function(props) {
    return props.marginTop || "0px";
}, function(props) {
    return props.marginBottom || "24px";
}, function(props) {
    return props.left || "0";
}, function(props) {
    return props.align;
});
var StickyCTA = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject8());
var ButtonContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject9(), function(props) {
    return props.marginLeft || "";
}, function(props) {
    return props.marginTop || "10px";
}, function(props) {
    return props.width || "inherit";
}, function(props) {
    return props.position || "relative";
}, function(props) {
    return props.bottom || "unset";
}, function(props) {
    return props && props.styles;
});
var ButtonLoaderImage = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.img(_templateObject10(), function(props) {
    return props.visibility ? "block" : "none";
}, function(props) {
    return props.marginTop || "30px";
});
var ButtonText = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject11(), function(props) {
    return props.hide ? "hidden" : "unset";
});
var Content = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject12(), function(props) {
    return props.maxWidth || "480px";
}, _utils_config__WEBPACK_IMPORTED_MODULE_2__/* .INTERNATIONAL_DESKTOP_ASSETS.JOURNEY_BACKGROUND */ .FJ.JOURNEY_BACKGROUND);
var ImageContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject13(), function(props) {
    return props.width || "initial";
}, function(props) {
    return props.width || "initial";
}, function(props) {
    return props.margin;
}, function(props) {
    return props && props.styles;
}, function(props) {
    return props.position || "initial";
});
var Circle = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject14(), function(props) {
    return props.height || "40px";
}, function(props) {
    return props.width || "40px";
}, function(props) {
    return props.border || "1px solid #E0E0E8";
});
var StickyText = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject15());
var Row = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject16(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.align) || "flex-start";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.justify) || "flex-start";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.paddingBottom) || "12px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.margin) || "0";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.gap) || "16px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.border) || "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.paddingRight) || "20px";
});
var Accordion = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject17(), function(props) {
    return props === null || props === void 0 ? void 0 : props.padding;
});
var AccordionItem = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject18(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.padding) || "0 0 20px 0";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.margin) || "0 0 20px 0";
});
var AccordionDropdown = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject19(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.rotate) ? "rotate(180deg)" : "rotate(0deg)";
});
var AccordionContent = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject20(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.margin) || "0 0 0 34px";
}, function(props) {
    return !(props === null || props === void 0 ? void 0 : props.open) ? "0" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.open) ? "1" : "0";
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.padding;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.overflow) || "hidden";
});
var MediumText = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject21(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.weight) || "500";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "0.875rem";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) || "inherit";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.maxWidth) || "unset";
});
var TextArea = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.textarea(_templateObject22());
var Text = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject23(), function(props) {
    return props === null || props === void 0 ? void 0 : props.weight;
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.size;
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.lineHeight;
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.color;
}, function(props) {
    return props && props.styles;
});
var PhoneInputContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject24(), function(props) {
    return props && props.styles;
});
var PostScript = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject25(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.weight) || "400";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "0.75rem";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.lineHeight) || "1rem";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) || "rgb(91, 86, 117)";
}, function(props) {
    return props && props.styles;
});


/***/ }),

/***/ 66725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ PRODUCTION_ENVIRONMENT; }
/* harmony export */ });
/* unused harmony export InternalServerErrorMessage */
/* provided dependency */ var process = __webpack_require__(83454);
var InternalServerErrorMessage = "Oops! Internal server error Please try refreshing the page. If the issue persists, please reach out to us at support@acko.com";
var PRODUCTION_ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT !== "master" && process.env.NEXT_PUBLIC_ENVIRONMENT !== "dev";


/***/ }),

/***/ 55978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A_": function() { return /* binding */ getRequest; },
/* harmony export */   "GH": function() { return /* binding */ putRequest; },
/* harmony export */   "j0": function() { return /* binding */ postRequest; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);



// Urls
var UAT_URL = "https://www.ackodev.com";
// Axios client
var axiosClient = axios__WEBPACK_IMPORTED_MODULE_0___default().create();
// Axios Configs
axiosClient.defaults.baseURL = UAT_URL;
axiosClient.defaults.headers = {
    "Content-Type": "application/json",
    Accept: "application/json"
};
// axiosClient.defaults.timeout = 4000;
axiosClient.defaults.withCredentials = true;
// Request methods
var getRequest = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(URL) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axiosClient.get("".concat(URL))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function getRequest(URL) {
        return _ref.apply(this, arguments);
    };
}();
function postRequest(URL) {
    return _postRequest.apply(this, arguments);
}
function _postRequest() {
    _postRequest = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(URL) {
        var payload, response;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    payload = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    return [
                        4,
                        axiosClient.post("".concat(URL), payload)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return _postRequest.apply(this, arguments);
}
function putRequest(URL) {
    return _putRequest.apply(this, arguments);
}
function _putRequest() {
    _putRequest = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(URL) {
        var payload, token, headers, response;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    payload = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, token = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "";
                    headers = !!token ? {
                        headers: {
                            "x-captcha-token": token
                        }
                    } : {};
                    return [
                        4,
                        axiosClient.put("".concat(URL), payload, headers)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return _putRequest.apply(this, arguments);
}


/***/ }),

/***/ 92310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gW": function() { return /* binding */ CoverType; },
  "X7": function() { return /* binding */ TravelFeBaseUrl; },
  "fR": function() { return /* binding */ TravelFePdpUrl; },
  "qh": function() { return /* binding */ TravelPassBaseUrl; },
  "pd": function() { return /* binding */ TravelPassFeBaseUrl; },
  "k2": function() { return /* binding */ UrlType; },
  "L1": function() { return /* binding */ VasFeBaseUrl; },
  "zQ": function() { return /* binding */ getUserDetailsAPI; },
  "H7": function() { return /* binding */ internationalTravelUrls; },
  "ql": function() { return /* binding */ internationalTravelUrlsV2; },
  "sf": function() { return /* binding */ travelPassUrls; },
  "kG": function() { return /* binding */ travelV2fUrls; }
});

// UNUSED EXPORTS: BaseUrl, BaseUrlV2, JourneyType, V2fBaseUrl, VisaBaseUrl, electronicsUrls, partnershipUrls, partnershipsUrls, userUrls

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./src/common/constants/utm.ts

var DEFAULT_UTM_PARAMS = {
    utm_campaign: "international_travel",
    utm_source: "acko_web"
};
var getUTMParams = function() {
    if (false) {}
    var urlParams = new URLSearchParams(window.location.search);
    return {
        utm_campaign: urlParams.get("utm_campaign") || DEFAULT_UTM_PARAMS.utm_campaign,
        utm_source: urlParams.get("utm_source") || DEFAULT_UTM_PARAMS.utm_source
    };
};
var appendUTMParams = function(url) {
    var params = getUTMParams();
    var queryString = Object.entries(params).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, "=").concat(encodeURIComponent(value));
    }).join("&");
    var separator = url.includes("?") ? "&" : "?";
    return "".concat(url).concat(separator).concat(queryString);
};

;// CONCATENATED MODULE: ./src/common/utils/api/urls.ts
/**
 * International travel Urls
 */ 
var BaseUrl = "/travel/api/v1/international";
var BaseUrlV2 = "/travel/api/v2/travel/journey";
var VisaBaseUrl = "/travel/api/v1/vas/visa_assistance";
var V2fBaseUrl = "".concat(VisaBaseUrl, "/v2f");
var TravelFeBaseUrl = "/p/travel/international-insurance";
var TravelPassBaseUrl = "/travel/api/v1/travel";
var TravelFePdpUrl = "".concat(TravelFeBaseUrl, "/pdp");
var VasFeBaseUrl = "/travel/vas/visa-application";
var TravelPassFeBaseUrl = "/travel/domestic-pass";
var JourneyType = {
    PURCHASE: "purchase",
    TRAVEL_PASS: "travel_pass_purchase",
    INTERNATIONAL_TRAVEL: "international-travel"
};
var UrlType = {
    FETCH_JOURNEY: "",
    FETCH_FAQS: "/faqs",
    SELECT_PACKAGE: "/select_package",
    EDIT_TRIP_DETAILS: "/edit_trip_details",
    UPDATE_COVER: "/plan",
    UPDATE_TRAVELLER_DETAILS: "/update_traveller_details",
    CHECK_PINCODE: "/check-pincode",
    UPDATE_BUNDLED_ADDONS: "/addons",
    INITIATE_PAYMENT: "/initiate_payment",
    KYC_INIT: "/kyc/init",
    VERIFY_PAYMENT: "/payment_verify",
    UPDATE_INSURED: "/update_insured",
    SUBMIT_USER_DETAILS: "/submit_user_details"
};
var travelV2fUrls = {
    initV2fJourney: function() {
        var url = "".concat(V2fBaseUrl, "/journey/init");
        return url;
    },
    getV2fCountries: function() {
        var url = "".concat(V2fBaseUrl, "/countries");
        return url;
    },
    v2fCountryResults: function() {
        var url = "".concat(V2fBaseUrl, "/countries/result");
        return url;
    },
    initPayment: function() {
        var url = "".concat(V2fBaseUrl, "/journey/payment/init");
        return url;
    },
    verifyPayment: function(bookingId, ekey) {
        var url = "".concat(V2fBaseUrl, "/journey/payment/verify?booking_id=").concat(bookingId, "&ekey=").concat(ekey);
        return url;
    },
    initInsurancePurchase: function(bookingId) {
        var url = "".concat(VisaBaseUrl, "/").concat(bookingId, "/insurance_purchase/init");
        return url;
    },
    getMyBookings: function() {
        var url = "".concat(V2fBaseUrl, "/applications");
        return url;
    }
};
var travelPassUrls = {
    initJourney: "".concat(TravelPassBaseUrl, "/journey/").concat(JourneyType.TRAVEL_PASS, "/purchase/init"),
    fetchJourney: function(jId) {
        return "".concat(TravelPassBaseUrl, "/journey/").concat(jId, "/fetch");
    },
    submitUserDetails: function(jId) {
        return "".concat(TravelPassBaseUrl, "/journey/").concat(jId).concat(UrlType.SUBMIT_USER_DETAILS);
    },
    updateState: function(jId, action) {
        return "".concat(TravelPassBaseUrl, "/journey/").concat(jId, "/goto/").concat(action);
    },
    manageCustomerAddress: "".concat(TravelPassBaseUrl, "/address"),
    putCustomerAddress: "".concat(TravelPassBaseUrl, "/address"),
    fetchUserDetails: "".concat(TravelPassBaseUrl, "/get_pass_policy")
};
var internationalTravelUrlsV2 = {
    initJourney: "".concat(BaseUrl, "/journey/").concat(JourneyType.PURCHASE, "/init/v2"),
    action: function(jId, action) {
        var url = "".concat(BaseUrl, "/journey/").concat(JourneyType.PURCHASE, "/").concat(jId).concat(action, "/v2");
        return appendUTMParams(url);
    },
    updateState: function(jId, action) {
        var url = "".concat(BaseUrl, "/journey/").concat(JourneyType.PURCHASE, "/").concat(jId, "/goto/").concat(action);
        return url;
    }
};
var internationalTravelUrls = {
    initJourney: "".concat(BaseUrl, "/journey/").concat(JourneyType.PURCHASE, "/init"),
    initJourneyV2: "".concat(BaseUrlV2, "/").concat(JourneyType.INTERNATIONAL_TRAVEL, "/purchase/init"),
    getSeoData: "".concat(BaseUrl, "/seo/insurance_purchase/config"),
    initSeoJourney: "".concat(BaseUrl, "/seo/insurance_purchase/init"),
    fetchPreExistingDiseases: "".concat(BaseUrl, "/medical/pre-existing-diseases"),
    getAllTrips: "travel/api/v1/travel/my_trips",
    action: function(jId, action) {
        var url = "".concat(BaseUrl, "/journey/").concat(JourneyType.PURCHASE, "/").concat(jId).concat(action);
        return url;
    },
    updateState: function(jId, action) {
        var url = "".concat(BaseUrl, "/journey/").concat(JourneyType.PURCHASE, "/").concat(jId, "/goto/").concat(action);
        return url;
    },
    getBenefits: function(jId, planId) {
        var url = "".concat(BaseUrl, "/").concat(jId, "/covers?planId=").concat(planId);
        return url;
    },
    verifyPayment: function(proposalId) {
        var url = "".concat(BaseUrl, "/proposal/").concat(proposalId, "/payment_verify");
        return url;
    },
    cancelTransaction: function() {
        var url = "".concat(BaseUrl, "/proposal/cancel_transaction");
        return url;
    },
    generic: function(type) {
        var url = "".concat(BaseUrl).concat(type);
        return url;
    },
    getComparison: function(jId, req) {
        var url = "".concat(BaseUrl, "/journey/").concat(jId, "/plans/compare?").concat(req);
        return url;
    },
    getPdp: function(policyId) {
        var url = "".concat(BaseUrl, "/policy-details/compressed/").concat(policyId);
        return url;
    },
    getPdpUrl: function() {
        return "".concat(BaseUrl, "/claim/pdp");
    },
    applyCoupon: function() {
        return "".concat(BaseUrl, "/apply_coupon");
    },
    removeCoupon: function() {
        return "".concat(BaseUrl, "/remove_coupon");
    },
    getPsuedoCoupon: function() {
        var isApp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var platform = isApp ? "app" : "web";
        var url = "".concat(BaseUrl, "/pseudo-coupons?platform=").concat(platform);
        return url;
    },
    getPolicyPdf: function() {
        var policyId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        var url = "".concat(BaseUrl, "/pdf?policy_id=").concat(policyId);
        return url;
    },
    postPurchaseDataCollection: function(jId) {
        var url = "".concat(BaseUrl, "/journey/").concat(jId, "/post_purchase_data_collection");
        return url;
    }
};
var CoverType = {
    MEDICAL: "medical",
    TRIP: "trip",
    BAGGAGE: "baggage"
};
var getUserDetailsAPI = "/api/user/details/";
/**
 * partnership urls
 */ var partnershipUrls = {
    claim: {
        claimDetails: "jarvis-api/partnership/claims/oneclick/internet/data",
        trackingDetails: {
            partnership: "jarvis-api/partnership/claims/internet",
            electronics: "electronics-api/fetch/claims/tracking"
        }
    },
    onboarding: {
        policyDetails: "partnership/user/onboarding/policy_details",
        updateUserDetails: "partnership/user/onboarding/user_details",
        updateCarDetails: "partnership/user/onboarding/crosssell_details"
    },
    policy: {
        details: "partnerships/fetch/policy"
    },
    claims: {
        partnershipClaims: "partnerships/fetch/claims",
        electronicsClaims: "electronics-api/fetch/claims"
    }
};
var electronicsUrls = {
    policy: {
        details: "electronics-api/fetch/policy",
        edit: "electronics-api/policy"
    }
};
var partnershipsUrls = {
    demoRequest: "/partnerships/send_lead_email"
};
var userUrls = {
    basicDetails: "https://www.acko.com/api/user/details/"
};


/***/ }),

/***/ 79354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ StoryBorderStyle; },
/* harmony export */   "E5": function() { return /* binding */ StoryAnimationBackgroundColor; },
/* harmony export */   "FJ": function() { return /* binding */ INTERNATIONAL_DESKTOP_ASSETS; },
/* harmony export */   "Fw": function() { return /* binding */ COUPON_STATUS; },
/* harmony export */   "Ip": function() { return /* binding */ PDP_ICONS; },
/* harmony export */   "O4": function() { return /* binding */ COUPON_HEADER_BACKGROUND; },
/* harmony export */   "OK": function() { return /* binding */ ANIMATIONS; },
/* harmony export */   "Uv": function() { return /* binding */ ACKO_GTM_ID; },
/* harmony export */   "WM": function() { return /* binding */ PAYMENT_LOADER_DATA; },
/* harmony export */   "XL": function() { return /* binding */ VAS_LOADER_DATA; },
/* harmony export */   "XO": function() { return /* binding */ ErrorMessages; },
/* harmony export */   "XY": function() { return /* binding */ GROWTHBOOK_UAT; },
/* harmony export */   "ZW": function() { return /* binding */ ModalsType; },
/* harmony export */   "cV": function() { return /* binding */ CoverHeadBackground; },
/* harmony export */   "dl": function() { return /* binding */ JourneyState; },
/* harmony export */   "kR": function() { return /* binding */ COMPLIANCE_PENDING_ICONS; },
/* harmony export */   "ou": function() { return /* binding */ ASSETS; },
/* harmony export */   "rz": function() { return /* binding */ AdditionalStyles; },
/* harmony export */   "tW": function() { return /* binding */ GROWTHBOOK_PROD; },
/* harmony export */   "xF": function() { return /* binding */ ModalBackgroundColor; },
/* harmony export */   "z4": function() { return /* binding */ StoryBackgroundColor; },
/* harmony export */   "zm": function() { return /* binding */ TRAVELLER_DETAILS_ICONS; }
/* harmony export */ });
/* unused harmony exports CAPTCHA_KEY, GTM_ID, GA_ID, NEWRELIC_URL */
var ModalBackgroundColor = {
    WARNING: "linear-gradient(180deg, #fbeaea 0%, #ffffff 100%)",
    INFO: "linear-gradient(180deg, #def3ff 0%, #ffffff 100%)",
    PACKAGE_CHANGE: "linear-gradient(180deg, #fbeaea 0%, #ffffff 100%)",
    GENERIC: "#FFFFFF"
};
var ErrorMessages = {
    GENERIC: "Something went wrong, Please try again later.",
    TRIP_DETAILS: {
        COUNTRY_REQUIRED: "Please select a country",
        DURATION_REQUIRED: "Please select trip duration",
        ADULT_REQUIRED: "Please add an adult or a senior citizen to continue",
        INVALID_DATE: "Current date is not allowed",
        INELIGIBLE_TRIP_START_DATE: "This trip start date makes a traveller ineligible. Choose a different date or update traveller details.",
        PACKAGE_REQUIRED: "Please select the coverage type"
    },
    TRAVELLER_DETAILS: {
        FUTURE_DOB: "Date of birth cannot be in the future."
    }
};
var ModalsType = {
    PRICE_BREAKUP: "price_breakup",
    BENEFITS: "benefits",
    MANDATORY: "mandatory",
    WARNING: "warning",
    INFO: "info",
    PRICE_UPDATE: "price-update",
    PACKAGE_CHANGE: "package-change"
};
var CoverHeadBackground = {
    medical: "linear-gradient(291.97deg, #ECFEFF 25.43%, #F3EDFF 74.78%)",
    trip: "linear-gradient(296.6deg, #FFFBF1 15.55%, #FDF0F9 84.07%)",
    baggage: "linear-gradient(95.29deg, #EBFBEE 11.74%, #E3FAFC 86.95%)",
    baggaage: "linear-gradient(95.29deg, #EBFBEE 11.74%, #E3FAFC 86.95%)"
};
var StoryBackgroundColor = {
    medical: "rgb(252, 240, 249)",
    trip: "rgb(226, 245, 255)",
    baggage: "rgb(239, 233, 251)",
    baggaage: "rgb(239, 233, 251)"
};
var StoryAnimationBackgroundColor = {
    medical: "rgb(251, 233, 246)",
    trip: "rgb(226, 245, 255)",
    baggage: "rgb(239, 233, 251)",
    baggaage: "rgb(239, 233, 251)"
};
var AdditionalStyles = {
    medical: {
        paddingBottom: "14px"
    },
    trip: {
        padding: "20px 0px 16px"
    },
    baggage: {
        padding: "10px 0px 4px"
    },
    baggaage: {
        padding: "10px 0px 4px"
    }
};
var StoryBorderStyle = {
    medical: "1px solid rgba(252, 194, 215, 1)",
    trip: "1px solid rgba(169, 221, 254, 1)",
    baggage: "1px solid rgba(208, 189, 244, 1)",
    baggaage: "1px solid rgba(208, 189, 244, 1)"
};
var JourneyState = {
    PACKAGE_SELECTION: "package_selection",
    TRIP_DETAILS_COLLECTION: "trip_details_collection",
    MEDICAL_COVER_SELECTION: "medical_cover_selection",
    TRIP_COVER_SELECTION: "trip_cover_selection",
    BAGGAGE_COVER_SELECTION: "baggage_cover_selection",
    BUNDLED_PLAN_SELECTION: "bundled_plan_selection",
    BUNDLED_ADDON_SELECTION: "bundled_addon_selection",
    PLAN_SELECTION: "plan_selection",
    JOURNEY_SUMMARY: "journey_summary",
    POLICY_INIT: "policy_init",
    COMPLIANCE_PENDING: "compliance_pending",
    POLICY_ACTIVATED: "policy_activated",
    PAYMENT_INITIATED: "payment_initiated",
    PAYMENT_PENDING: "payment_pending",
    PAYMENT_FAILED: "payment_failed",
    POST_PURCHASE_DATA_COLLECTION: "post_purchase_data_collection",
    POST_POLICY_DATA_COLLECTION_INITIATED: "post_policy_data_collection_initiated",
    TRIP_DETAILS_COLLECTION_AND_PACKAGE_SELECTION: "trip_details_collection_and_package_selection"
};
var GROWTHBOOK_UAT = {
    HOST: "https://growthbook-api.internal.ackodev.com",
    KEY: "sdk-Z4y19WZBri00dOD2"
};
var GROWTHBOOK_PROD = {
    HOST: "https://ab.acko.com/",
    KEY: "sdk-Pw0f4p0AdN7T11M"
};
var CAPTCHA_KEY = {
    PROD: "a146f3ce-fb59-4672-a53a-77c50bf38d3d",
    UAT: "f9571092-6149-4653-a02d-6e7738a4878d"
};
var GTM_ID = {
    PROD: "GTM-5XMNN6W"
};
var ACKO_GTM_ID = {
    PROD: "GTM-TZVHFQH"
};
var GA_ID = {
    PROD: "G-801FY3RHXE"
};
var PDP_ICONS = {
    POLICY_INFO: "https://travel.ackoassets.com/images/pdp_web/pdp_policy_info.svg",
    STEP_1: "https://travel.ackoassets.com/images/desktop/extend_policy_icon.svg",
    STEP_2: "https://travel.ackoassets.com/images/desktop/update_travelle_icon.svg",
    STEP_3: "https://travel.ackoassets.com/images/desktop/raise_track icon.svg",
    QR_CODE: "https://travel.ackoassets.com/images/pdp_web/qrcode.svg",
    BLUE_ARROW: "https://travel.ackoassets.com/images/desktop/blue-arrow.svg"
};
var COMPLIANCE_PENDING_ICONS = {
    TICK_STAGE: "https://travel.ackoassets.com/images/pdp_web/tick_stage.svg",
    VISA_COMPLIANCE: "https://travel.ackoassets.com/images/pdp_web/visa_compliance.svg"
};
var ANIMATIONS = {
    VERIFY_PAYMENT_LOADING: "https://travel.ackoassets.com/images/pdp_web/verify_payment_loading.json",
    POLICY_ACTIVATED: "https://travel.ackoassets.com/images/pdp_web/policy_activated.json",
    MEDICAL_PERSUASION: "https://travel.ackoassets.com/images/medical/persuasion_new.json",
    THUMBS_UP: "https://travel.ackoassets.com/images/visa2fly/ThumbsUp.json",
    GIFT_BOX: "https://travel.ackoassets.com/images/coupons/gift-box.json",
    CONFETTI: "https://travel.ackoassets.com/images/coupons/side-confetti.json"
};
var TRAVELLER_DETAILS_ICONS = {
    PERSON: "https://travel.ackoassets.com/images/pdp_web/personal_details.svg",
    DROPDOWN: "https://travel.ackoassets.com/images/pdp_web/dropdown.svg"
};
var ASSETS = {
    ACKO_LOGO_DARK: "https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg",
    ACKO_LOGO_LIGHT: "https://acko-brand.ackoassets.com/brand/vector-svg/gradient/horizontal-reverse.svg",
    BACK_ARROW: "https://travel.ackoassets.com/images/fe_icons/back-arrow.svg",
    BUNDLE_CHANGE: "https://travel.ackoassets.com/images/fe_icons/bundleChange.svg",
    SHOW_SAMPLE_POLICY: "https://travel.ackoassets.com/images/fe_icons/show-sample-policy.svg",
    CIRCULAR_LOADER: "https://travel.ackoassets.com/images/fe_icons/circular-loader.gif",
    CLOSE_CROSS_MODAL: "https://travel.ackoassets.com/images/fe_icons/close-cross-modal.svg",
    CLOSE: "https://travel.ackoassets.com/images/fe_icons/close.svg",
    DETAILS_MISMATCH: "https://travel.ackoassets.com/images/fe_icons/details-mismatch.svg",
    DISCOUNT: "https://travel.ackoassets.com/images/fe_icons/discount.svg",
    FALLEN_GLASS: "https://travel.ackoassets.com/images/fe_icons/fallen-glass.svg",
    HAMBURGER_DARK: "https://travel.ackoassets.com/images/fe_icons/hamburger-dark.svg",
    HAMBURGER_LIGHT: "https://travel.ackoassets.com/images/fe_icons/hamburger-light.svg",
    HELP: "https://travel.ackoassets.com/images/fe_icons/help.svg",
    LOADER: "https://travel.ackoassets.com/images/fe_icons/loader.gif",
    MINUS: "https://travel.ackoassets.com/images/fe_icons/minus.svg",
    PRICE_UPDATED: "https://travel.ackoassets.com/images/fe_icons/price-updated.svg",
    WINDOW_DARK: "https://travel.ackoassets.com/images/fe_icons/window-dark.svg",
    WINDOW_LIGHT: "https://travel.ackoassets.com/images/fe_icons/window-light.svg",
    GREEN_TICK: "https://travel.ackoassets.com/images/green_tick.svg",
    GREEN_TICK_WITHOUT_BORDER: "https://travel.ackoassets.com/images/travel_pass/address/tick.svg",
    BAGGAGE_DELAY: "https://travel.ackoassets.com/images/gifs/baggage-delay.gif",
    FLIGHT_DELAY: "https://travel.ackoassets.com/images/gifs/flight-delay.gif",
    DOC_LOADER: "https://travel.ackoassets.com/images/gifs/docLoader.gif",
    SUCCESS: "https://travel.ackoassets.com/images/gifs/success.gif",
    PACKAGE_SELECTION_FOOTER: "https://travel.ackoassets.com/images/package-selection-footer.svg",
    KYC_ICON: "https://travel.ackoassets.com/images/kyc/kyc-icon.svg",
    V2F_HEAD_IMAGE: "https://travel.ackoassets.com/images/visa2fly/v2fSky.svg",
    EVISA: "https://travel.ackoassets.com/images/visa2fly/evisa.png",
    V2F_CARD_BORDER: "https://travel.ackoassets.com/images/visa2fly/v2f-card-border.svg",
    SEARCH_ICON: "https://travel.ackoassets.com/images/visa2fly/search-icon.svg",
    STAR_BULLET: "https://travel.ackoassets.com/images/visa2fly/star-bullet.svg",
    BORDERED_GREEN_TICK: "https://travel.ackoassets.com/images/visa2fly/border-green-tick.svg",
    MEDICAL_PLUS_SIGN: "https://travel.ackoassets.com/images/visa2fly/hospital-plus-sign.svg",
    IN_FLIGHT_CABIN: "https://travel.ackoassets.com/images/visa2fly/in-flight.svg",
    TRAVELLER_WITH_BAG: "https://travel.ackoassets.com/images/visa2fly/traveller-with-bag.svg",
    GRAY_FALLEN_GLASS: "https://travel.ackoassets.com/images/visa2fly/fallen-glass-gray.svg",
    SKY_VIDEO: "https://travel.ackoassets.com/images/visa2fly/Sky.webm",
    RELAX_CHAIR: "https://travel.ackoassets.com/images/visa2fly/relax.svg",
    FLIGHT_SKY: "https://travel.ackoassets.com/images/visa2fly/plane-sky.jpg",
    GIFT_BOX: "https://travel.ackoassets.com/images/coupons/gift-box.svg",
    WARNING_SIGN: "https://travel.ackoassets.com/images/coupons/warning-sign.svg",
    SAD_DOG: "https://travel.ackoassets.com/images/coupons/dog.svg",
    BLUE_SHIELD: "https://travel.ackoassets.com/images/coupons/blue-shield.svg",
    SAMPLE_POLICY: "https://travel.ackoassets.com/images/fe_icons/sample-travel-policy.pdf",
    NEW_SAMPLE_POLICY: "https://travel.ackoassets.com/images/fe_icons/new-sample-travel-policy.pdf",
    NOTE_ICON: "https://travel.ackoassets.com/images/info.svg",
    CLOUD_1: "https://travel.ackoassets.com/images/travel_pass/landing_page/clouds.svg",
    CLOUD_2: "https://travel.ackoassets.com/images/travel_pass/landing_page/clouds.svg",
    THUNDER_STROKES: "https://travel.ackoassets.com/images/travel_pass/landing_page/thunder_strokes.svg",
    TRAVEL_PASS_INTRO: "https://travel.ackoassets.com/images/travel_pass/video/travel_pass_intro.mp4",
    SHIELD_SUCCESS_TICK: "https://travel.ackoassets.com/images/travel_pass/status/success.svg",
    TRAVEL_PASS_CARD: "https://travel.ackoassets.com/images/travel_pass/landing_page/travel_pass_card.png",
    OTHER_ADDRESS_TYPE: "https://travel.ackoassets.com/images/travel_pass/address/other.svg",
    HOME_TAG_ICON: "https://travel.ackoassets.com/images/travel_pass/address/home_small.svg",
    WORK_TAG_ICON: "https://travel.ackoassets.com/images/travel_pass/address/work_small.svg",
    OTHER_TAG_ICON: "https://travel.ackoassets.com/images/travel_pass/address/other_small.svg",
    GREEN_OFFER_ICON: "https://travel.ackoassets.com/images/green_offer.svg",
    PURPLE_OFFER_ICON: "https://travel.ackoassets.com/images/purple_offer.svg",
    TRAVEL_PASS_BACKGROUND: "https://travel.ackoassets.com/images/travel-pass-background.png",
    BACK_ARROW_LIGHT: "https://travel.ackoassets.com/images/travel_pass/pdp/back_arrow_white.svg",
    TRAVEL_PASS_TNC: "https://travel.ackoassets.com/docs/flight_pass_tnc.pdf",
    ENVELOPE: "https://travel.ackoassets.com/images/fe_icons/envelope.svg",
    PHONE: "https://travel.ackoassets.com/images/phone.svg",
    VISA_SKY_DESKTOP_VIDEO: "https://travel.ackoassets.com/images/visa2fly/desktop/visa_desktop_header.webm",
    VISA_SKY_DESKTOP_POSTER: "https://travel.ackoassets.com/images/visa2fly/desktop/visa-desktop-poster.png",
    BLACK_SHIELD_TICK: "https://travel-uat-assets.ackodev.com/images/insurance_shield.svg",
    YELLOW_DISCOUNT: "https://travel.ackoassets.com/images/fe_icons/yellow-discounts.svg",
    PURPLE_DISCOUNT: "https://travel.ackoassets.com/images/fe_icons/purple-2-flag-discount.svg",
    BLACK_INFO_ICON: "https://travel.ackoassets.com/images/fe_icons/black-info-icon.svg",
    ALERT_SIGN_BOARD: "https://travel.ackoassets.com/images/fe_icons/alert-sign-board.svg",
    FAMILY_SHIELD: "https://travel.ackoassets.com/images/fe_icons/family-shield.svg",
    HAND_PICKING_BLOCK: "https://travel.ackoassets.com/images/fe_icons/hand-picking-block.svg",
    POLICY_READY: "https://travel.ackoassets.com/images/fe_icons/policy-ready.svg",
    PEOPLE: "https://travel.ackoassets.com/images/fe_icons/people.svg",
    FLIGHT: "https://travel.ackoassets.com/images/fe_icons/flight.png",
    BULB_DARK: "https://travel.ackoassets.com/images/fe_icons/bulb-dark.svg",
    PLANE_WITH_TRAIL: "https://travel.ackoassets.com/images/package/airplane-with-trail.png",
    BAGGAGE_DELAY_ICON: "https://travel.ackoassets.com/images/package/baggage-delay.svg",
    BUNDLED_ICON: "https://travel.ackoassets.com/images/package/bundled-icon.svg",
    CUSTOMER_SUPPORT: "https://travel.ackoassets.com/images/package/customer-support.svg",
    EDIT_DOCUMENT: "https://travel.ackoassets.com/images/package/edit-document.svg",
    FLIGHT_DELAY_ICON: "https://travel.ackoassets.com/images/package/flight-delay.svg",
    FLIGHT_TAKE_OFF: "https://travel.ackoassets.com/images/package/flight-take-off.svg",
    HEALTH_INSURANCE: "https://travel.ackoassets.com/images/package/health-insurance.svg",
    HOSPITAL: "https://travel.ackoassets.com/images/package/hospital.svg",
    PAY_MONEY: "https://travel.ackoassets.com/images/package/pay-money.svg",
    POEPLE: "https://travel.ackoassets.com/images/package/people.svg",
    SEE_ALL_COVERAGE: "https://travel.ackoassets.com/images/package/see-all-coverage.svg",
    TRAVEL_INTRO_DESKTOP: "https://travel.ackoassets.com/images/package/travel-intro-desktop.mp4",
    TRAVEL_INTRO_MOUNTAINS: "https://travel.ackoassets.com/images/package/mountains-intro.mp4",
    TRAVEL_LANDING_INTRO: "https://travel.ackoassets.com/images/package/travel-landing-intro.mp4",
    UNBUNDLED_SVG: "https://travel.ackoassets.com/images/package/unbundled-icon.svg",
    WHEN_ICON: "https://travel.ackoassets.com/images/package/when-icon.svg",
    WHITE_SEARCH_ICON: "https://travel.ackoassets.com/images/package/white-search-icon.svg",
    WHO_ICON: "https://travel.ackoassets.com/images/package/who-icon.svg",
    CUSTOMER_SUPPORT_PHONE: "https://travel.ackoassets.com/images/package/customer_support_phone.svg",
    MEDICAL_COVER_PHONE: "https://travel.ackoassets.com/images/package/cover-1.svg",
    FLIGHT_COVER_PHONE: "https://travel.ackoassets.com/images/package/cover-2.svg",
    BLUE_TICK: "https://travel.ackoassets.com/images/package/blue-tick.svg",
    DEFAULT_USER: "https://travel.ackoassets.com/images/fe_icons/default-user.png",
    VISA_COMPLIANT: "https://travel-uat-assets.ackodev.com/images/claim_resolved.svg",
    AIR_BALLONS_BACKGROUND: "https://travel.ackoassets.com/images/fe_icons/air-ballons.png",
    DARK_MOUNTAINS_BACKGROUND: "https://travel.ackoassets.com/images/package/mountains-bg.png",
    MOUNTAINS_BACKGROUND: "https://travel.ackoassets.com/images/fe_icons/mountains.png"
};
var INTERNATIONAL_DESKTOP_ASSETS = {
    LANDING_PAGE_BG: "https://travel.ackoassets.com/images/desktop/international-travel-desktop-bg.svg",
    CUSTOMER_SUPPORT: "https://travel.ackoassets.com/images/desktop/customer-support.svg",
    PASSPORT_ICON: "https://travel.ackoassets.com/images/desktop/passport.svg",
    MONEY_ICON: "https://travel.ackoassets.com/images/desktop/money.svg",
    NOTES_ICON: "https://travel.ackoassets.com/images/desktop/notes.svg",
    RIGHT_ARROW_ICON: "https://travel.ackoassets.com/images/desktop/right-arrow.svg",
    INFO_ICON: "https://travel.ackoassets.com/images/desktop/info-icon.svg",
    WHITE_TICK_ICON: "https://travel.ackoassets.com/images/desktop/white-tick-icon.svg",
    BLACK_TICK_ICON: "https://travel.ackoassets.com/images/desktop/black-tick.svg",
    GOLDEN_STAR: "https://travel.ackoassets.com/images/desktop/golden-star.svg",
    JOURNEY_BACKGROUND: "https://travel.ackoassets.com/images/desktop/journey-background.jpg"
};
var NEWRELIC_URL = "https://acko-frontend-prod.ackoassets.com/_next_static/js/newrelic/travel-newrelic.js";
var VAS_LOADER_DATA = {
    icon_url: ASSETS.DOC_LOADER,
    title: "Getting your application ready",
    sub_title: "Visa assistance powered by our trusted partner, Visa2fly"
};
var PAYMENT_LOADER_DATA = {
    title: "Hold on for a moment",
    sub_title: "Payment being processed",
    icon_url: ASSETS.DOC_LOADER
};
var COUPON_STATUS = {
    APPLICABLE: "Applicable",
    NON_APPLICABLE: "NonApplicable",
    APPLIED: "Applied"
};
var COUPON_HEADER_BACKGROUND = {
    Applicable: "linear-gradient(90.18deg, #451999 39.07%, #B191ED 138.56%)",
    NonApplicable: "rgba(248, 247, 252, 1)",
    Applied: "linear-gradient(90.16deg, #451999 -160.78%, #B191ED -48.81%, #EFE9FB 132.59%)"
};


/***/ }),

/***/ 15806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HT": function() { return /* binding */ HT; }
/* harmony export */ });
var HT = {
    NAME: "ht",
    SCRIPT: 'var configObject =  { "appId": "advtp",\n    "collectorHost": "dap.hindustantimes.com",\n   "pageViewRequired": true,\n    "pagePingRequired": false,\n    "syncRequired": true,\n    "userIdCookie": "_ht_clientid",\n       "pltRequired": false, \n    "existingImpressionCapture": false,\n    "existingLinkClickCapture": false,\n       "webEngageTokenRequired": false\n    };\n(function(p, l, o, w, i, k, n, g) {\nif (!p[i]) { p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || []; p.GlobalSnowplowNamespace.push(i); p[i] = function() { (p[i].q = p[i].q || []).push(arguments); }; p[i].q = p[i].q || []; n = l.createElement(o); g = l.getElementsByTagName(o)[0]; n.async = 1; n.src = w; g.parentNode.insertBefore(n, g);  n.onload = function() {     window.dapTracker = new window.dapDataTracker(); dapTracker.init(k); }}}(window, document, \'script\', "https://analytics.htmedia.in/analytics-js/tracker.js", \'snowplow\', configObject));'
};


/***/ }),

/***/ 78234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gg": function() { return /* binding */ TravelAppContext; },
/* harmony export */   "gi": function() { return /* binding */ TravelPassContext; }
/* harmony export */ });
/* unused harmony export RootContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11720);

var TravelAppContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    cookie: "",
    growthbookError: false
});
var TravelPassContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    data: {}
});
var RootContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 4789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ initialiseAckoAnalytics; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.acko-analytics/dist/index.js
var dist = __webpack_require__(94262);
;// CONCATENATED MODULE: ./src/common/utils/segment/credentials.ts
/* provided dependency */ var process = __webpack_require__(83454);
var getSegmentKey = function() {
    var host = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    try {
        if (host === null || host === void 0 ? void 0 : host.includes("localhost")) {
            return "NazJECklTzKBLmNIxOW56Co5llBHTkpY";
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === "dev" || process.env.NEXT_PUBLIC_ENVIRONMENT === "master") {
            return "NazJECklTzKBLmNIxOW56Co5llBHTkpY";
        }
        return "HAFmvakfiDMcgb9woKsT6C6hvubtp2yT";
    } catch (e) {
        return "NazJECklTzKBLmNIxOW56Co5llBHTkpY";
    }
};

// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
;// CONCATENATED MODULE: ./src/common/utils/globals/initialiseAckoAnalytics.tsx
/* eslint-disable react/no-danger */ 




var initialiseAckoAnalytics = function() {
    var ref;
    var trackerId = js_cookie/* default.get */.Z.get("trackerid") || "";
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((head_default()), {
        children: !!trackerId ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("script", {
            async: true,
            defer: true,
            type: "text/javascript",
            dangerouslySetInnerHTML: {
                __html: (0,dist.initAckoAnalytics)(trackerId, getSegmentKey(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.hostname))
            }
        }) : null
    });
};


/***/ }),

/***/ 7010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useViewport; },
/* harmony export */   "j": function() { return /* binding */ ViewportProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* eslint-disable react/jsx-no-constructed-context-values */ 

var viewportContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isMobile: true
});
function ViewportProvider(param) {
    var children = param.children, isMobileDevice = param.isMobileDevice;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isMobileDevice), isMobile = ref[0], setIsMobile = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleWindowResize = function handleWindowResize(e) {
            // Check if the media query is true
            if (e.matches) {
                // Then log the following message to the console
                // console.log("Media Query Matched!");
                setIsMobile(true);
            } else {
                // console.log("Media Query Not Matched!");
                setIsMobile(false);
            }
        };
        // Create a condition that targets viewports at least 768px wide
        var mediaQuery = window === null || window === void 0 ? void 0 : window.matchMedia("(max-width: 768px)");
        // Register event listener
        mediaQuery.addListener(handleWindowResize);
        // Initial check
        handleWindowResize(mediaQuery);
        return function() {
            return mediaQuery.removeListener(handleWindowResize);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(viewportContext.Provider, {
        value: {
            isMobile: isMobile
        },
        children: children
    });
}
var useViewport = function() {
    var isMobile = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(viewportContext).isMobile;
    return {
        isMobile: isMobile
    };
};



/***/ }),

/***/ 22701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eg": function() { return /* binding */ sendAppsFlyerEvents; },
/* harmony export */   "J6": function() { return /* binding */ sendVasEvents; },
/* harmony export */   "M2": function() { return /* binding */ sendSegmentEvent; },
/* harmony export */   "cu": function() { return /* binding */ sendTravelPassEvents; },
/* harmony export */   "j5": function() { return /* binding */ sendPartnerEvents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94262);
/* harmony import */ var _acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19659);
/* harmony import */ var src_common_custom_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49452);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31955);
/* harmony import */ var src_international_insurance_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56073);






var sendSegmentEvent = function(type, eventName, payload, userDetails) {
    var packageType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    if (true) {
        var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            product: _types__WEBPACK_IMPORTED_MODULE_1__/* .TRAVEL.PRODUCT */ .E8.PRODUCT,
            sub_product_name: _types__WEBPACK_IMPORTED_MODULE_1__/* .TRAVEL.SUB_PRODUCT_NAME */ .E8.SUB_PRODUCT_NAME,
            email: !!(userDetails === null || userDetails === void 0 ? void 0 : userDetails.email) ? userDetails === null || userDetails === void 0 ? void 0 : userDetails.email : undefined,
            phone: !!(userDetails === null || userDetails === void 0 ? void 0 : userDetails.phone) ? userDetails === null || userDetails === void 0 ? void 0 : userDetails.phone : undefined,
            journey: !!packageType ? src_international_insurance_config__WEBPACK_IMPORTED_MODULE_4__/* .PageType */ .GV[packageType] : _types__WEBPACK_IMPORTED_MODULE_1__/* .TRAVEL.JOURNEY */ .E8.JOURNEY
        }, (0,src_common_custom_hooks__WEBPACK_IMPORTED_MODULE_2__/* .getUtmParams */ .We)(), payload);
        if (type === _types__WEBPACK_IMPORTED_MODULE_1__/* .EventType.VIEW */ .tw.VIEW) (0,_acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_0__.waitForAnalyticsLoad)().then(function() {
            return (0,_acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_0__.pageEvent)(eventName, props);
        });
        if (type === _types__WEBPACK_IMPORTED_MODULE_1__/* .EventType.TAP */ .tw.TAP) (0,_acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_0__.trackEvent)(eventName, props);
    }
    return null;
};
var sendVasEvents = function(eN) {
    var eT = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _types__WEBPACK_IMPORTED_MODULE_1__/* .EventType.VIEW */ .tw.VIEW, payload = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, userDetails = arguments.length > 3 ? arguments[3] : void 0;
    var ref;
    var urlParams = new URLSearchParams(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.search);
    var bookingId = urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("booking_id");
    var orderId = urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("order_id");
    sendSegmentEvent(eT, eN, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        journey: _types__WEBPACK_IMPORTED_MODULE_1__/* .VAS.JOURNEY */ .xM.JOURNEY,
        sub_product_name: _types__WEBPACK_IMPORTED_MODULE_1__/* .VAS.SUB_PRODUCT_NAME */ .xM.SUB_PRODUCT_NAME,
        order_id: orderId || undefined,
        lead_id: bookingId || undefined,
        page: _types__WEBPACK_IMPORTED_MODULE_1__/* .VasPages.TRAVEL_VISA_ASSISTANCE_COUNTRY_SELECTION_PAGE */ .ZD.TRAVEL_VISA_ASSISTANCE_COUNTRY_SELECTION_PAGE,
        from_page: _types__WEBPACK_IMPORTED_MODULE_1__/* .VasPages.TRAVEL_HOMEPAGE */ .ZD.TRAVEL_HOMEPAGE
    }, payload), userDetails);
};
var sendTravelPassEvents = function(eN) {
    var payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, eT = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _types__WEBPACK_IMPORTED_MODULE_1__/* .EventType.VIEW */ .tw.VIEW, userDetails = arguments.length > 3 ? arguments[3] : void 0;
    sendSegmentEvent(eT, eN, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        journey: _types__WEBPACK_IMPORTED_MODULE_1__/* .DOMESTIC_PASS.JOURNEY */ .hE.JOURNEY,
        sub_product_name: _types__WEBPACK_IMPORTED_MODULE_1__/* .DOMESTIC_PASS.SUB_PRODUCT_NAME */ .hE.SUB_PRODUCT_NAME,
        from_page: _types__WEBPACK_IMPORTED_MODULE_1__/* .TravelPassPages.TRAVEL_HOMEPAGE */ .tH.TRAVEL_HOMEPAGE
    }, payload), userDetails);
};
var sendAppsFlyerEvents = function(actionName) {
    var payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if ( true && !!(window === null || window === void 0 ? void 0 : window.flutter_inappwebview)) {
        var ref, ref1;
        var urlParams = new URLSearchParams(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.search);
        var isApp = (ref1 = urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("platform")) === null || ref1 === void 0 ? void 0 : ref1.includes("app");
        if (isApp) {
            var ref2;
            var data = {
                action: _types__WEBPACK_IMPORTED_MODULE_1__/* .AppsFlyer.ACTION */ .TV.ACTION,
                action_value: {
                    destination: _types__WEBPACK_IMPORTED_MODULE_1__/* .AppsFlyer.DESTINATION */ .TV.DESTINATION,
                    event_name: actionName,
                    event_params: [
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            device_id: js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === null || js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === void 0 ? void 0 : js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("trackerid")
                        }, payload, (0,src_common_custom_hooks__WEBPACK_IMPORTED_MODULE_2__/* .getUtmParams */ .We)()), 
                    ]
                }
            };
            window === null || window === void 0 ? void 0 : (ref2 = window.flutter_inappwebview) === null || ref2 === void 0 ? void 0 : ref2.callHandler("WebViewConnect", JSON.stringify(data));
        }
    }
};
var sendPartnerEvents = function() {
    var payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if ( true && !!(window === null || window === void 0 ? void 0 : window.dapTracker)) {
        var ref, ref1;
        var source = _types__WEBPACK_IMPORTED_MODULE_1__/* .HindustanTimesPartner.source */ .Ck.source, medium = _types__WEBPACK_IMPORTED_MODULE_1__/* .HindustanTimesPartner.medium */ .Ck.medium, campaign = _types__WEBPACK_IMPORTED_MODULE_1__/* .HindustanTimesPartner.campaign */ .Ck.campaign;
        var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            source: source,
            medium: medium,
            campaign: campaign,
            type: _types__WEBPACK_IMPORTED_MODULE_1__/* .HindustanTimesPartner */ .Ck === null || _types__WEBPACK_IMPORTED_MODULE_1__/* .HindustanTimesPartner */ .Ck === void 0 ? void 0 : (ref = _types__WEBPACK_IMPORTED_MODULE_1__/* .HindustanTimesPartner.type */ .Ck.type) === null || ref === void 0 ? void 0 : ref.leadSubmit,
            trackerId: js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === null || js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === void 0 ? void 0 : js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("trackerid")
        }, payload);
        window === null || window === void 0 ? void 0 : (ref1 = window.dapTracker) === null || ref1 === void 0 ? void 0 : ref1.track(_types__WEBPACK_IMPORTED_MODULE_1__/* .HindustanTimesPartner.action */ .Ck.action, data, _types__WEBPACK_IMPORTED_MODULE_1__/* .HindustanTimesPartner.event */ .Ck.event);
    }
};


/***/ }),

/***/ 19659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C_": function() { return /* binding */ TravelPassTrackEvents; },
/* harmony export */   "Ck": function() { return /* binding */ HindustanTimesPartner; },
/* harmony export */   "E8": function() { return /* binding */ TRAVEL; },
/* harmony export */   "G$": function() { return /* binding */ TravelInsuranceTrackEvents; },
/* harmony export */   "I6": function() { return /* binding */ TravelInsurancePages; },
/* harmony export */   "TV": function() { return /* binding */ AppsFlyer; },
/* harmony export */   "Tk": function() { return /* binding */ AppsFlyerEvents; },
/* harmony export */   "ZD": function() { return /* binding */ VasPages; },
/* harmony export */   "e2": function() { return /* binding */ TravelInsuranceViewEvents; },
/* harmony export */   "hE": function() { return /* binding */ DOMESTIC_PASS; },
/* harmony export */   "iC": function() { return /* binding */ VasTrackEvents; },
/* harmony export */   "lO": function() { return /* binding */ VasViewEvents; },
/* harmony export */   "tH": function() { return /* binding */ TravelPassPages; },
/* harmony export */   "tw": function() { return /* binding */ EventType; },
/* harmony export */   "uT": function() { return /* binding */ TravelPassViewEvents; },
/* harmony export */   "xM": function() { return /* binding */ VAS; }
/* harmony export */ });
var TRAVEL = {
    PRODUCT: "travel",
    JOURNEY: "buy",
    SUB_PRODUCT_NAME: "international_travel",
    COUPON_JOURNEY: "couponing",
    SEO: "seo"
};
var TravelInsurancePages;
(function(TravelInsurancePages) {
    TravelInsurancePages["HOME"] = "home";
    TravelInsurancePages["SEO"] = "travel-insurance";
    TravelInsurancePages["TRAVEL_ALL_TRIPS"] = "travel_all_trips";
    TravelInsurancePages["INT_LANDING_PAGE"] = "int_landing_page";
    TravelInsurancePages["INT_TRAVEL_FORK_SCREEN"] = "int_travel_fork_screen";
    TravelInsurancePages["INT_TRAVEL_TRIP_INFO_SCREEN"] = "int_travel_trip_info_screen";
    TravelInsurancePages["INT_TRAVEL_BUNDLED_PLAN_SELECTION_SCREEN"] = "int_travel_bundled_plan_selection_screen";
    TravelInsurancePages["INT_TRAVEL_BUNDLED_ADDON_SCREEN"] = "int_travel_bundled_add_on_screen";
    TravelInsurancePages["INT_TRAVEL_REVIEW_SCREEN"] = "int_travel_review_screen";
    TravelInsurancePages["INT_TRAVEL_UNBUNDLED_MEDICAL_COVER"] = "int_travel_unbundled_medical_cover";
    TravelInsurancePages["INT_TRAVEL_UNBUNDLED_TRIP_COVER"] = "int_travel_unbundled_trip_cover";
    TravelInsurancePages["INT_TRAVEL_UNBUNDLED_BAGGAGE_COVER"] = "int_travel_unbundled_baggage_cover";
    TravelInsurancePages["INT_TRAVEL_ADD_COVER_NUDGE_MODAL"] = "int_travel_add_cover_nudge_modal";
    TravelInsurancePages["INT_TRAVEL_ADD_ON_NUDGE_MODAL"] = "int_travel_add_on_nudge_modal";
    TravelInsurancePages["INT_TRAVEL_MEDICAL_INSURANCE_MANDATORY_MODAL"] = "int_travel_medical_insurance_mandatory_modal";
    TravelInsurancePages["INT_TRAVEL_MEDICAL_COVER_PERSUASION_MODAL"] = "int_travel_medical_cover_persuasion_modal";
    TravelInsurancePages["INT_TRAVEL_TRIP_COVER_PERSUASION_MODAL"] = "int_travel_trip_cover_persuasion_modal";
    TravelInsurancePages["INT_TRAVEL_BAGGAGE_COVER_PERSUASION_MODAL"] = "int_travel_baggage_cover_persuasion_modal";
    TravelInsurancePages["INT_TRAVEL_POST_PAYMENT_ADD_DETAILS_SCREEN"] = "int_travel_post_payment_add_details_screen";
    TravelInsurancePages["INT_TRAVEL_POST_PAYMENT_ADD_DETAILS_NUDGE"] = "int_travel_post_payment_add_details_nudge";
    TravelInsurancePages["INT_TRAVEL_TRAVELLERS_DETAILS_SCREEN"] = "int_travel_travellers_details_screen";
    TravelInsurancePages["INT_TRAVEL_BUY_JOURNEY_SUCCESS_SCREEN"] = "int_travel_buy_journey_success_screen";
    TravelInsurancePages["INT_TRAVEL_POST_PAYMENT_DOWNLOAD_APP"] = "int_travel_post_payment_download_app";
    TravelInsurancePages["INT_TRAVEL_POST_PAYMENT_TRAVELLERS_DETAILS"] = "int_travel_post_payment_travellers_details";
    TravelInsurancePages["INT_TRAVEL_HELP_SCREEN"] = "int_travel_help_screen";
    TravelInsurancePages["INT_TRAVEL_PAYMENT_PENDING_SCREEN"] = "int_travel_payment_pending_screen";
    TravelInsurancePages["INT_TRAVEL_VERIFY_PAYMENT_SCREEN"] = "int_travel_verify_payment_screen";
    TravelInsurancePages["INT_TRAVEL_COUPON_LIST"] = "int_travel_coupon_list";
    TravelInsurancePages["INT_TRAVEL_WIDGET_HT"] = "int_travel_widget_ht";
    TravelInsurancePages["INT_TRAVEL_PAYMENT_INITIATION_LOADER"] = "int_travel_payment_initiation_loader";
    TravelInsurancePages["INT_TRAVEL_POST_PAYMENT_TRAVELLERS_DETAILS_SCREEN"] = "int_travel_post_payment_travellers_details_screen";
    TravelInsurancePages["INT_LANDING_PAGE_COVERAGE_EXPLAINER"] = "int_landing_page_coverage_explainer";
    TravelInsurancePages["INT_LANDING_PAGE_CLAIMS_EXPLAINER"] = "int_landing_page_claims_explainer";
    TravelInsurancePages["INT_LANDING_PAGE_FLEXIBILITY_SECTION"] = "int_landing_page_flexibility_section";
    TravelInsurancePages["INT_LANDING_PAGE_CUSTOMER_SUPPORT_SECTION"] = "int_landing_page_customer_support_section";
    TravelInsurancePages["INT_LANDING_PAGE_TESTIMONIAL_SECTION"] = "int_landing_page_testimonial_section";
    TravelInsurancePages["INT_LANDING_PAGE_FAQ_SECTION"] = "int_landing_page_faq_section";
    TravelInsurancePages["INT_TRIP_INFO_PAGE"] = "int_trip_info_page";
})(TravelInsurancePages || (TravelInsurancePages = {}));
var TravelInsuranceViewEvents;
(function(TravelInsuranceViewEvents) {
    TravelInsuranceViewEvents["VIEW_INT_LANDING_PAGE"] = "view_int_landing_page";
    TravelInsuranceViewEvents["VIEW_INT_TRIP_INFO_SCREEN"] = "view_int_trip_info_screen";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_FORK_SCREEN"] = "view_page_int_fork_screen";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_TRIP_INFO_SCREEN"] = "view_page_int_trip_info_screen";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_BUNDLED_PLAN"] = "view_page_int_bundled_plan";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_BUNDLED_ADD_ON"] = "view_page_int_bundled_add_on";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_REVIEW"] = "view_page_int_review";
    TravelInsuranceViewEvents["VIEW_INT_PAGE_PAYMENT_SUCCESS"] = "view_int_page_payment_success";
    TravelInsuranceViewEvents["VIEW_INT_PAGE_POST_PAYMENT_DETAILS_PENDING"] = "view_int_page_post_payment_details_pending";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_MEDICAL_COVER"] = "view_page_int_medical_cover";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_TRIP_COVER"] = "view_page_int_trip_cover";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_BAGGAGE_COVER"] = "view_page_int_baggage_cover";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_ADD_COVER_NUDGE"] = "view_modal_int_add_cover_nudge";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_ADD_ON_NUDGE"] = "view_modal_int_add_on_nudge";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_MEDICAL_INSURANCE_MANDATORY_NUDGE"] = "view_modal_int_medical_insurance_mandatory_nudge";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_COVER_PERSUASION"] = "view_modal_int_cover_persuasion";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_TRAVELLERS_DETAILS"] = "view_page_int_travellers_details";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_PRICE_UPDATE"] = "view_modal_int_price_update";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_COVERAGE_UPDATE"] = "view_modal_int_coverage_update";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_TRAVELLER_AGE_UPDATE"] = "view_modal_int_traveller_age_update";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_BUY_JOURNEY_SUCCESS"] = "view_page_int_buy_journey_success";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_POST_ISSUANCE_DOWNLOAD_APP"] = "view_page_int_post_issuance_download_app";
    TravelInsuranceViewEvents["VIEW_PAGE_PAYMENT_SUCCESS_ADD_DETAILS"] = "view_page_payment_success_add_details";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_HELP"] = "view_page_int_help";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_PAYMENT_PENDING"] = "view_page_int_payment_pending";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_ERROR"] = "view_page_int_error";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_COUPON_LIST"] = "view_page_int_coupon_list";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_COUPON_APPLIED"] = "view_page_int_coupon_applied";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_PAYMENT_INITIATION"] = "view_page_int_payment_initiation";
    TravelInsuranceViewEvents["VIEW_COUPON_NUDGE"] = "view_coupon_nudge";
    TravelInsuranceViewEvents["VIEW_COUPON_SCROLL"] = "view_coupon_scroll";
    TravelInsuranceViewEvents["VIEW_TRAVEL_WIDGET_HT"] = "view_travel_widget_ht";
    TravelInsuranceViewEvents["VIEW_PAGE_CIS_CONFIRMATION"] = "view_page_cis_confirmation";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_TRAVELLERS_DETAILS_POST_PAYMENT"] = "view_page_int_travellers_details_post_payment";
    TravelInsuranceViewEvents["VIEW_PAGE_ALL_TRIPS"] = "view_page_all_trips";
    TravelInsuranceViewEvents["VIEW_COUNTRY_DETAIL_CARD"] = "view_country_detail_card";
    TravelInsuranceViewEvents["VIEW_TRAVELLER_COUNT_CARD"] = "view_traveller_count_card";
    TravelInsuranceViewEvents["VIEW_TRIP_DURATION_CARD"] = "view_trip_duration_card";
    TravelInsuranceViewEvents["VIEW_FORK_SCREEN_CARD"] = "view_fork_screen_card";
    TravelInsuranceViewEvents["VIEW_OTHER_PLANS_COMPARISON"] = "view_other_plans_comparison";
})(TravelInsuranceViewEvents || (TravelInsuranceViewEvents = {}));
var TravelInsuranceTrackEvents;
(function(TravelInsuranceTrackEvents) {
    TravelInsuranceTrackEvents["TAP_BTN_INT_HELP"] = "tap_btn_int_help";
    TravelInsuranceTrackEvents["TAP_BTN_INT_BACK"] = "tap_btn_int_back";
    TravelInsuranceTrackEvents["TAP_BTN_INT_PRICE_BREAKUP_DETAILS"] = "tap_btn_int_price_breakup_details";
    TravelInsuranceTrackEvents["TAP_BTN_INT_EDIT_DETAILS"] = "tap_btn_int_edit_details";
    TravelInsuranceTrackEvents["TAP_BTN_INT_CONTINUE"] = "tap_btn_int_continue";
    TravelInsuranceTrackEvents["TAP_BTN_INT_BUNDLED_JOURNEY"] = "tap_btn_int_bundled_journey";
    TravelInsuranceTrackEvents["TAP_BTN_INT_UNBUNDLED_JOURNEY"] = "tap_btn_int_unbundled_journey";
    TravelInsuranceTrackEvents["TAP_BTN_INT_BUNDLED_BASIC_PLAN_BENEFITS"] = "tap_btn_int_bundled_basic_plan_benefits";
    TravelInsuranceTrackEvents["TAP_BTN_INT_BUNDLED_COMFORT_PLAN_BENEFITS"] = "tap_btn_int_bundled_comfort_plan_benefits";
    TravelInsuranceTrackEvents["TAP_BTN_INT_BUNDLED_COMPARE"] = "tap_btn_int_bundled_compare";
    TravelInsuranceTrackEvents["TAP_BTN_INT_BUNDLED_PLAN"] = "tap_btn_int_bundled_plan";
    TravelInsuranceTrackEvents["TAP_BTN_INT_SELECT_ADD_ON"] = "tap_btn_int_select_add_on";
    TravelInsuranceTrackEvents["TAP_BTN_INT_ADD_DETAILS"] = "tap_btn_int_add_details";
    TravelInsuranceTrackEvents["TAP_BTN_INT_SKIP"] = "tap_btn_int_skip";
    TravelInsuranceTrackEvents["TAP_BTN_INT_TRIP_INFO_CONTINUE"] = "tap_btn_int_trip_info_continue";
    TravelInsuranceTrackEvents["TAP_BTN_INT_SEE_BENEFITS"] = "tap_btn_int_see_benefits";
    TravelInsuranceTrackEvents["TAP_BTN_INT_ADD_ON_TOGGLE"] = "tap_btn_int_add_on_toggle";
    TravelInsuranceTrackEvents["TAP_BTN_INT_ADD_COVER"] = "tap_btn_int_add_cover";
    TravelInsuranceTrackEvents["TAP_BTN_INT_SKIP_COVER"] = "tap_btn_int_skip_cover";
    TravelInsuranceTrackEvents["TAP_BTN_INT_UPDATE_COVERAGE_AMOUNT"] = "tap_btn_int_update_coverage_amount";
    TravelInsuranceTrackEvents["TAP_BTN_INT_VIEW_POLICY"] = "tap_btn_int_view_policy";
    TravelInsuranceTrackEvents["TAP_BTN_INT_DOWNLOAD_APP"] = "tap_btn_int_download_app";
    TravelInsuranceTrackEvents["TAP_BTN_INT_COPY_NOMINEE"] = "tap_btn_int_copy_nominee";
    TravelInsuranceTrackEvents["TAP_BTN_INT_CTA"] = "tap_btn_int_cta";
    TravelInsuranceTrackEvents["TAP_BTN_INT_SUM_INSURED_UPDATE"] = "tap_btn_int_sum_insured_update";
})(TravelInsuranceTrackEvents || (TravelInsuranceTrackEvents = {}));
var VAS = {
    JOURNEY: "visa assistance",
    SUB_PRODUCT_NAME: "visa_assistance",
    SERVICE: "visa2fly",
    VAS_ROUTER_QUERY: "vasQuery",
    VAS_HISTORY_REFERER: "vasReferer",
    VAS_MY_BOOKING_REFERER: "vasMyBookingsReferer",
    VAS_RESUME_BOOKING_REFERER: "vasResumeBookingReferer"
};
var DOMESTIC_PASS = {
    JOURNEY: "buy",
    SUB_PRODUCT_NAME: "travel_pass"
};
var VasPages;
(function(VasPages) {
    VasPages["TRAVEL_HOMEPAGE"] = "travel_homepage";
    VasPages["EXPLORE_PAGE"] = "explore_page";
    VasPages["TRAVEL_VISA_POST_PAYMENT_INSURANCE_NUDGE"] = "travel_visa_post_payment_insurance_nudge";
    VasPages["VIEW_MODAL_VISA_ASSISTANCE_COUNTRY_SELECTION"] = "view_modal_visa_assistance_country_selection";
    VasPages["TRAVEL_VISA_ASSISTANCE_COUNTRY_SELECTION_PAGE"] = "travel_visa_assistance_country_selection_page";
    VasPages["TRAVEL_VISA_REDIRECTION_LOADER"] = "travel_visa_redirection_loader";
    VasPages["TRAVEL_VISA_APPLICATION_SUCCESS"] = "travel_visa_application_successful";
    VasPages["TRAVEL_VISA_PAYMENT_INITIATION_LOADER"] = "travel_visa_payment_initiation_loader";
    VasPages["TRAVEL_VISA_PAYMENT_VERIFICATION_LOADER"] = "travel_visa_payment_verification_loader";
})(VasPages || (VasPages = {}));
var VasViewEvents;
(function(VasViewEvents) {
    VasViewEvents["VIEW_PAGE_EXPLORE"] = "view_page_explore";
    VasViewEvents["VIEW_PAGE_VISA_ASSISTANCE_COUNTRY_SELECTION_PAGE"] = "view_page_visa_assistance_country_selection_page";
    VasViewEvents["VIEW_MODAL_VISA_ASSISTANCE_COUNTRY_SELECTION"] = "view_modal_visa_assistance_country_selection";
    VasViewEvents["VIEW_PAGE_VISA_REDIRECTION_LOADER"] = "view_page_visa_redirection_loader";
    VasViewEvents["VIEW_PAGE_VISA_APPLICATION_SUCCESSFUL"] = "view_page_visa_application_successful";
    VasViewEvents["VIEW_PAGE_VISA_ASSISTANCE_TRAVEL_INSURANCE_NUDGE"] = "view_page_visa_assistance_travel_insurance_nudge";
    VasViewEvents["VIEW_PAGE_VISA_ASSISTANCE_PAYMENT_INITIATION"] = "view_page_visa_assistance_payment_initiation";
    VasViewEvents["VIEW_PAGE_VISA_ASSISTANCE_PAYMENT_VERIFICATION"] = "view_page_visa_assistance_payment_verification";
})(VasViewEvents || (VasViewEvents = {}));
var VasTrackEvents;
(function(VasTrackEvents) {
    VasTrackEvents["TAP_BTN_COUNTRY_SELECTION"] = "tap_btn_country_selection";
    VasTrackEvents["TAP_BTN_INT_CONTINUE"] = "tap_btn_int_continue";
    VasTrackEvents["TAP_BTN_COUNTRY_SEARCH_FILTER"] = "tap_btn_country_search_filter";
    VasTrackEvents["TAP_BTN_COUNTRY_SEARCH"] = "tap_btn_country_search";
    VasTrackEvents["TAP_BTN_INT_SKIP"] = "tap_btn_int_skip";
})(VasTrackEvents || (VasTrackEvents = {}));
var TravelPassPages;
(function(TravelPassPages) {
    TravelPassPages["TRAVEL_HOMEPAGE"] = "travel_homepage";
    TravelPassPages["FLIGHT_PASS_LANDING_PAGE"] = "flight_pass_landing_page";
    TravelPassPages["FLIGHT_PASS_LANDING_PAGE_BUY_MODAL"] = "flight_pass_landing_page_buy_modal";
    TravelPassPages["FLIGHT_PASS_POST_PAYMENT_ADDRESS_SETUP_PAGE"] = "flight_pass_post_payment_address_setup_page";
    TravelPassPages["FLIGHT_PASS_PAYMENT_INITIATED_PAGE"] = "flight_pass_payment_initiated_page";
    TravelPassPages["FLIGHT_PASS_PAYMENT_PROCESSING_PAGE"] = "flight_pass_payment_processing_page";
    TravelPassPages["FLIGHT_PASS_PAYMENT_SUCCESS_PAGE"] = "flight_pass_payment_success_page";
    TravelPassPages["FLIGHT_PASS_PAYMENT_FAILED_PAGE"] = "flight_pass_payment_failed_page";
    TravelPassPages["FLIGHT_PASS_POLICY_INIT_PAGE"] = "flight_pass_policy_init_page";
    TravelPassPages["FLIGHT_PASS_POLICY_SUCCESS_PAGE"] = "flight_pass_policy_success_page";
    TravelPassPages["FLIGHT_PASS_SAVED_ADDRESSES_MODAL"] = "flight_pass_saved_addresses_modal";
    TravelPassPages["FLIGHT_PASS_ADD_NEW_ADDRESS_MODAL"] = "flight_pass_add_new_address_modal";
    TravelPassPages["FLIGHT_PASS_ADDRESS_SAVED_PAGE"] = "flight_pass_address_saved_page";
    TravelPassPages["FLIGHT_PASS_APP_DOWNLOAD_PAGE"] = "flight_pass_app_download_page";
})(TravelPassPages || (TravelPassPages = {}));
var TravelPassViewEvents;
(function(TravelPassViewEvents) {
    TravelPassViewEvents["VIEW_PAGE_FLIGHT_PASS_LANDING_SCREEN"] = "view_page_flight_pass_landing_screen";
    TravelPassViewEvents["VIEW_MODAL_FLIGHT_PASS_USER_DETAILS"] = "view_modal_flight_pass_user_details";
    TravelPassViewEvents["VIEW_PAGE_FLIGHT_PASS_PAYMENT_SUCCESS"] = "view_page_flight_pass_payment_success";
    TravelPassViewEvents["VIEW_PAGE_FLIGHT_PASS_ADDRESS_NUDGE"] = "view_page_flight_pass_address_nudge";
    TravelPassViewEvents["VIEW_MODAL_FLIGHT_PASS_SAVED_ADDRESSES"] = "view_modal_flight_pass_saved_addresses";
    TravelPassViewEvents["VIEW_MODAL_FLIGHT_PASS_ADD_NEW_ADDRESS"] = "view_modal_flight_pass_add_new_address";
    TravelPassViewEvents["VIEW_PAGE_FLIGHT_PASS_ADDRESS_ADDED"] = "view_page_flight_pass_address_added";
    TravelPassViewEvents["VIEW_PAGE_FLIGHT_PASS_APP_DOWNLOAD_NUDGE"] = "view_page_flight_pass_app_download_nudge";
    TravelPassViewEvents["VIEW_PAGE_FLIGHT_PASS_SET_UP_COMPLETE"] = "view_page_flight_pass_set_up_complete";
})(TravelPassViewEvents || (TravelPassViewEvents = {}));
var TravelPassTrackEvents;
(function(TravelPassTrackEvents) {
    TravelPassTrackEvents["TAP_BTN_CONTINUE"] = "tap_btn_continue";
    TravelPassTrackEvents["TAP_BTN_INT_BACK"] = "tap_btn_back";
})(TravelPassTrackEvents || (TravelPassTrackEvents = {}));
var EventType = {
    TAP: "tap",
    VIEW: "view"
};
var AppsFlyerEvents;
(function(AppsFlyerEvents) {
    AppsFlyerEvents["INT_LEAD_ENTERED"] = "int_lead_entered";
    AppsFlyerEvents["INT_QUOTE_GENERATED_BUNDLED"] = "int_quote_generated_bundled";
    AppsFlyerEvents["INT_QUOTE_GENERATED_UNBUNDLED"] = "int_quote_generated_unbundled";
    AppsFlyerEvents["INT_PAYMENT_COMPLETED"] = "int_payment_completed";
})(AppsFlyerEvents || (AppsFlyerEvents = {}));
var AppsFlyer;
(function(AppsFlyer) {
    AppsFlyer["ACTION"] = "send_event";
    AppsFlyer["DESTINATION"] = "firebase";
})(AppsFlyer || (AppsFlyer = {}));
var HindustanTimesPartner = {
    action: "advLPClick",
    type: {
        leadSubmit: "leadSubmit",
        buttonClick: "buttonClick"
    },
    campaign: "AckoTravelInsurance",
    source: "ht",
    medium: "display",
    event: "event",
    pages: {
        tripInfo: "tripInfo",
        bundledPlan: "bundledPlan",
        bundledAddon: "bundledAddon",
        unbundledPlan: "unbundledPlan",
        travellersDetails: "travellersDetails",
        checkout: "checkout",
        paymentSuccess: "paymentSuccess"
    }
};


/***/ }),

/***/ 44718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IY": function() { return /* binding */ getDomainOrigin; }
/* harmony export */ });
/* unused harmony exports getServerHostDomain, getHeaders */
/* provided dependency */ var process = __webpack_require__(83454);
var getDomainOrigin = function() {
    try {
        if (window !== undefined) {
            var ref, ref1;
            if ((window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.hostname) === "localhost") {
                return "http://localhost:9000";
            }
            return window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.origin;
        }
        return "https://www.acko.com";
    } catch (e) {
        console.error("domain error ", e);
        return "https://www.acko.com";
    }
};
var getServerHostDomain = function(host) {
    try {
        if (host === null || host === void 0 ? void 0 : host.includes("localhost")) {
            return "http://localhost:9000";
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === "dev" || process.env.NEXT_PUBLIC_ENVIRONMENT === "master") {
            return "https://www.ackodev.com";
        }
        return "https://www.acko.com";
    } catch (e) {
        return "https://www.acko.com";
    }
};
function getHeaders() {
    return {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json"
    };
}


/***/ }),

/***/ 56073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AL": function() { return /* binding */ TravelActionType; },
/* harmony export */   "Cr": function() { return /* binding */ BUNDLED_PLAN_CATEGORIES; },
/* harmony export */   "DQ": function() { return /* binding */ StateToViewEventsMapper; },
/* harmony export */   "Dt": function() { return /* binding */ APPLY_COUPON_RESPONSE_CODE; },
/* harmony export */   "Fe": function() { return /* binding */ PHONE_ERROR; },
/* harmony export */   "GV": function() { return /* binding */ PageType; },
/* harmony export */   "Hs": function() { return /* binding */ COUPON_CARD_ACTIONS; },
/* harmony export */   "KZ": function() { return /* binding */ BundledDesktopStages; },
/* harmony export */   "Nd": function() { return /* binding */ COTRAVELLER_COUPON_CODE; },
/* harmony export */   "Rj": function() { return /* binding */ StateToPersuasionMapper; },
/* harmony export */   "TX": function() { return /* binding */ internationalInsuranceUsps; },
/* harmony export */   "UW": function() { return /* binding */ APPLY_COUPON_MESSAGES; },
/* harmony export */   "Uc": function() { return /* binding */ Stages; },
/* harmony export */   "Uf": function() { return /* binding */ partnerWidgetTravellers; },
/* harmony export */   "Vn": function() { return /* binding */ StateToPageMapper; },
/* harmony export */   "WD": function() { return /* binding */ Category; },
/* harmony export */   "_o": function() { return /* binding */ PASSPORT_ERRORS; },
/* harmony export */   "rH": function() { return /* binding */ COUPON_TYPE; },
/* harmony export */   "sx": function() { return /* binding */ UnbundledDesktopStages; },
/* harmony export */   "vR": function() { return /* binding */ REQUIRED_FIELD_ERROR; },
/* harmony export */   "w$": function() { return /* binding */ NAME_ERRORS; },
/* harmony export */   "xF": function() { return /* binding */ CoverTypeList; },
/* harmony export */   "yR": function() { return /* binding */ PackageType; },
/* harmony export */   "yx": function() { return /* binding */ MISSING_FIELDS_ERROR; }
/* harmony export */ });
/* unused harmony exports CurrencyType, modalTypes, LongTermConditions, TravelPassStateToPageMapper, beemaConfig */
/* harmony import */ var src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92310);
/* harmony import */ var src_common_utils_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79354);
/* harmony import */ var src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19659);



var TravelActionType = {
    COLLECT_TRAVEL_DETAILS: "collect_travel_details",
    SHOW_STORIES: "show_stories",
    COLLECT_MEDICAL_COVER: "collect_medical_cover",
    COLLECT_PLANS: "collect_plans",
    COLLECT_ADDONS: "collect_addons",
    COLLECT_TRAVELLER_DETAILS: "collect_traveller_details",
    CHECKOUT: "checkout",
    INITIATE_PAYMENT: "initiate_payment",
    CONFIRM_PAYMENT: "confirm_payment",
    LOAD_POLICY: "load_policy",
    INITIATE_KYC: "initiate_kyc",
    TRIP_INFO: "tripInfo",
    POLICY_ACTIVATED: "policy_activated",
    COMPLIANCE_PENDING: "compliance_pending"
};
var COUPON_CARD_ACTIONS = {
    APPLY: "apply coupon",
    REMOVE: "remove coupon",
    SEE_ALL_COUPONS: "see all coupons",
    SEE_DETAILS: "see coupon details"
};
var APPLY_COUPON_RESPONSE_CODE = {
    SUCCESS: "SUCCESS",
    INVALID: "INVALID_CODE"
};
var COUPON_TYPE = "COUPON";
var COTRAVELLER_COUPON_CODE = "COTRAVELLER10";
var APPLY_COUPON_MESSAGES = {
    SUCCESS: "Coupon applied successfully!",
    INVALID: "Only one coupon can be applied!",
    DEFAULT: "Oops! This coupon is not valid",
    ERROR: "Oops! Something went wrong. Please try again."
};
var UnbundledDesktopStages = [
    "Trip info",
    "Build plan",
    "Personal details",
    "Review & Pay", 
];
var BundledDesktopStages = [
    "Trip info",
    "Choose plan",
    "Personal details",
    "Review & Pay", 
];
var Stages = [
    "Trip info",
    "Plan info",
    "Details",
    "Checkout"
];
var PackageType = {
    UNBUNDLED: "unbundled",
    BUNDLED: "bundled"
};
var CoverTypeList = [
    src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_0__/* .CoverType.MEDICAL */ .gW.MEDICAL,
    src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_0__/* .CoverType.TRIP */ .gW.TRIP,
    src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_0__/* .CoverType.BAGGAGE */ .gW.BAGGAGE, 
];
var PageType = {
    unbundled: "unbundled_only_cohort",
    bundled: "bundled_only_cohort",
    default: "buy"
};
var Category = {
    SENIOR_CITIZEN: "senior_citizen",
    ADULT: "adult",
    CHILD: "child",
    CHILDREN: "children"
};
var CurrencyType = {
    INR: "₹",
    USD: "$"
};
var modalTypes = {
    benefits: {
        label: "Medical cover benefits",
        type: "benefits"
    },
    claimAmount: {
        label: "Hospitalisation bills coverage",
        type: "claim amount"
    },
    medicalUsage: {
        label: "How to use this cover?",
        type: "medical usage"
    }
};
var LongTermConditions = (/* unused pure expression or super */ null && ([
    "Hypertension",
    "Diabetes mellitus",
    "Chronic illness",
    "Asthma",
    "Thyroid",
    "High bood pressure",
    "Epilepsy",
    "Lupus", 
]));
var PASSPORT_ERRORS = {
    DUPLICATE: "This passport number is linked to another traveller in this policy",
    EMPTY: "We need your passport number",
    INVALID: "Please enter a valid passport number"
};
var NAME_ERRORS = {
    INVALID_FORMAT: "Special characters like @, #, $ are not allowed"
};
var REQUIRED_FIELD_ERROR = "This is a required field";
var PHONE_ERROR = "Please enter a valid mobile number";
var MISSING_FIELDS_ERROR = "Please enter the required fields";
var BUNDLED_PLAN_CATEGORIES = {
    COMFORT: "comfort",
    SMART: "smart"
};
var StateToPageMapper = {
    package_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_FORK_SCREEN */ .I6.INT_TRAVEL_FORK_SCREEN,
    medical_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_UNBUNDLED_MEDICAL_COVER */ .I6.INT_TRAVEL_UNBUNDLED_MEDICAL_COVER,
    trip_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_UNBUNDLED_TRIP_COVER */ .I6.INT_TRAVEL_UNBUNDLED_TRIP_COVER,
    baggage_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_UNBUNDLED_BAGGAGE_COVER */ .I6.INT_TRAVEL_UNBUNDLED_BAGGAGE_COVER,
    bundled_addon_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_BUNDLED_ADDON_SCREEN */ .I6.INT_TRAVEL_BUNDLED_ADDON_SCREEN,
    bundled_plan_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_BUNDLED_PLAN_SELECTION_SCREEN */ .I6.INT_TRAVEL_BUNDLED_PLAN_SELECTION_SCREEN,
    journey_summary: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_REVIEW_SCREEN */ .I6.INT_TRAVEL_REVIEW_SCREEN,
    trip_details_collection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_TRIP_INFO_SCREEN */ .I6.INT_TRAVEL_TRIP_INFO_SCREEN,
    traveller_details_updation: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_TRAVELLERS_DETAILS_SCREEN */ .I6.INT_TRAVEL_TRAVELLERS_DETAILS_SCREEN,
    compliance_pending: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_POST_PAYMENT_ADD_DETAILS_SCREEN */ .I6.INT_TRAVEL_POST_PAYMENT_ADD_DETAILS_SCREEN,
    policy_activated: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_BUY_JOURNEY_SUCCESS_SCREEN */ .I6.INT_TRAVEL_BUY_JOURNEY_SUCCESS_SCREEN,
    policy_compliance_initiated: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_POST_PAYMENT_TRAVELLERS_DETAILS */ .I6.INT_TRAVEL_POST_PAYMENT_TRAVELLERS_DETAILS,
    payment_pending: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_PAYMENT_PENDING_SCREEN */ .I6.INT_TRAVEL_PAYMENT_PENDING_SCREEN,
    null: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.HOME */ .I6.HOME,
    vas: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .VasPages.TRAVEL_VISA_POST_PAYMENT_INSURANCE_NUDGE */ .ZD.TRAVEL_VISA_POST_PAYMENT_INSURANCE_NUDGE,
    seo: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.SEO */ .I6.SEO
};
var TravelPassStateToPageMapper = {
    landing_page: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_LANDING_PAGE */ .tH.FLIGHT_PASS_LANDING_PAGE,
    payment_initiated: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_PAYMENT_INITIATED_PAGE */ .tH.FLIGHT_PASS_PAYMENT_INITIATED_PAGE,
    payment_processing: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_PAYMENT_PROCESSING_PAGE */ .tH.FLIGHT_PASS_PAYMENT_PROCESSING_PAGE,
    payment_success: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_PAYMENT_SUCCESS_PAGE */ .tH.FLIGHT_PASS_PAYMENT_SUCCESS_PAGE,
    payment_failed: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_PAYMENT_FAILED_PAGE */ .tH.FLIGHT_PASS_PAYMENT_FAILED_PAGE,
    policy_init: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_POLICY_INIT_PAGE */ .tH.FLIGHT_PASS_POLICY_INIT_PAGE,
    policy_success: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_POLICY_SUCCESS_PAGE */ .tH.FLIGHT_PASS_POLICY_SUCCESS_PAGE
};
var StateToViewEventsMapper = {
    medical_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsuranceViewEvents.VIEW_PAGE_INT_MEDICAL_COVER */ .e2.VIEW_PAGE_INT_MEDICAL_COVER,
    trip_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsuranceViewEvents.VIEW_PAGE_INT_TRIP_COVER */ .e2.VIEW_PAGE_INT_TRIP_COVER,
    baggage_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsuranceViewEvents.VIEW_PAGE_INT_BAGGAGE_COVER */ .e2.VIEW_PAGE_INT_BAGGAGE_COVER,
    policy_compliance_initiated: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsuranceViewEvents.VIEW_PAGE_PAYMENT_SUCCESS_ADD_DETAILS */ .e2.VIEW_PAGE_PAYMENT_SUCCESS_ADD_DETAILS
};
var StateToPersuasionMapper = {
    medical_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_MEDICAL_COVER_PERSUASION_MODAL */ .I6.INT_TRAVEL_MEDICAL_COVER_PERSUASION_MODAL,
    trip_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_TRIP_COVER_PERSUASION_MODAL */ .I6.INT_TRAVEL_TRIP_COVER_PERSUASION_MODAL,
    baggage_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_BAGGAGE_COVER_PERSUASION_MODAL */ .I6.INT_TRAVEL_BAGGAGE_COVER_PERSUASION_MODAL
};
var partnerWidgetTravellers = [
    {
        index: 0,
        count: 0,
        category: "adult",
        title: "Adult",
        sub_title: "18-60 years"
    },
    {
        index: 1,
        count: 0,
        category: "child",
        title: "Child",
        sub_title: "below 18 years"
    },
    {
        index: 2,
        count: 0,
        category: "senior_citizen",
        title: "Senior citizen",
        sub_title: "60-70 years",
        note: {
            icon_url: "https://travel.ackoassets.com/images/info.svg",
            text: "We do not cover travellers aged 70 and above"
        }
    }, 
];
var internationalInsuranceUsps = [
    {
        image_url: src_common_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .INTERNATIONAL_DESKTOP_ASSETS.PASSPORT_ICON */ .FJ.PASSPORT_ICON,
        description: "Visa compliant policies"
    },
    {
        image_url: src_common_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .INTERNATIONAL_DESKTOP_ASSETS.CUSTOMER_SUPPORT */ .FJ.CUSTOMER_SUPPORT,
        description: "9 out 10 claims settled within 24 hours"
    },
    {
        image_url: src_common_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .INTERNATIONAL_DESKTOP_ASSETS.MONEY_ICON */ .FJ.MONEY_ICON,
        description: "Prices starting at Rs. 49/day*"
    },
    {
        image_url: src_common_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .INTERNATIONAL_DESKTOP_ASSETS.NOTES_ICON */ .FJ.NOTES_ICON,
        description: "Cancel or edit your policy on our app any time"
    }, 
];
var beemaConfig = {
    URL: "https://acko-cms.ackoassets.com/bimagyaan_quiz_ac0e2af536.png",
    QUIZ_URL: "https://www.mygov.in/"
};


/***/ }),

/***/ 3262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ PreviousPageContextProvider; },
/* harmony export */   "Dn": function() { return /* binding */ TripInfoContextProvider; },
/* harmony export */   "OV": function() { return /* binding */ PreviousPageContext; },
/* harmony export */   "ad": function() { return /* binding */ CouponsContext; },
/* harmony export */   "hF": function() { return /* binding */ PersuassionContext; },
/* harmony export */   "kO": function() { return /* binding */ PersuassionContextProvider; },
/* harmony export */   "qG": function() { return /* binding */ TripInfoContext; },
/* harmony export */   "qX": function() { return /* binding */ PostPaymentDetails; },
/* harmony export */   "w_": function() { return /* binding */ PostPaymentDetailsProvider; },
/* harmony export */   "x_": function() { return /* binding */ CouponsContextProvider; }
/* harmony export */ });
/* unused harmony export DefaultTravellers */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);


var TripInfoContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__["default"].createContext({});
var DefaultTravellers = [
    {
        index: 0,
        count: 0,
        category: "adult",
        title: "Adult",
        sub_title: "18-60 years"
    },
    {
        index: 1,
        count: 0,
        category: "child",
        title: "Child",
        sub_title: "below 18 years"
    },
    {
        index: 2,
        count: 0,
        category: "senior_citizen",
        title: "Senior citizen",
        sub_title: "60-70 years",
        note: {
            icon_url: "https://travel-uat-assets.ackodev.com/images/info.svg",
            text: "We do not cover travellers aged 70 and above"
        }
    }, 
];
var TripInfoContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        start: null,
        end: null
    }), tripDuration = ref[0], setTripDuration = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), selectedCountries = ref1[0], setSelectedCountries = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(DefaultTravellers), travellerList = ref2[0], setTravellerList = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), travellerDetails = ref3[0], setTravellerDetails = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), travellerErrors = ref4[0], setTravellerErrors = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), otherDetails = ref5[0], setOtherDetails = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), otherDetailsErrors = ref6[0], setOtherDetailsErrors = ref6[1];
    var contextValue = {
        tripDuration: {
            data: tripDuration,
            set: setTripDuration
        },
        selectedCountries: {
            data: selectedCountries,
            set: setSelectedCountries
        },
        travellers: {
            data: travellerList,
            set: setTravellerList
        },
        travellerDetails: {
            data: travellerDetails,
            set: setTravellerDetails
        },
        travellerErrors: {
            data: travellerErrors,
            set: setTravellerErrors
        },
        otherDetails: {
            data: otherDetails,
            set: setOtherDetails
        },
        otherDetailsErrors: {
            data: otherDetailsErrors,
            set: setOtherDetailsErrors
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(TripInfoContext.Provider, {
        value: contextValue,
        children: children
    });
};
var PersuassionContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__["default"].createContext({
    medical: {
        isActive: false,
        setIsActive: null
    },
    flight: {
        isActive: false,
        setIsActive: null
    },
    baggage: {
        isActive: false,
        setIsActive: null
    },
    popUpStatus: {
        isActive: false,
        setIsActive: null
    },
    atlPopUpStatus: {
        isActive: false,
        setIsActive: null
    }
});
var PersuassionContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), medical = ref[0], setMedical = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), flight = ref1[0], setFlight = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), baggage = ref2[0], setBaggage = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), popUp = ref3[0], setPopUp = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), altPopUp = ref4[0], setAtlPopUp = ref4[1];
    var contextValue = {
        medical: {
            isActive: medical,
            setIsActive: setMedical
        },
        flight: {
            isActive: flight,
            setIsActive: setFlight
        },
        baggage: {
            isActive: baggage,
            setIsActive: setBaggage
        },
        popUpStatus: {
            isActive: popUp,
            setIsActive: setPopUp
        },
        atlPopUpStatus: {
            isActive: altPopUp,
            setIsActive: setAtlPopUp
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(PersuassionContext.Provider, {
        value: contextValue,
        children: children
    });
};
var PreviousPageContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__["default"].createContext({
    previousPageName: null,
    setPreviousPageName: null
});
var PreviousPageContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), previousPageName = ref[0], setPreviousPageName = ref[1];
    var contextValue = {
        previousPageName: previousPageName,
        setPreviousPageName: setPreviousPageName
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(PreviousPageContext.Provider, {
        value: contextValue,
        children: children
    });
};
var CouponsContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__["default"].createContext({
    coupons: null,
    setCoupons: null
});
var CouponsContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), coupons = ref[0], setCoupons = ref[1];
    var contextValue = {
        coupons: coupons,
        setCoupons: setCoupons
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(CouponsContext.Provider, {
        value: contextValue,
        children: children
    });
};
var PostPaymentDetails = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__["default"].createContext({
    healthAndNomineeDetails: null,
    setHealthAndNomineeDetails: function() {}
});
var PostPaymentDetailsProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), healthAndNomineeDetails = ref[0], setHealthAndNomineeDetails = ref[1];
    var contextValue = {
        healthAndNomineeDetails: healthAndNomineeDetails,
        setHealthAndNomineeDetails: setHealthAndNomineeDetails
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(PostPaymentDetails.Provider, {
        value: contextValue,
        children: children
    });
};


/***/ }),

/***/ 60262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fontStyles":"common_fontStyles__dVXKd"};

/***/ }),

/***/ 40906:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 56421:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _warn = __webpack_require__(96425);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://developers.google.com/tag-manager/quickstart

var Snippets = {
  tags: function tags(_ref) {
    var id = _ref.id,
        events = _ref.events,
        dataLayer = _ref.dataLayer,
        dataLayerName = _ref.dataLayerName,
        preview = _ref.preview,
        auth = _ref.auth;

    var gtm_auth = '&gtm_auth=' + auth;
    var gtm_preview = '&gtm_preview=' + preview;

    if (!id) (0, _warn2.default)('GTM Id is required');

    var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';

    var script = '\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\', ' + JSON.stringify(events).slice(1, -1) + '});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';\n        j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl+\'' + gtm_auth + gtm_preview + '&gtm_cookies_win=x\';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,\'script\',\'' + dataLayerName + '\',\'' + id + '\');';

    var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);

    return {
      iframe: iframe,
      script: script,
      dataLayerVar: dataLayerVar
    };
  },
  dataLayer: function dataLayer(_dataLayer, dataLayerName) {
    return '\n      window.' + dataLayerName + ' = window.' + dataLayerName + ' || [];\n      window.' + dataLayerName + '.push(' + JSON.stringify(_dataLayer) + ')';
  }
};

module.exports = Snippets;

/***/ }),

/***/ 58676:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _Snippets = __webpack_require__(56421);

var _Snippets2 = _interopRequireDefault(_Snippets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagManager = {
  dataScript: function dataScript(dataLayer) {
    var script = document.createElement('script');
    script.innerHTML = dataLayer;
    return script;
  },
  gtm: function gtm(args) {
    var snippets = _Snippets2.default.tags(args);

    var noScript = function noScript() {
      var noscript = document.createElement('noscript');
      noscript.innerHTML = snippets.iframe;
      return noscript;
    };

    var script = function script() {
      var script = document.createElement('script');
      script.innerHTML = snippets.script;
      return script;
    };

    var dataScript = this.dataScript(snippets.dataLayerVar);

    return {
      noScript: noScript,
      script: script,
      dataScript: dataScript
    };
  },
  initialize: function initialize(_ref) {
    var gtmId = _ref.gtmId,
        _ref$events = _ref.events,
        events = _ref$events === undefined ? {} : _ref$events,
        dataLayer = _ref.dataLayer,
        _ref$dataLayerName = _ref.dataLayerName,
        dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName,
        _ref$auth = _ref.auth,
        auth = _ref$auth === undefined ? '' : _ref$auth,
        _ref$preview = _ref.preview,
        preview = _ref$preview === undefined ? '' : _ref$preview;

    var gtm = this.gtm({
      id: gtmId,
      events: events,
      dataLayer: dataLayer || undefined,
      dataLayerName: dataLayerName,
      auth: auth,
      preview: preview
    });
    if (dataLayer) document.head.appendChild(gtm.dataScript);
    document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
    document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
  },
  dataLayer: function dataLayer(_ref2) {
    var _dataLayer = _ref2.dataLayer,
        _ref2$dataLayerName = _ref2.dataLayerName,
        dataLayerName = _ref2$dataLayerName === undefined ? 'dataLayer' : _ref2$dataLayerName;

    if (window[dataLayerName]) return window[dataLayerName].push(_dataLayer);
    var snippets = _Snippets2.default.dataLayer(_dataLayer, dataLayerName);
    var dataScript = this.dataScript(snippets);
    document.head.insertBefore(dataScript, document.head.childNodes[0]);
  }
};

module.exports = TagManager;

/***/ }),

/***/ 1785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _TagManager = __webpack_require__(58676);

var _TagManager2 = _interopRequireDefault(_TagManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _TagManager2.default;

/***/ }),

/***/ 96425:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var warn = function warn(s) {
  console.warn('[react-gtm]', s);
};

exports["default"] = warn;

/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}__webpack_unused_export__=l;__webpack_unused_export__=m;__webpack_unused_export__=k;__webpack_unused_export__=h;__webpack_unused_export__=c;exports.ForwardRef=n;__webpack_unused_export__=e;__webpack_unused_export__=t;__webpack_unused_export__=r;__webpack_unused_export__=d;
__webpack_unused_export__=g;__webpack_unused_export__=f;__webpack_unused_export__=p;__webpack_unused_export__=function(a){return A(a)||z(a)===l};__webpack_unused_export__=A;__webpack_unused_export__=function(a){return z(a)===k};__webpack_unused_export__=function(a){return z(a)===h};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};__webpack_unused_export__=function(a){return z(a)===n};__webpack_unused_export__=function(a){return z(a)===e};__webpack_unused_export__=function(a){return z(a)===t};
__webpack_unused_export__=function(a){return z(a)===r};__webpack_unused_export__=function(a){return z(a)===d};__webpack_unused_export__=function(a){return z(a)===g};__webpack_unused_export__=function(a){return z(a)===f};__webpack_unused_export__=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};__webpack_unused_export__=z;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 10063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ServerStyleSheet": function() { return /* binding */ ServerStyleSheet; },
  "StyleSheetConsumer": function() { return /* binding */ StyleSheetConsumer; },
  "StyleSheetContext": function() { return /* binding */ StyleSheetContext; },
  "StyleSheetManager": function() { return /* binding */ StyleSheetManager; },
  "ThemeConsumer": function() { return /* binding */ ThemeConsumer; },
  "ThemeContext": function() { return /* binding */ ThemeContext; },
  "ThemeProvider": function() { return /* binding */ ThemeProvider; },
  "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS": function() { return /* binding */ __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS; },
  "createGlobalStyle": function() { return /* binding */ createGlobalStyle; },
  "css": function() { return /* binding */ css; },
  "default": function() { return /* binding */ styled_components_browser_esm; },
  "isStyledComponent": function() { return /* binding */ isStyledComponent; },
  "keyframes": function() { return /* binding */ keyframes; },
  "withTheme": function() { return /* binding */ withTheme; }
});

// EXTERNAL MODULE: ./node_modules/stylis/stylis.min.js
var stylis_min = __webpack_require__(21746);
var stylis_min_default = /*#__PURE__*/__webpack_require__.n(stylis_min);
// EXTERNAL MODULE: ./node_modules/stylis-rule-sheet/index.js
var stylis_rule_sheet = __webpack_require__(71427);
var stylis_rule_sheet_default = /*#__PURE__*/__webpack_require__.n(stylis_rule_sheet);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
;// CONCATENATED MODULE: ./node_modules/memoize-one/dist/memoize-one.esm.js
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ var memoize_one_esm = (memoizeOne);

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize_browser_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var is_prop_valid_browser_esm = (index);

;// CONCATENATED MODULE: ./node_modules/is-what/dist/index.esm.js
/**
 * Returns the object type of the given payload
 *
 * @param {*} payload
 * @returns {string}
 */
function getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
/**
 * Returns whether the payload is undefined
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */
function isUndefined(payload) {
    return getType(payload) === 'Undefined';
}
/**
 * Returns whether the payload is null
 *
 * @param {*} payload
 * @returns {payload is null}
 */
function isNull(payload) {
    return getType(payload) === 'Null';
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isPlainObject(payload) {
    if (getType(payload) !== 'Object')
        return false;
    return payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype;
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isObject(payload) {
    return isPlainObject(payload);
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is { [K in any]: never }}
 */
function isEmptyObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length === 0;
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isFullObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length > 0;
}
/**
 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isAnyObject(payload) {
    return getType(payload) === 'Object';
}
/**
 * Returns whether the payload is an object like a type passed in < >
 *
 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
 *
 * @template T this must be passed in < >
 * @param {*} payload
 * @returns {payload is T}
 */
function isObjectLike(payload) {
    return isAnyObject(payload);
}
/**
 * Returns whether the payload is a function (regular or async)
 *
 * @param {*} payload
 * @returns {payload is AnyFunction}
 */
function isFunction(payload) {
    return typeof payload === 'function';
}
/**
 * Returns whether the payload is an array
 *
 * @param {any} payload
 * @returns {payload is any[]}
 */
function index_esm_isArray(payload) {
    return getType(payload) === 'Array';
}
/**
 * Returns whether the payload is a an array with at least 1 item
 *
 * @param {*} payload
 * @returns {payload is any[]}
 */
function isFullArray(payload) {
    return index_esm_isArray(payload) && payload.length > 0;
}
/**
 * Returns whether the payload is a an empty array
 *
 * @param {*} payload
 * @returns {payload is []}
 */
function isEmptyArray(payload) {
    return index_esm_isArray(payload) && payload.length === 0;
}
/**
 * Returns whether the payload is a string
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isString(payload) {
    return getType(payload) === 'String';
}
/**
 * Returns whether the payload is a string, BUT returns false for ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isFullString(payload) {
    return isString(payload) && payload !== '';
}
/**
 * Returns whether the payload is ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isEmptyString(payload) {
    return payload === '';
}
/**
 * Returns whether the payload is a number (but not NaN)
 *
 * This will return `false` for `NaN`!!
 *
 * @param {*} payload
 * @returns {payload is number}
 */
function isNumber(payload) {
    return getType(payload) === 'Number' && !isNaN(payload);
}
/**
 * Returns whether the payload is a boolean
 *
 * @param {*} payload
 * @returns {payload is boolean}
 */
function isBoolean(payload) {
    return getType(payload) === 'Boolean';
}
/**
 * Returns whether the payload is a regular expression (RegExp)
 *
 * @param {*} payload
 * @returns {payload is RegExp}
 */
function isRegExp(payload) {
    return getType(payload) === 'RegExp';
}
/**
 * Returns whether the payload is a Map
 *
 * @param {*} payload
 * @returns {payload is Map<any, any>}
 */
function isMap(payload) {
    return getType(payload) === 'Map';
}
/**
 * Returns whether the payload is a WeakMap
 *
 * @param {*} payload
 * @returns {payload is WeakMap<any, any>}
 */
function isWeakMap(payload) {
    return getType(payload) === 'WeakMap';
}
/**
 * Returns whether the payload is a Set
 *
 * @param {*} payload
 * @returns {payload is Set<any>}
 */
function isSet(payload) {
    return getType(payload) === 'Set';
}
/**
 * Returns whether the payload is a WeakSet
 *
 * @param {*} payload
 * @returns {payload is WeakSet<any>}
 */
function isWeakSet(payload) {
    return getType(payload) === 'WeakSet';
}
/**
 * Returns whether the payload is a Symbol
 *
 * @param {*} payload
 * @returns {payload is symbol}
 */
function isSymbol(payload) {
    return getType(payload) === 'Symbol';
}
/**
 * Returns whether the payload is a Date, and that the date is valid
 *
 * @param {*} payload
 * @returns {payload is Date}
 */
function isDate(payload) {
    return getType(payload) === 'Date' && !isNaN(payload);
}
/**
 * Returns whether the payload is a Blob
 *
 * @param {*} payload
 * @returns {payload is Blob}
 */
function isBlob(payload) {
    return getType(payload) === 'Blob';
}
/**
 * Returns whether the payload is a File
 *
 * @param {*} payload
 * @returns {payload is File}
 */
function isFile(payload) {
    return getType(payload) === 'File';
}
/**
 * Returns whether the payload is a Promise
 *
 * @param {*} payload
 * @returns {payload is Promise<any>}
 */
function isPromise(payload) {
    return getType(payload) === 'Promise';
}
/**
 * Returns whether the payload is an Error
 *
 * @param {*} payload
 * @returns {payload is Error}
 */
function isError(payload) {
    return getType(payload) === 'Error';
}
/**
 * Returns whether the payload is literally the value `NaN` (it's `NaN` and also a `number`)
 *
 * @param {*} payload
 * @returns {payload is typeof NaN}
 */
function isNaNValue(payload) {
    return getType(payload) === 'Number' && isNaN(payload);
}
/**
 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
 *
 * @param {*} payload
 * @returns {(payload is boolean | null | undefined | number | string | symbol)}
 */
function isPrimitive(payload) {
    return (isBoolean(payload) ||
        isNull(payload) ||
        isUndefined(payload) ||
        isNumber(payload) ||
        isString(payload) ||
        isSymbol(payload));
}
/**
 * Returns true whether the payload is null or undefined
 *
 * @param {*} payload
 * @returns {(payload is null | undefined)}
 */
var isNullOrUndefined = isOneOf(isNull, isUndefined);
function isOneOf(a, b, c, d, e) {
    return function (value) {
        return a(value) || b(value) || (!!c && c(value)) || (!!d && d(value)) || (!!e && e(value));
    };
}
/**
 * Does a generic check to check that the given payload is of a given type.
 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
 * It will, however, differentiate between object and null
 *
 * @template T
 * @param {*} payload
 * @param {T} type
 * @throws {TypeError} Will throw type error if type is an invalid type
 * @returns {payload is T}
 */
function isType(payload, type) {
    if (!(type instanceof Function)) {
        throw new TypeError('Type must be a function');
    }
    if (!Object.prototype.hasOwnProperty.call(type, 'prototype')) {
        throw new TypeError('Type is not a class');
    }
    // Classes usually have names (as functions usually have names)
    var name = type.name;
    return getType(payload) === name || Boolean(payload && payload.constructor === type);
}



;// CONCATENATED MODULE: ./node_modules/merge-anything/dist/index.esm.js


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function assignProp(carry, key, newVal, originalObject) {
    var propType = originalObject.propertyIsEnumerable(key)
        ? 'enumerable'
        : 'nonenumerable';
    if (propType === 'enumerable')
        carry[key] = newVal;
    if (propType === 'nonenumerable') {
        Object.defineProperty(carry, key, {
            value: newVal,
            enumerable: false,
            writable: true,
            configurable: true
        });
    }
}
function mergeRecursively(origin, newComer, extensions) {
    // work directly on newComer if its not an object
    if (!isPlainObject(newComer)) {
        // extend merge rules
        if (extensions && index_esm_isArray(extensions)) {
            extensions.forEach(function (extend) {
                newComer = extend(origin, newComer);
            });
        }
        return newComer;
    }
    // define newObject to merge all values upon
    var newObject = {};
    if (isPlainObject(origin)) {
        var props_1 = Object.getOwnPropertyNames(origin);
        var symbols_1 = Object.getOwnPropertySymbols(origin);
        newObject = __spreadArrays(props_1, symbols_1).reduce(function (carry, key) {
            // @ts-ignore
            var targetVal = origin[key];
            if ((!isSymbol(key) && !Object.getOwnPropertyNames(newComer).includes(key)) ||
                (isSymbol(key) && !Object.getOwnPropertySymbols(newComer).includes(key))) {
                assignProp(carry, key, targetVal, origin);
            }
            return carry;
        }, {});
    }
    var props = Object.getOwnPropertyNames(newComer);
    var symbols = Object.getOwnPropertySymbols(newComer);
    var result = __spreadArrays(props, symbols).reduce(function (carry, key) {
        // re-define the origin and newComer as targetVal and newVal
        var newVal = newComer[key];
        var targetVal = (isPlainObject(origin))
            // @ts-ignore
            ? origin[key]
            : undefined;
        // extend merge rules
        if (extensions && index_esm_isArray(extensions)) {
            extensions.forEach(function (extend) {
                newVal = extend(targetVal, newVal);
            });
        }
        // When newVal is an object do the merge recursively
        if (targetVal !== undefined && isPlainObject(newVal)) {
            newVal = mergeRecursively(targetVal, newVal, extensions);
        }
        assignProp(carry, key, newVal, newComer);
        return carry;
    }, newObject);
    return result;
}
/**
 * Merge anything recursively.
 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
 * Basic types overwrite objects or other basic types.
 *
 * @param {(IConfig | any)} origin
 * @param {...any[]} newComers
 * @returns the result
 */
function merge(origin) {
    var newComers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        newComers[_i - 1] = arguments[_i];
    }
    var extensions = null;
    var base = origin;
    if (isPlainObject(origin) && origin.extensions && Object.keys(origin).length === 1) {
        base = {};
        extensions = origin.extensions;
    }
    return newComers.reduce(function (result, newComer) {
        return mergeRecursively(result, newComer, extensions);
    }, base);
}

function concatArrays(originVal, newVal) {
    if (isArray(originVal) && isArray(newVal)) {
        // concat logic
        return originVal.concat(newVal);
    }
    return newVal; // always return newVal as fallback!!
}

/* harmony default export */ var index_esm = (merge);


;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(83454);










// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var styled_components_browser_esm_isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 
function styled_components_browser_esm_isFunction(test) {
  return typeof test === 'function';
}

// 

function getComponentName(target) {
  return ( false) || target.displayName || target.name || 'Component';
}

// 
function isStatelessFunction(test) {
  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
}

// 
function isStyledComponent(target) {
  return target && typeof target.styledComponentId === 'string';
}

// 

var SC_ATTR = typeof process !== 'undefined' && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || 'data-styled';

var SC_VERSION_ATTR = 'data-styled-version';

var SC_STREAM_ATTR = 'data-styled-streamed';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (process.env.REACT_APP_SC_DISABLE_SPEEDY || process.env.SC_DISABLE_SPEEDY) || "production" !== 'production';

// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? 0 : {};

/**
 * super basic version of sprintf
 */
function format() {
  var a = arguments.length <= 0 ? undefined : arguments[0];
  var b = [];

  for (var c = 1, len = arguments.length; c < len; c += 1) {
    b.push(arguments.length <= c ? undefined : arguments[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#' + code + ' for more information.' + (interpolations.length > 0 ? ' Additional arguments: ' + interpolations.join(', ') : '')));
    } else { var _this; }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new (stylis_min_default())({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new (stylis_min_default())({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];

// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = stylis_rule_sheet_default()(function (rule) {
  parsingRules.push(rule);
});

var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;

var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
  if (
  // the first self-ref is always untouched
  offset > 0 &&
  // there should be at least two self-refs to do a replacement (.b > .b)
  string.slice(0, offset).indexOf(_selector) !== -1 &&
  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
  string.slice(offset - _selector.length, offset) !== _selector) {
    return '.' + _componentId;
  }

  return match;
};

/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */
var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
    // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
  }
};

stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

function stringifyRules(rules, selector, prefix) {
  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';

  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  // stylis has no concept of state to be passed to plugins
  // but since JS is single=threaded, we can rely on that to ensure
  // these properties stay in sync with the current stylis run
  _componentId = componentId;
  _selector = selector;
  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');

  return stylis(prefix || !selector ? '' : selector, cssStr);
}

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : 0;
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = tag.ownerDocument.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = tag.ownerDocument.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var targetDocument = document;
  if (target) targetDocument = target.ownerDocument;else if (tagEl) targetDocument = tagEl.ownerDocument;

  var el = targetDocument.createElement('style');
  el.setAttribute(SC_ATTR, '');
  el.setAttribute(SC_VERSION_ATTR, "4.4.1");

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(targetDocument.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.4.1" + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.4.1", _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return compat_module["default"].createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    // $FlowFixMe
    if (el.isConnected === false) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(targetDocument, id) {
  return targetDocument.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(el.ownerDocument, id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(el.ownerDocument, id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTag = function makeServerTag(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTag(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

var rehydrate = function rehydrate(tag, els, extracted) {
  /* add all extracted components to the new tag */
  for (var i = 0, len = extracted.length; i < len; i += 1) {
    var _extracted$i = extracted[i],
        componentId = _extracted$i.componentId,
        cssFromDOM = _extracted$i.cssFromDOM;

    var cssRules = splitByRules(cssFromDOM);
    tag.insertRules(componentId, cssRules);
  }

  /* remove old HTMLStyleElements, since they have been rehydrated */
  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
    var el = els[_i];
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {

  /* a map from ids to tags */

  /* deferred rules for a given id */

  /* this is used for not reinjecting rules via hasNameForId() */

  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */

  /* a list of tags belonging to this StyleSheet */

  /* a tag for import rules */

  /* current capacity until a new tag must be created */

  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
    if (!IS_BROWSER || this.forceServer) return this;

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.4.1" + '"]');

    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (!nodesSize) return this;

    for (var i = 0; i < nodesSize; i += 1) {
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0, name; j < elNamesSize; j += 1) {
        name = elNames[j];
        /* add rehydrated name to sheet to avoid re-adding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (!extractedSize) return this;

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);

    rehydrate(tag, els, extracted);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(tag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = tag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for createGlobalStyle to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);

    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;

    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return (0,compat_module.cloneElement)(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

// 

var Keyframes = function () {
  function Keyframes(name, rules) {
    var _this = this;

    classCallCheck(this, Keyframes);

    this.inject = function (styleSheet) {
      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
        styleSheet.inject(_this.id, _this.rules, _this.name);
      }
    };

    this.toString = function () {
      throw new StyledComponentsError(12, String(_this.name));
    };

    this.name = name;
    this.rules = rules;

    this.id = 'sc-keyframes-' + name;
  }

  Keyframes.prototype.getName = function getName() {
    return this.name;
  };

  return Keyframes;
}();

// 

/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

// 

// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
  // $FlowFixMe
  if (value == null || typeof value === 'boolean' || value === '') {
    return '';
  }

  if (typeof value === 'number' && value !== 0 && !(name in unitless_browser_esm)) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return String(value).trim();
}

// 

/**
 * It's falsish not falsy because 0 is allowed.
 */
var isFalsish = function isFalsish(chunk) {
  return chunk === undefined || chunk === null || chunk === false || chunk === '';
};

var objToCssArray = function objToCssArray(obj, prevKey) {
  var rules = [];
  var keys = Object.keys(obj);

  keys.forEach(function (key) {
    if (!isFalsish(obj[key])) {
      if (styled_components_browser_esm_isPlainObject(obj[key])) {
        rules.push.apply(rules, objToCssArray(obj[key], key));

        return rules;
      } else if (styled_components_browser_esm_isFunction(obj[key])) {
        rules.push(hyphenateStyleName(key) + ':', obj[key], ';');

        return rules;
      }
      rules.push(hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';');
    }
    return rules;
  });

  return prevKey ? [prevKey + ' {'].concat(rules, ['}']) : rules;
};

function flatten(chunk, executionContext, styleSheet) {
  if (Array.isArray(chunk)) {
    var ruleSet = [];

    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
      result = flatten(chunk[i], executionContext, styleSheet);

      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
    }

    return ruleSet;
  }

  if (isFalsish(chunk)) {
    return null;
  }

  /* Handle other components */
  if (isStyledComponent(chunk)) {
    return '.' + chunk.styledComponentId;
  }

  /* Either execute or defer the function */
  if (styled_components_browser_esm_isFunction(chunk)) {
    if (isStatelessFunction(chunk) && executionContext) {
      var _result = chunk(executionContext);

      if (false) {}

      return flatten(_result, executionContext, styleSheet);
    } else return chunk;
  }

  if (chunk instanceof Keyframes) {
    if (styleSheet) {
      chunk.inject(styleSheet);
      return chunk.getName();
    } else return chunk;
  }

  /* Handle objects */
  return styled_components_browser_esm_isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
}

// 

function css(styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (styled_components_browser_esm_isFunction(styles) || styled_components_browser_esm_isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
}

// 

function constructWithOptions(componentConstructor, tag) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  if (!(0,react_is.isValidElementType)(tag)) {
    throw new StyledComponentsError(1, String(tag));
  }

  /* This is callable directly as a template function */
  // $FlowFixMe: Not typed to avoid destructuring arguments
  var templateFunction = function templateFunction() {
    return componentConstructor(tag, options, css.apply(undefined, arguments));
  };

  /* If config methods are called, wrap up a new template function and merge options */
  templateFunction.withConfig = function (config) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
  };

  /* Modify/inject new props at runtime */
  templateFunction.attrs = function (attrs) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
    }));
  };

  return templateFunction;
}

// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }
  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;
    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;
    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }
  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

// 

function hasFunctionObjectKey(obj) {
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (var key in obj) {
    if (styled_components_browser_esm_isFunction(obj[key])) {
      return true;
    }
  }

  return false;
}

function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
      return false;
    } else if (styled_components_browser_esm_isFunction(rule) && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs.some(function (x) {
    return styled_components_browser_esm_isFunction(x) || hasFunctionObjectKey(x);
  })) return false;

  return true;
}

// 

/* combines hashStr (murmurhash) and nameGenerator for convenience */
var hasher = function hasher(str) {
  return generateAlphabeticName(murmurhash(str));
};

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */

var ComponentStyle = function () {
  function ComponentStyle(rules, attrs, componentId) {
    classCallCheck(this, ComponentStyle);

    this.rules = rules;
    this.isStatic =  true && isStaticRules(rules, attrs);
    this.componentId = componentId;

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  /*
   * Flattens a rule set into valid CSS
   * Hashes it, wraps the whole chunk in a .hash1234 {}
   * Returns the hash to be injected on render()
   * */


  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
    var isStatic = this.isStatic,
        componentId = this.componentId,
        lastClassName = this.lastClassName;

    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
      return lastClassName;
    }

    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var name = hasher(this.componentId + flatCSS.join(''));
    if (!styleSheet.hasNameForId(componentId, name)) {
      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
    }

    this.lastClassName = name;
    return name;
  };

  ComponentStyle.generateName = function generateName(str) {
    return hasher(str);
  };

  return ComponentStyle;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs(props => ({\n' + '    style: {\n' + '      background: props.background,\n' + '    },\n' + '  }))`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function styled_components_browser_esm_escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function isTag(target) {
  return typeof target === 'string' && ( false ? 0 : true);
}

// 

function generateDisplayName(target) {
  // $FlowFixMe
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

var _TYPE_STATICS;

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDerivedStateFromProps: true,
  propTypes: true,
  type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[react_is.ForwardRef] = {
  $$typeof: true,
  render: true
}, _TYPE_STATICS);

var defineProperty$1 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    _Object$getOwnPropert = Object.getOwnPropertySymbols,
    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
  return [];
} : _Object$getOwnPropert,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf = Object.getPrototypeOf,
    objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;


function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components

    var inheritedComponent = getPrototypeOf(sourceComponent);

    if (inheritedComponent && inheritedComponent !== objectPrototype) {
      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
    }

    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
    // $FlowFixMe
    getOwnPropertySymbols(sourceComponent));

    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;

    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;

    var i = keys.length;
    var descriptor = void 0;
    var key = void 0;

    // eslint-disable-next-line no-plusplus
    while (i--) {
      key = keys[i];

      if (
      // $FlowFixMe
      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
      // $FlowFixMe
      !(targetStatics && targetStatics[key])) {
        descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        if (descriptor) {
          try {
            // Avoid failures from read-only properties
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {
            /* fail silently */
          }
        }
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

// 
function isDerivedReactComponent(fn) {
  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb.apply(undefined, arguments);
    }
  };
});

// 

var ThemeContext = (0,compat_module.createContext)();

var ThemeConsumer = ThemeContext.Consumer;

/**
 * Provide a theme to an entire react component tree via context
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider(props) {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = memoize_one_esm(_this.getContext.bind(_this));
    _this.renderInner = _this.renderInner.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) return null;

    return compat_module["default"].createElement(
      ThemeContext.Consumer,
      null,
      this.renderInner
    );
  };

  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
    var context = this.getContext(this.props.theme, outerTheme);

    return compat_module["default"].createElement(
      ThemeContext.Provider,
      { value: context },
      this.props.children
    );
  };

  /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */


  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
    if (styled_components_browser_esm_isFunction(theme)) {
      var mergedTheme = theme(outerTheme);

      if (false) {}

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, outerTheme, theme);
  };

  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
    return this.getTheme(theme, outerTheme);
  };

  return ThemeProvider;
}(compat_module.Component);

// 

var CLOSING_TAG_R = /^\s*<\/[a-z]/i;

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.sealed = false;
  }

  /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */


  ServerStyleSheet.prototype.seal = function seal() {
    if (!this.sealed) {
      /* Remove sealed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.sealed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.sealed) {
      throw new StyledComponentsError(2);
    }

    return compat_module["default"].createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.seal();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.seal();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        var renderedHtml = chunk.toString();

        /* prepend style html to chunk, unless the start of the chunk is a closing tag in which case append right after that */
        if (CLOSING_TAG_R.test(renderedHtml)) {
          var endOfClosingTag = renderedHtml.indexOf('>');

          this.push(renderedHtml.slice(0, endOfClosingTag + 1) + html + renderedHtml.slice(endOfClosingTag + 1));
        } else this.push(html + renderedHtml);

        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.seal();
    });

    readableStream.on('error', function (err) {
      _this.seal();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var StyleSheetContext = (0,compat_module.createContext)();
var StyleSheetConsumer = StyleSheetContext.Consumer;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager(props) {
    classCallCheck(this, StyleSheetManager);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = memoize_one_esm(_this.getContext);
    return _this;
  }

  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
    if (sheet) {
      return sheet;
    } else if (target) {
      return new StyleSheet(target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        sheet = _props.sheet,
        target = _props.target;


    return compat_module["default"].createElement(
      StyleSheetContext.Provider,
      { value: this.getContext(sheet, target) },
       false ? 0 : children
    );
  };

  return StyleSheetManager;
}(compat_module.Component);
 false ? 0 : void 0;

// 

var identifiers = {};

/* We depend on components having unique IDs */
function generateId(_ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : styled_components_browser_esm_escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);

  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
}

// $FlowFixMe

var StyledComponent = function (_Component) {
  inherits(StyledComponent, _Component);

  function StyledComponent() {
    classCallCheck(this, StyledComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.attrs = {};

    _this.renderOuter = _this.renderOuter.bind(_this);
    _this.renderInner = _this.renderInner.bind(_this);

    if (false) {}
    return _this;
  }

  StyledComponent.prototype.render = function render() {
    return compat_module["default"].createElement(
      StyleSheetConsumer,
      null,
      this.renderOuter
    );
  };

  StyledComponent.prototype.renderOuter = function renderOuter() {
    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;

    this.styleSheet = styleSheet;

    // No need to subscribe a static component to theme changes, it won't change anything
    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();

    return compat_module["default"].createElement(
      ThemeConsumer,
      null,
      this.renderInner
    );
  };

  StyledComponent.prototype.renderInner = function renderInner(theme) {
    var _props$forwardedCompo = this.props.forwardedComponent,
        componentStyle = _props$forwardedCompo.componentStyle,
        defaultProps = _props$forwardedCompo.defaultProps,
        displayName = _props$forwardedCompo.displayName,
        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
        styledComponentId = _props$forwardedCompo.styledComponentId,
        target = _props$forwardedCompo.target;


    var generatedClassName = void 0;
    if (componentStyle.isStatic) {
      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
    } else {
      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
    }

    var elementToBeCreated = this.props.as || this.attrs.as || target;
    var isTargetTag = isTag(elementToBeCreated);

    var propsForElement = {};
    var computedProps = _extends({}, this.props, this.attrs);

    var key = void 0;
    // eslint-disable-next-line guard-for-in
    for (key in computedProps) {
      if (false) {}

      if (key === 'forwardedComponent' || key === 'as') {
        continue;
      } else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (key === 'forwardedAs') propsForElement.as = computedProps[key];else if (!isTargetTag || is_prop_valid_browser_esm(key)) {
        // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
      }
    }

    if (this.props.style && this.attrs.style) {
      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
    }

    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(' ');

    return (0,compat_module.createElement)(elementToBeCreated, propsForElement);
  };

  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
    var _this2 = this;

    var context = _extends({}, props, { theme: theme });

    if (!attrs.length) return context;

    this.attrs = {};

    attrs.forEach(function (attrDef) {
      var resolvedAttrDef = attrDef;
      var attrDefWasFn = false;
      var attr = void 0;
      var key = void 0;

      if (styled_components_browser_esm_isFunction(resolvedAttrDef)) {
        // $FlowFixMe
        resolvedAttrDef = resolvedAttrDef(context);
        attrDefWasFn = true;
      }

      /* eslint-disable guard-for-in */
      // $FlowFixMe
      for (key in resolvedAttrDef) {
        attr = resolvedAttrDef[key];

        if (!attrDefWasFn) {
          if (styled_components_browser_esm_isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
            if (false) {}

            attr = attr(context);

            if (false) {}
          }
        }

        _this2.attrs[key] = attr;
        context[key] = attr;
      }
      /* eslint-enable */
    });

    return context;
  };

  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _props$forwardedCompo2 = props.forwardedComponent,
        attrs = _props$forwardedCompo2.attrs,
        componentStyle = _props$forwardedCompo2.componentStyle,
        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names

    if (componentStyle.isStatic && !attrs.length) {
      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
    }

    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);

    if (false) {}

    return className;
  };

  return StyledComponent;
}(compat_module.Component);

function createStyledComponent(target, options, rules) {
  var isTargetStyledComp = isStyledComponent(target);
  var isClass = !isTag(target);

  var _options$displayName = options.displayName,
      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
      _options$componentId = options.componentId,
      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
      _options$ParentCompon = options.ParentComponent,
      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
      _options$attrs = options.attrs,
      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;


  var styledComponentId = options.displayName && options.componentId ? styled_components_browser_esm_escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

  // fold the underlying StyledComponent attrs up (implicit extend)
  var finalAttrs =
  // $FlowFixMe
  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;

  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
  // $FlowFixMe
  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);

  /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */
  var WrappedStyledComponent = void 0;
  var forwardRef = function forwardRef(props, ref) {
    return compat_module["default"].createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
  };
  forwardRef.displayName = displayName;
  WrappedStyledComponent = compat_module["default"].forwardRef(forwardRef);
  WrappedStyledComponent.displayName = displayName;

  // $FlowFixMe
  WrappedStyledComponent.attrs = finalAttrs;
  // $FlowFixMe
  WrappedStyledComponent.componentStyle = componentStyle;

  // $FlowFixMe
  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;

  // $FlowFixMe
  WrappedStyledComponent.styledComponentId = styledComponentId;

  // fold the underlying StyledComponent target up since we folded the styles
  // $FlowFixMe
  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;

  // $FlowFixMe
  WrappedStyledComponent.withComponent = function withComponent(tag) {
    var previousComponentId = options.componentId,
        optionsToCopy = objectWithoutProperties(options, ['componentId']);


    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : styled_components_browser_esm_escape(getComponentName(tag)));

    var newOptions = _extends({}, optionsToCopy, {
      attrs: finalAttrs,
      componentId: newComponentId,
      ParentComponent: ParentComponent
    });

    return createStyledComponent(tag, newOptions, rules);
  };

  // $FlowFixMe
  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
    get: function get$$1() {
      return this._foldedDefaultProps;
    },
    set: function set$$1(obj) {
      // $FlowFixMe
      this._foldedDefaultProps = isTargetStyledComp ? index_esm(target.defaultProps, obj) : obj;
    }
  });

  if (false) {}

  // $FlowFixMe
  WrappedStyledComponent.toString = function () {
    return '.' + WrappedStyledComponent.styledComponentId;
  };

  if (isClass) {
    hoistNonReactStatics(WrappedStyledComponent, target, {
      // all SC-specific things should not be hoisted
      attrs: true,
      componentStyle: true,
      displayName: true,
      foldedComponentIds: true,
      styledComponentId: true,
      target: true,
      withComponent: true
    });
  }

  return WrappedStyledComponent;
}

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var styled = function styled(tag) {
  return constructWithOptions(createStyledComponent, tag);
};

// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
  styled[domElement] = styled(domElement);
});

// 

var GlobalStyle = function () {
  function GlobalStyle(rules, componentId) {
    classCallCheck(this, GlobalStyle);

    this.rules = rules;
    this.componentId = componentId;
    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var css = stringifyRules(flatCSS, '');

    styleSheet.inject(this.componentId, css);
  };

  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
    var componentId = this.componentId;

    if (styleSheet.hasId(componentId)) {
      styleSheet.remove(componentId);
    }
  };

  // TODO: overwrite in-place instead of remove+create?


  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
    this.removeStyles(styleSheet);
    this.createStyles(executionContext, styleSheet);
  };

  return GlobalStyle;
}();

// 

// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) {
  window.scCGSHMRCache = {};
}

function createGlobalStyle(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));
  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
  var style = new GlobalStyle(rules, id);

  var GlobalStyleComponent = function (_React$Component) {
    inherits(GlobalStyleComponent, _React$Component);

    function GlobalStyleComponent(props) {
      classCallCheck(this, GlobalStyleComponent);

      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

      var _this$constructor = _this.constructor,
          globalStyle = _this$constructor.globalStyle,
          styledComponentId = _this$constructor.styledComponentId;


      if (IS_BROWSER) {
        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
      }

      /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */
      _this.state = {
        globalStyle: globalStyle,
        styledComponentId: styledComponentId
      };
      return _this;
    }

    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (window.scCGSHMRCache[this.state.styledComponentId]) {
        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
      }
      /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */
      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
        this.state.globalStyle.removeStyles(this.styleSheet);
      }
    };

    GlobalStyleComponent.prototype.render = function render() {
      var _this2 = this;

      if (false) {}

      return compat_module["default"].createElement(
        StyleSheetConsumer,
        null,
        function (styleSheet) {
          _this2.styleSheet = styleSheet || StyleSheet.master;

          var globalStyle = _this2.state.globalStyle;


          if (globalStyle.isStatic) {
            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);

            return null;
          } else {
            return compat_module["default"].createElement(
              ThemeConsumer,
              null,
              function (theme) {
                // $FlowFixMe
                var defaultProps = _this2.constructor.defaultProps;


                var context = _extends({}, _this2.props);

                if (typeof theme !== 'undefined') {
                  context.theme = determineTheme(_this2.props, theme, defaultProps);
                }

                globalStyle.renderStyles(context, _this2.styleSheet);

                return null;
              }
            );
          }
        }
      );
    };

    return GlobalStyleComponent;
  }(compat_module["default"].Component);

  GlobalStyleComponent.globalStyle = style;
  GlobalStyleComponent.styledComponentId = id;


  return GlobalStyleComponent;
}

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

function keyframes(strings) {
  /* Warning if you've used keyframes on React Native */
  if (false) {}

  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));

  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));

  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
}

// 

var withTheme = (function (Component$$1) {
  var WithTheme = compat_module["default"].forwardRef(function (props, ref) {
    return compat_module["default"].createElement(
      ThemeConsumer,
      null,
      function (theme) {
        // $FlowFixMe
        var defaultProps = Component$$1.defaultProps;

        var themeProp = determineTheme(props, theme, defaultProps);

        if (false) {}

        return compat_module["default"].createElement(Component$$1, _extends({}, props, { theme: themeProp, ref: ref }));
      }
    );
  });

  hoistNonReactStatics(WithTheme, Component$$1);

  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';

  return WithTheme;
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {}

/* Warning if there are several instances of styled-components */
if (false) {}

//

/* harmony default export */ var styled_components_browser_esm = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 71427:
/***/ (function(module) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		0
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),

/***/ 21746:
/***/ (function(module) {

!function(e){ true?module.exports=e(null):0}(function e(a){"use strict";var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R)}C=W}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee}n+=r}i[s]=n.replace(c,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve}ke=0}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim()}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[r++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a}return e},Te.set=Re,void 0!==a)Re(a);return Te});
//# sourceMappingURL=stylis.min.js.map

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 31955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ api; }
/* harmony export */ });
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */




/***/ }),

/***/ 97997:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HY": function() { return /* reexport */ preact_module/* Fragment */.HY; },
  "tZ": function() { return /* reexport */ u; },
  "BX": function() { return /* reexport */ u; }
});

// UNUSED EXPORTS: jsxAttr, jsxDEV, jsxEscape, jsxTemplate

// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/preact/dist/preact.module.js
var preact_module = __webpack_require__(6400);
;// CONCATENATED MODULE: ./node_modules/preact/jsx-runtime/dist/jsxRuntime.module.js
var t=/["&<]/;function n(r){if(0===r.length||!1===t.test(r))return r;for(var e=0,n=0,o="",f="";n<r.length;n++){switch(r.charCodeAt(n)){case 34:f="&quot;";break;case 38:f="&amp;";break;case 60:f="&lt;";break;default:continue}n!==e&&(o+=r.slice(e,n)),o+=f,e=n+1}return n!==e&&(o+=r.slice(e,n)),o}var o=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,f=0,i=Array.isArray;function u(e,t,n,o,i,u){var a,c,p={};for(c in t)"ref"==c?a=t[c]:p[c]=t[c];var l={type:e,props:p,key:n,ref:a,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,constructor:void 0,__v:--f,__i:-1,__u:0,__source:i,__self:u};if("function"==typeof e&&(a=e.defaultProps))for(c in a)void 0===p[c]&&(p[c]=a[c]);return preact_module/* options.vnode */.YM.vnode&&preact_module/* options.vnode */.YM.vnode(l),l}function a(r){var t=u(e,{tpl:r,exprs:[].slice.call(arguments,1)});return t.key=t.__v,t}var c={},p=/[A-Z]/g;function l(e,t){if(r.attr){var f=r.attr(e,t);if("string"==typeof f)return f}if("ref"===e||"key"===e)return"";if("style"===e&&"object"==typeof t){var i="";for(var u in t){var a=t[u];if(null!=a&&""!==a){var l="-"==u[0]?u:c[u]||(c[u]=u.replace(p,"-$&").toLowerCase()),_=";";"number"!=typeof a||l.startsWith("--")||o.test(l)||(_="px;"),i=i+l+":"+a+_}}return e+'="'+i+'"'}return null==t||!1===t||"function"==typeof t||"object"==typeof t?"":!0===t?e:e+'="'+n(t)+'"'}function _(r){if(null==r||"boolean"==typeof r||"function"==typeof r)return null;if("object"==typeof r){if(void 0===r.constructor)return r;if(i(r)){for(var e=0;e<r.length;e++)r[e]=_(r[e]);return r}}return n(""+r)}
//# sourceMappingURL=jsxRuntime.module.js.map

;// CONCATENATED MODULE: ./node_modules/preact/compat/jsx-runtime.mjs





/***/ }),

/***/ 88593:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"_args":[["axios@0.21.4","/usr/src/app"]],"_from":"axios@0.21.4","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"axios@0.21.4","name":"axios","escapedName":"axios","rawSpec":"0.21.4","saveSpec":null,"fetchSpec":"0.21.4"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz","_spec":"0.21.4","_where":"/usr/src/app","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [179], function() { return __webpack_exec__(6840), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);